export default {
  nav: {
    home: 'Home',
    articles: 'Articles',
    tech: 'Tech',
    software: 'Software',
    tutorial: 'Tutorials',
    resource: 'Resources',
    news: 'News',
    tools: 'Tools',
    about: 'About',
    sponsor: 'Membership',
    copyright: 'Copyright'
  },
  header: {
    searchPlaceholder: 'Search articles...',
    searchMobilePlaceholder: 'Search articles & tools...',
    search: 'Search',
    navLabel: 'Navigation',
    drawerHint: 'Browse · tap to navigate',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    langZh: '中文',
    langEn: 'EN'
  },
  footer: {
    nav: 'Navigate',
    about: 'About',
    copyright: 'Copyright',
    feedback: 'Feedback',
    followUs: 'Follow us',
    channelsHint: 'Hover or tap QR to enlarge',
    allRights: 'All rights reserved',
    contactEmail: 'Contact',
    qrAlt: '{label} QR code',
    qrEnlarge: 'Enlarge {label} QR',
    close: 'Close',
    wechatScan: 'Scan with WeChat',
    filingHint: 'ICP for this domain: {label}',
    filingHintEmpty: 'ICP filing'
  },
  home: {
    readMore: 'Read more',
    noCarousel: 'No featured slides yet',
    noCarouselHint: 'Enable “Show on homepage carousel” in the admin article editor',
    latest: 'Latest',
    featured: 'Featured',
    views: 'views',
    softwareTitle: 'Software picks',
    softwareSubtitle: 'Handy apps for work, study, and development',
    tutorialTitle: 'Tutorials',
    tutorialSubtitle: 'From basics to real-world projects',
    resourceTitle: 'Resources',
    resourceSubtitle: 'Learning paths, open source, and book lists',
    techTitle: 'Tech articles',
    techSubtitle: 'Frontend, engineering, and performance',
    all: 'All',
    viewMore: 'See more',
    techCatTitle: '{cat} tech articles',
    emptyCategory: 'No posts in this category',
    seoIndex: 'All articles'
  },
  articles: {
    count: '{n} articles',
    searchPrefix: 'Search: {q}',
    all: 'All',
    tech: 'Tech',
    software: 'Software',
    tutorial: 'Tutorials',
    resource: 'Resources',
    news: 'News',
    titleAll: 'All articles',
    titleTech: 'Tech articles',
    titleSoftware: 'Software picks',
    titleTutorial: 'Tutorials',
    titleResource: 'Resources',
    titleNews: 'News',
    subCategory: 'Subcategory',
    softwareCats: 'Software categories',
    tutorialCats: 'Tutorial categories',
    resourceCats: 'Resource categories',
    techCats: 'Tech categories',
    tags: 'Tags',
    empty: 'No matching articles',
    featured: 'Featured'
  },
  article: {
    home: 'Home',
    body: 'Article',
    back: 'Back',
    repostFrom: 'Reposted from: ',
    readMinutes: '~{n} min',
    readAbout: 'Length',
    views: 'views',
    copyLink: 'Copy link',
    loadingBody: 'Loading content…',
    thanks: 'Thanks for reading',
    moreType: 'More {type}',
    related: 'Related',
    loading: 'Loading article…',
    notFound: 'Article not found',
    backToList: 'Back to articles',
    translationFallback: 'No English translation yet — showing Chinese original',
    original: 'Original',
    repost: 'Repost',
    publishedAt: 'Published {date}',
    updatedAt: 'Updated {date}',
    publish: 'Published',
    update: 'Updated',
    copied: 'Link copied',
    copyFailed: 'Copy failed',
    uncategorized: 'Uncategorized',
    authorDefault: 'Author',
    recommend: 'Recommended',
    hotTags: 'Popular tags',
    thisArticle: 'This article',
    category: 'Category',
    authorBio: 'Writing about tech and sharing useful notes',
    updatedShort: '↑',
    list: 'Articles',
    copyright: {
      sectionLabel: 'Copyright',
      badgeTitle: 'Article copyright',
      thisSite: 'This site',
      prefixSiteName: 'Site name: ',
      prefixSiteUrl: 'Permanent URL: ',
      itemNetwork: 'Some articles on this site are sourced from the web for learning and discussion only. Contact us to request removal if your rights are affected.',
      itemStance: 'Resources published here do not represent this site’s position. We are not responsible for their authenticity or legality.',
      itemIllegal: 'Illegal content or speech is not allowed. Please contact us immediately if you find any so we can remove it.',
      itemLinks: 'Some resources are stored on cloud drives. If a link is broken, leave a comment and we will fix it as soon as possible.',
      itemRights: 'Copyright belongs to the authors. Do not republish without permission. Content is for learning only; if it infringes your rights, comment below and we will handle it promptly.'
    }
  },
  friendLinks: {
    title: 'Blogroll',
    subtitle: 'Sites we recommend'
  },
  share: {
    label: 'Share',
    copyTo: 'Copy link for {name}',
    preview: 'Card preview',
    collapse: 'Hide preview',
    copied: 'Copied',
    copyLink: 'Copy link',
    previewTip: 'This card style appears when the link is pasted in WeChat, QQ, and similar apps',
    wechat: 'WeChat',
    qq: 'QQ',
    weibo: 'Weibo'
  },
  lock: {
    login: 'Sign-in required',
    member: 'Members only',
    paid: 'Paid',
    public: 'Public',
    loginMsg: 'Sign in to read this section',
    memberMsg: 'Become a member to read this section',
    paidMsg: 'Unlock this section with {n} {name}',
    paidMsgPlain: 'Unlock this section with {name}',
    myPoints: 'My {name}: ',
    insufficient: '(need {n} more)',
    loginRead: 'Sign in to read',
    openMember: 'Become a member',
    unlock: 'Unlock · {n} {name}',
    getPoints: 'Get {name}',
    loginFirst: 'Sign in first'
  },
  sharePage: {
    common: {
      loading: 'Loading…',
      cannotOpen: 'Unavailable',
      cannotAccess: 'Access denied',
      loadFail: 'Failed to load',
      copied: 'Copied',
      copyFail: 'Copy failed',
      print: 'Print',
      export: 'Export / PDF',
      banned: 'Banned',
      closed: 'Closed',
      notFound: 'Unavailable',
      popup: 'Allow pop-ups and try again',
      printFail: 'Print failed — try again later',
      printOk: 'Print dialog opened — pick a printer or “Save as PDF”',
      printWx: 'If no print panel appears, tap ⋯ → “Open in browser”, then print',
      exportOk: 'Export started — choose “Save as PDF” or share in the print panel',
      exportWx: 'If no export panel appears, tap ⋯ → “Open in browser”, then Save as PDF',
      brandMark: 'Q',
      brandName: 'Qing Ping Guo',
      learn: 'Learn more',
      providedBy: 'This page is provided by wyqii.cn',
      providedBySystem: 'Powered by wyqii.cn'
    },
    nav: {
      title: 'Choose a map',
      close: 'Close',
      opening: 'Opening…',
      open: 'Open',
      copyAddr: 'Copy address',
      cancel: 'Cancel',
      hintWx: 'In WeChat, use WeChat Maps first — you can switch to Amap or Tencent Maps from there',
      hintApp: 'Opens an installed map app directly — no download page',
      wechat: 'WeChat Maps',
      wechatDesc: 'Recommended · pick Amap or Tencent Maps inside WeChat',
      amap: 'Amap',
      amapDesc: 'Open Amap for navigation',
      amapWx: 'Try Amap (may be limited in WeChat)',
      amapAddr: 'Open Amap by address',
      tencent: 'Tencent Maps',
      tencentDesc: 'Open Tencent Maps',
      tencentWx: 'Open via Tencent Maps link',
      tencentAddr: 'Open Tencent Maps by address',
      apple: 'Apple Maps',
      appleDesc: 'System maps',
      failWx: 'Could not open {name}. Use WeChat Maps above instead',
      failApp: 'Could not open {name}. Make sure the app is installed',
      openFail: 'Failed to open',
      addrCopied: 'Address copied',
      destination: 'Destination'
    },
    doc: {
      altH5: 'Access QR code',
      altMini: 'Mini-program code',
      altVerify: 'Verify',
      verifyTip: 'Scan to check this was issued on this site',
      scanVerify: 'Scan to verify',
      siteIssued: 'Issued on this site',
      siteIssuedNo: 'Issued on this site · No. check',
      sealMark: '(Seal)',
      amountLower: 'Amount (figures)',
      amountUpper: 'Amount (words)',
      orgInfo: 'Organization',
      noLines: 'No line items',
      amountCn: 'In words',
      idNoOf: 'ID: {v}',
      emptyBody: '(No body yet)',
      clauseLabel: 'Clauses',
      bothSigned: 'Both parties signed',
      signA: 'Party A signature',
      signB: 'Party B signature',
      altSignA: 'Party A signature',
      altSignB: 'Party B signature',
      operatorOf: 'Handled by: {name}',
      issueDateOf: 'Issued: {d}',
      contactOf: 'Contact: {v}',
      addressOf: 'Address: {v}',
      signPlaceOf: 'Signed at: {v}',
      signerOf: 'Signed by: {name}',
      dateOf: 'Date: {d}'
    },
    wifi: {
      cannotOpen: 'Cannot open share',
      goMake: 'Create a Wi‑Fi link',
      eyebrow: 'Scan to connect',
      desc: 'Scan the mini-program code below with WeChat to connect to this network',
      altQr: 'Wi‑Fi mini-program code',
      qrUnavailable: 'Mini-program code unavailable',
      copyOpen: 'Copy open link',
      copyText: 'Copy share text',
      dlQr: 'Download mini code',
      tip: 'Send the open link to friends. After they open this page in a browser or WeChat, they can scan into the mini program to connect.',
      providedByPrefix: 'This page is provided by',
      providedBySuffix: '',
      needCode: 'Missing share code',
      missing: 'Share not found',
      linkCopied: 'Open link copied',
      textCopied: 'Share text copied'
    },
    receipt: {
      badge: 'E-receipt',
      blockedTitle: 'Loading blocked',
      blockMsg: 'Developer tools or an unusual debug environment was detected. Close the console and refresh to view this receipt.',
      titleRestricted: 'Access restricted',
      notFoundDesc: 'Receipt not found or deleted',
      bannedDesc: 'This receipt was banned by an admin',
      closedDesc: 'The creator closed access'
    },
    quote: {
      badge: 'E-quotation',
      verify: 'Verify number',
      notFoundDesc: 'Quote not found or deleted',
      bannedDesc: 'This quote was banned by an admin',
      closedDesc: 'The creator closed access'
    },
    contract: {
      badge: 'E-contract',
      goSign: 'Sign',
      signTitle: 'Handwritten signature',
      signLead: 'Choose a party, enter your name, sign below, then submit',
      partyA: 'Party A · {name}',
      partyB: 'Party B · {name}',
      pending: 'Pending',
      signerName: 'Signer name',
      phName: 'Enter your real name',
      canvasHint: 'Sign in this area',
      clear: 'Clear',
      submitting: 'Submitting…',
      confirmSign: 'Confirm signature',
      bothDone: 'Both parties have signed',
      needName: 'Enter the signer name',
      needInk: 'Please sign first',
      signOk: 'Signed',
      signFail: 'Sign failed',
      notFoundDesc: 'Contract not found or deleted',
      bannedDesc: 'This contract was banned by an admin',
      closedDesc: 'The creator closed access',
      pendingReview: 'Under review',
      pendingReviewDesc: 'The contract is under review — try again later'
    },
    card: {
      make: 'Create card',
      unavailable: 'Card unavailable',
      goMake: 'Create a business card',
      altMap: 'Location map',
      locBadge: 'Location',
      mapNav: 'Map navigation',
      goNav: 'Navigate',
      brandDefault: 'Qing Ping Guo business card',
      brandSub: 'Make one like this — free',
      coordSet: 'Coordinates set',
      needCode: 'Missing card code',
      missing: 'Card not found',
      titleSuffix: '{name} · Qing Ping Guo',
      defaultTitle: 'Business card',
      wechatCopied: 'WeChat ID copied',
      scanWechat: 'Long-press the QR on the card to add WeChat',
      wechatLine: 'WeChat {id}',
      infoCopied: 'Card info copied',
      actCall: 'Call',
      actSms: 'SMS',
      actWechat: 'WeChat',
      actMap: 'Navigate',
      actEmail: 'Email',
      actCopy: 'Copy',
      actWebsite: 'Website',
      phName: 'Name',
      scanAdd: 'Scan to add WeChat',
      altWechatQr: 'WeChat QR',
      initial: 'N'
    },
    comment: {
      opening: 'Opening comment…',
      unavailable: 'Comment unavailable',
      dear: 'Dear student',
      student: 'Student',
      insight: 'How your teacher sees you',
      bodyOf: '{type} body',
      empty: 'No comment yet — check back later.',
      typeLabel: 'Type',
      date: 'Date',
      regards: 'Yours',
      teacher: 'Homeroom teacher',
      wishLabel: 'Note',
      typeFinal: 'Final',
      typeMid: 'Midterm',
      typeTerm: 'Term',
      typeDaily: 'Daily',
      commentWord: 'Comment',
      titleFallback: 'Student comment',
      initial: 'S',
      missing: 'Comment not found or sharing is closed',
      wishFinal: 'Take this term’s bright spots home',
      hintFinal: 'As the term ends, bring home what you gained and look ahead.',
      wishMid: 'Keep shining through the second half',
      hintMid: 'Halfway there — keep going; the rest will be even better.',
      wishTerm: 'This term’s growth was seen',
      hintTerm: 'A full term of growth deserves to be noticed.',
      wishDaily: 'Every small step forward',
      hintDaily: 'Every bit of daily progress is noticed.'
    },
    receiptCheck: {
      badge: 'Issued here · scan to verify',
      title: 'Receipt verification',
      lead: 'Enter the receipt number (No.) to check it was issued by this site.',
      receiptNo: 'Receipt No.',
      phNo: 'e.g. R20260731XXXXXX',
      checking: 'Checking…',
      checkNow: 'Verify now',
      issuer: 'Payee',
      payer: 'Payer',
      amount: 'Amount',
      date: 'Date',
      purpose: 'Purpose',
      provider: 'Issued by',
      needNo: 'Enter a receipt number',
      failLabel: 'Verification failed',
      retry: 'Please try again later'
    },
    quoteCheck: {
      badge: 'Issued here · scan to verify',
      title: 'Quote verification',
      lead: 'Enter the quote number to check it was issued by this site.',
      quoteNo: 'Quote No.',
      quoteNoField: 'Quote number',
      phNo: 'e.g. Q20260804XXXXXX',
      checking: 'Checking…',
      checkNow: 'Verify now',
      summary: 'Summary',
      defaultTitle: 'Quotation',
      total: 'Total',
      seller: 'From',
      buyer: 'Client',
      quoteDate: 'Quote date',
      validUntil: 'Valid until',
      itemCount: 'Line items',
      amountCn: 'Amount in words',
      provider: 'Issued by',
      footTip: 'Verification confirms the issued record for this number. Also check amount, client, and issuer on the paper or PDF.',
      needNo: 'Enter a quote number',
      failLabel: 'Verification failed',
      retry: 'Please try again later'
    },
    gift: {
      readonly: 'Read-only',
      make: 'Create gift book',
      unavailable: 'Share unavailable',
      goMake: 'Create a gift book',
      protected: 'Protected gift book',
      defaultTitle: 'Gift book share',
      pwdLead: 'Enter the access password to view. No sign-in required. Read-only.',
      phPwd: 'Access password',
      pwdHint: 'After unlocking, this device won’t ask again for 24 hours',
      viewBook: 'View gift book',
      backList: 'Back to list',
      readonlyOf: 'Read-only · {title}',
      stats: '{n} entries · ¥{amt} total',
      asc: 'Oldest first',
      desc: 'Newest first',
      phSearch: 'Search name / note',
      search: 'Search',
      moreFilter: 'More filters',
      amountMin: 'Amount ≥',
      amountMax: 'Amount ≤',
      clear: 'Clear',
      apply: 'Apply',
      colName: 'Name',
      colAmt: 'Amount',
      colRemark: 'Note',
      empty: 'No matching records',
      crossSearch: 'Search all books · read-only',
      matchN: '{n} matches',
      hitBooks: '{n} books',
      phSearchMore: 'Continue searching name / note',
      heroEyebrow: 'Gifts · easy to review',
      booksN: '{n} books',
      entriesN: '{n} entries',
      total: 'Total ¥{amt}',
      listHint: 'Search all books, or open one for details. Read-only.',
      phSearchAll: 'Search all books: name / note',
      openMini: 'Open in mini program',
      openMiniTip: 'WeChat can open the mini program directly; or scan the same share.',
      openMiniBtn: 'Open mini program',
      copyPage: 'Copy web link',
      pageCopied: 'Web link copied',
      altQr: 'Mini-program code',
      wechatScan: 'Scan with WeChat',
      bookStats: '{n} entries · ¥{amt}',
      needKeyword: 'Enter a search keyword',
      badPwd: 'Incorrect password',
      searchFail: 'Search failed',
      missing: 'Share not found or expired',
      noBook: 'Gift book not found'
    },
    order: {
      loading: 'Loading menu…',
      tableOrder: '{name} · table order',
      eMenu: 'Digital menu',
      myOrders: 'My orders',
      cannotOrder: 'Ordering is unavailable',
      dineIn: 'Dine-in',
      takeaway: 'Takeaway',
      pickTable: 'Choose a table',
      noTables: 'No tables — ask the shop',
      addrTitle: 'Delivery info',
      collapse: 'Hide',
      edit: 'Edit',
      fill: 'Fill in',
      phContact: 'Contact',
      phPhone: 'Mobile',
      phAddr: 'Address',
      phDetail: 'Apt / unit (optional)',
      saveAddr: 'Save address',
      cart: '{n} items · ¥{amt}',
      phRemark: 'Note (optional)',
      submitting: 'Submitting…',
      submit: 'Place order',
      success: 'Order placed',
      orderNo: 'No. {no}',
      total: 'Total ¥{amt}',
      viewMy: 'View my orders',
      continue: 'Order more',
      myTitle: 'My orders',
      refresh: 'Refresh',
      historyTip: 'Orders from this device only',
      emptyOrders: 'No orders yet',
      orderedAt: 'Placed {t}',
      updatedAt: 'Updated {t}',
      remarkOf: 'Note: {r}',
      close: 'Close',
      open: 'Open',
      paused: 'Paused',
      recCat: 'Featured',
      loadOrdersFail: 'Failed to load orders',
      needAddr: 'Enter contact, phone, and address',
      addrSaved: 'Address saved on this device',
      pickDish: 'Pick a dish first',
      pickTableWarn: 'Choose a table',
      needShip: 'Enter delivery info',
      orderOk: 'Order placed',
      orderFail: 'Order failed',
      notFoundDesc: 'Menu not found or deleted',
      bannedDesc: 'This menu is not accessible',
      disabled: 'Disabled',
      disabledDesc: 'The shop disabled this menu',
      closed: 'Closed',
      closedDesc: 'The shop is closed',
      offHours: 'Outside hours',
      offHoursDesc: 'Not within opening hours'
    },
    electric: {
      mark: 'E',
      brand: 'Electric records',
      make: 'Create electric room',
      unavailable: 'Share unavailable',
      protected: 'Protected {type}',
      pwdLead: 'Enter the password to view readings. Read-only.',
      phPwd: 'Access password',
      pwdHint: 'After unlocking, this device won’t ask again for 30 days',
      view: 'View',
      overview: 'Room overview · read-only',
      price: '{n} per kWh',
      months: 'Last {n} months',
      main: 'Main meter',
      sub: 'Sub-meter',
      priceShort: '{n}/kWh',
      compare: 'Period comparison',
      noData: 'No readings yet',
      vsLast: 'vs last month',
      subTotal: 'Sub-meters total',
      diff: 'Difference',
      reading: 'Reading {n}',
      usage: 'Usage {n}',
      mainPreview: 'Main meter',
      tenantMeter: 'Tenant meter',
      readonly: 'Read-only',
      ofRoom: 'Room: {name}',
      monthsOf: 'Last {n} months',
      colPeriod: 'Period',
      colReading: 'Reading',
      colUsage: 'Usage',
      colCost: 'Cost',
      colTime: 'Time',
      colRemark: 'Note',
      empty: 'No records',
      foot: 'Provided by wyqii.cn electric records',
      typeMeter: 'Meter',
      typeRoom: 'Room',
      titleSuffix: '{name} · Electric records',
      meterSuffix: '{name} · Meter',
      badPwd: 'Wrong password'
    },
    task: {
      mark: 'T',
      brand: 'Task submit',
      make: 'Create task board',
      login: 'Sign in',
      unavailable: 'Share unavailable',
      protected: 'Protected board · {role}',
      pwdLead: 'Enter the access password to continue',
      phPwd: 'Access password',
      pwdHint: 'After unlocking, this device won’t ask again for 30 days',
      enter: 'Enter',
      invite: '{role} · collaborate',
      defaultDesc: 'Collaboration board',
      phSearch: 'Search tasks: title, notes, submitter, assignee…',
      clear: 'Clear',
      submitTitle: 'Submit a task',
      submitTip: 'Title is enough; images optional (auto WebP)',
      logged: 'Signed in · {name}',
      guestOk: 'Guests can submit',
      needLoginTag: 'Sign-in required',
      needLoginStrong: 'This board requires sign-in to submit',
      needLoginP: 'Sign in to submit tasks and images. Your account is the submitter.',
      loginNow: 'Sign in now',
      boardTasks: 'Board tasks',
      unlimited: 'Unlimited',
      remain: ' · {n} left',
      unlimitedHard: ' · unlimited (system cap {n})',
      quotaFull: 'Task limit reached — cannot submit',
      title: 'Title',
      phTitle: 'e.g. Replace homepage banner',
      desc: 'Notes (optional)',
      phDesc: 'Details, acceptance criteria…',
      nick: 'Your nickname',
      phNick: 'So the assignee can reach you',
      photos: 'Images (optional, max 9)',
      uploadHint: 'Click to upload or Ctrl+V to paste · auto WebP',
      uploading: 'Uploading…',
      loginToSubmit: 'Have an account? Sign in to submit',
      list: 'Tasks',
      showing: 'Showing {a} / {b}',
      noMatch: 'No matching tasks',
      empty: 'No tasks yet',
      meta: 'From {s} · Assignee {a}',
      unassigned: 'Unassigned',
      rejectOf: 'Rejected: {r}',
      doing: 'In progress',
      complete: 'Done',
      reject: 'Reject',
      loggedUser: 'Signed in',
      roleView: 'View only',
      roleSubmit: 'Can submit',
      roleExec: 'Can execute',
      roleAccess: 'Access',
      all: 'All',
      stPending: 'Pending',
      stDoing: 'In progress',
      stDone: 'Done',
      stRejected: 'Rejected',
      loginFirst: 'Sign in first to {reason}',
      needCode: 'Missing share code',
      defaultBoard: 'Task board',
      titleSuffix: '{name} · Tasks',
      badPwd: 'Wrong password',
      loginUpload: 'upload images',
      quotaWarn: 'Task limit reached',
      max9: 'Up to 9 images',
      uploadFail: 'Upload failed',
      imgAdded: 'Image added (WebP)',
      needTitle: 'Enter a title',
      needNick: 'Enter a nickname, or sign in',
      submitted: 'Submitted',
      submitFail: 'Submit failed',
      updated: 'Updated',
      fail: 'Failed',
      rejectPrompt: 'Enter a reject reason',
      rejectTitle: 'Reject task',
      rejectPreset: 'Not feasible',
      rejectPh: 'e.g. not feasible / needs delay'
    },
    live: {
      iframeTitle: 'Live QR page',
      protected: 'Protected live QR',
      pwdLead: 'Enter the access password to continue',
      phPwd: 'Access password',
      pwdHint: 'After unlocking, this device won’t ask again for 24 hours',
      view: 'View content',
      notFoundDesc: 'Live QR not found or deleted',
      bannedDesc: 'This live QR was banned by an admin',
      pending: 'Under review',
      pendingDesc: 'Available after review',
      rejected: 'Rejected',
      rejectedDesc: 'Did not pass review',
      closedDesc: 'The creator closed access',
      notStarted: 'Not started',
      notStartedDesc: 'Not yet available',
      expired: 'Expired',
      expiredDesc: 'Access window ended',
      needPwd: 'Password required',
      needPwdDesc: 'Enter the access password',
      needPwdWarn: 'Enter a password',
      badPwd: 'Incorrect password',
      verifyFail: 'Verification failed'
    }
  },
  tools: {
    badge: 'Online toolkit',
    heroTitle: 'Practical tools, ready to use',
    heroDesc: 'PDF, images, barcodes, webmaster, life, networking, and config conversion — processed locally in your browser, fast and private.',
    countTools: 'tools',
    countCats: 'categories',
    localPct: 'local',
    searchPlaceholder: 'Search tools, e.g. PDF merge, QR code…',
    frequent: 'Frequent tools',
    frequentHintLogin: 'Synced to your account by usage; pin to keep on top',
    frequentHintGuest: 'Stored on this device; sign in to sync across devices',
    clear: 'Clear',
    clearConfirm: 'Clear frequent tools history?',
    cleared: 'Cleared',
    pin: 'Pin',
    unpin: 'Unpin',
    removeFrequent: 'Remove',
    frequentEmpty: 'Tools you use will appear here for quick access',
    all: 'All',
    toolsInCat: '{n} tools',
    empty: 'No matching tools',
    notFound: 'Tool not found',
    backHub: 'Back to toolkit',
    allTools: 'All tools',
    loginRequired: 'Sign in to use',
    loginTip: 'This tool requires an account. After signing in, files are processed locally in your browser.',
    loginNow: 'Sign in',
    tip: 'Notice',
    onlineTool: 'Online tool',
    ui: {
      drop: 'Click or drop files here',
      localHint: 'Processed locally — files are not uploaded',
      localHintMax: 'Processed locally; max {n}MB per image',
      fileTooLarge: 'File must be under {n}MB',
      process: 'Process',
      convert: 'Convert',
      copy: 'Copy',
      copied: 'Copied',
      copyManual: 'Please copy manually',
      paste: 'Paste',
      pasted: 'Pasted',
      clipboardFail: 'Could not read the clipboard',
      copyFail: 'Copy failed',
      input: 'Input',
      output: 'Output',
      encode: 'Encode',
      decode: 'Decode',
      escape: 'Escape',
      unescape: 'Unescape',
      format: 'Beautify',
      minify: 'Minify',
      lookup: 'Look up',
      yes: 'Yes',
      no: 'No',
      swapIo: 'Swap',
      result: 'Result…',
      optional: 'Optional',
      required: 'Required',
      done: 'Done',
      fail: 'Processing failed',
      generate: 'Generate',
      genOk: 'Generated',
      genFail: 'Generation failed',
      recognize: 'Decode',
      recOk: 'Decoded',
      download: 'Download',
      downloadImage: 'Download image',
      preview: 'Preview',
      empty: 'Leave empty',
      refresh: 'Refresh',
      search: 'Search',
      clear: 'Clear',
      share: 'Share',
      export: 'Export',
      manage: 'Manage',
      add: 'Add',
      close: 'Close',
      create: 'Create',
      action: 'Actions',
      remark: 'Note',
      loadFail: 'Failed to load',
      saveFail: 'Save failed',
      deleted: 'Deleted',
      updated: 'Updated',
      created: 'Created',
      saved: 'Saved',
      exportFail: 'Export failed',
      opFail: 'Operation failed',
      hasPwd: 'Password',
      public: 'Public',
      quotaAdmin: 'Set by admin',
      needName: 'Please enter a name',
      unlimited: 'Unlimited',
      enabled: 'Enabled',
      disabled: 'Disabled',
      memberOnly: 'Members only',
      token: 'Token',
      rotateToken: 'Rotate token',
      enableToken: 'Enable and generate token',
      closeApi: 'Turn off API',
      openApi: 'Open API'
    },
    pdf: {
      config: 'Options',
      dropPdf: 'Upload a PDF',
      dropPdfs: 'Upload multiple PDFs',
      dropImages: 'Upload one or more images',
      dropFirst: 'Upload the first PDF',
      dropSecondAlt: 'Upload the second PDF (interleave)',
      dropInsert: 'Upload the PDF to insert',
      dropLogo: 'Upload watermark / logo image',
      dropSign: 'Upload signature image (optional)',
      splitRange: 'Split ranges (e.g. 1-3;5;8-10)',
      splitPh: 'Empty = entire document as one file',
      deletePages: 'Pages to delete (e.g. 1-3,5,8-10)',
      exportFormat: 'Export format',
      page: 'Page',
      signText: 'Signature text',
      rotateAll: 'Rotate entire document',
      rotateHint: 'Or set rotation per page in the thumbnails below',
      pageN: 'Page {n}',
      angle: 'Angle',
      reorderHint: 'Drag to reorder (or use the arrows)',
      origPage: '#{i} · original page {n}',
      insertAfter: 'Insert after page (0 = beginning)',
      marginTop: 'Top margin (pt)',
      marginBottom: 'Bottom margin (pt)',
      marginLeft: 'Left margin (pt)',
      marginRight: 'Right margin (pt)',
      headerH: 'Header height (pt)',
      footerH: 'Footer height (pt)',
      paper: 'Paper size',
      nup: 'N-up',
      wmText: 'Watermark text',
      wmPh: 'Multiple lines supported',
      fontSize: 'Font size',
      opacity: 'Opacity',
      rotate: 'Angle',
      color: 'Color',
      mode: 'Mode',
      tile: 'Tile',
      center: 'Center',
      qrContent: 'QR content',
      qrPh: 'URL or text',
      scale: 'Scale',
      position: 'Position',
      posCenter: 'Center',
      posBR: 'Bottom right',
      posTR: 'Top right',
      posBL: 'Bottom left',
      posBC: 'Bottom center',
      posBR2: 'Bottom right',
      posTC: 'Top center',
      pageStart: 'Start number',
      template: 'Template',
      header: 'Header',
      footer: 'Footer',
      metaTitle: 'Title',
      metaAuthor: 'Author',
      metaSubject: 'Subject',
      metaKeywords: 'Keywords',
      metaCreator: 'Creator',
      metaProducer: 'Producer',
      gray: 'Grayscale',
      bw: 'Black & white',
      format: 'Format',
      extract: 'Extracted text',
      links: 'Links ({n})',
      loadMeta: 'Read current metadata',
      preview40: 'Previewing first 40 of {n} pages; processing still applies to all',
      metaLoaded: 'Metadata loaded ({n} pages)',
      readFail: 'Failed to read',
      pdfReady: 'PDF generated — download started',
      mergeOk: 'Merged',
      altMergeOk: 'Interleaved merge complete',
      exportedImgs: 'Exported {n} images',
      splitOk: 'Split into {n} files',
      compressOk: 'Compressed (basic in-browser)',
      optimizeOk: 'Optimized',
      unlockOk: 'Tried to lift restrictions and resaved',
      deletedPages: 'Deleted {n} pages',
      blankOk: 'Removed blank pages: {pages}',
      rotateOk: 'Rotated',
      reverseOk: 'Reversed',
      reorderOk: 'Reordered',
      reorderPartial: 'Reordered first {n} pages; remaining pages keep original order',
      waitThumbs: 'Wait for thumbnails before reordering',
      needPages: 'Specify pages to delete',
      noImages: 'No embedded images found',
      noLinks: 'No hyperlinks found',
      unknown: 'Unknown tool',
      insertOk: 'Inserted',
      cropOk: 'Cropped',
      hfOk: 'Header/footer area cropped by margins',
      sizeOk: 'Page size unified',
      nupOk: 'N-up layout applied',
      wmTextOk: 'Text watermark added',
      wmLogoOk: 'Logo watermark added',
      wmQrOk: 'QR watermark added',
      pageNumOk: 'Page numbers added',
      hfAddOk: 'Header and footer added',
      textOk: 'Text extracted and downloaded',
      extractImgs: 'Extracted {n} images',
      extractLinks: 'Extracted {n} links',
      metaSaved: 'Metadata saved',
      metaCleared: 'Metadata cleared',
      grayOk: 'Grayscale / B&W conversion done',
      longOk: 'Long image exported',
      signOk: 'Signed PDF exported',
      actions: {
        'pdf-to-images': 'Export images',
        'images-to-pdf': 'Create PDF',
        'pdf-split': 'Split PDF',
        'pdf-merge': 'Merge PDFs',
        'pdf-merge-alt': 'Interleave',
        'pdf-compress': 'Compress PDF',
        'pdf-optimize': 'Optimize & download',
        'pdf-delete-pages': 'Delete & export',
        'pdf-blank-pages': 'Remove blank pages',
        'pdf-rotate': 'Rotate & download',
        'pdf-reverse': 'Reverse & download',
        'pdf-reorder': 'Export new order',
        'pdf-insert': 'Insert & download',
        'pdf-crop': 'Crop & download',
        'pdf-page-size': 'Unify size & download',
        'pdf-nup': 'N-up & download',
        'pdf-watermark': 'Add watermark',
        'pdf-logo-watermark': 'Add logo watermark',
        'pdf-qr-watermark': 'Add QR watermark',
        'pdf-page-number': 'Add page numbers',
        'pdf-header-footer': 'Add header/footer',
        'pdf-remove-hf': 'Crop & download',
        'pdf-extract-text': 'Extract text',
        'pdf-extract-images': 'Extract images',
        'pdf-extract-links': 'Extract links',
        'pdf-metadata': 'Save metadata',
        'pdf-clear-metadata': 'Clear & download',
        'pdf-grayscale': 'Convert & download',
        'pdf-long-image': 'Export long image',
        'pdf-unlock': 'Unlock & download',
        'pdf-sign': 'Sign & export'
      }
    },
    image: {
      drop: 'Upload image',
      dropStitch: 'Upload images to stitch',
      dropResize: 'Upload image to resize',
      srcSize: 'Original size',
      resizeMode: 'Resize mode',
      custom: 'Custom size',
      percent: 'By percent',
      maxSide: 'Max side',
      lockRatio: 'Lock aspect',
      lockTip: 'Changing width or height updates the other side to match the original ratio',
      width: 'Target width',
      height: 'Target height',
      ratioBase: 'Anchor',
      byWidth: 'Keep width',
      byHeight: 'Keep height',
      scale: 'Scale',
      scaleTip: 'e.g. 10% turns 1024px into about 102px',
      maxW: 'Max width',
      maxH: 'Max height',
      maxTip: 'Shrinks to fit; will not upscale past the original',
      exportFmt: 'Export format',
      keepFmt: 'Original',
      quality: 'Quality',
      preview: 'Preview size',
      scaleAbout: '(about {n})',
      scaleWH: 'W {w}% / H {h}%',
      stitchH: 'Horizontal',
      stitchV: 'Vertical',
      block: 'Block size',
      maxBytes: 'Max size',
      qualityShort: 'Quality',
      wmPh: 'Watermark text',
      pos: 'Position',
      readFail: 'Could not read image size',
      resized: 'Resized to {w}×{h} — download started',
      gridOk: '9-grid images packed and downloaded',
      doneDl: 'Done — download started'
    },
    code: {
      inputPh: 'Enter text or URL',
      copybookPh: 'Enter Chinese characters',
      logo: 'Upload logo image',
      uploadCode: 'Upload image with a code',
      tabFile: 'Upload image',
      tabCam: 'Scan with camera',
      stopScan: 'Stop scanning',
      startCam: 'Start camera',
      camDefault: 'Please allow camera access in the browser.',
      hintQr: 'Align the QR code in the frame…',
      hintBar: 'Align the barcode in the frame…',
      hintDm: 'Align the Data Matrix in the frame…',
      hintHx: 'Align the Han Xin Code in the frame…',
      tipQr: 'Use the rear camera in good light; scanning stops automatically when decoded.',
      tipBar: 'Keep the barcode level, sharp, and free of glare.',
      tipDm: 'Data Matrix is a square matrix — keep the whole code in frame.',
      tipHx: 'Keep the full Han Xin Code in frame, sharp and glare-free; scanning stops when decoded.',
      hintDefault: 'Align the code in the frame…',
      camDenied: 'Cannot access the camera. Check browser permission or use HTTPS.',
      scanOk: 'Scanned',
      recFail: 'Could not decode. Try a sharper image.',
      camUnsupported: 'Camera is not supported in this environment',
      videoNotReady: 'Video is not ready'
    },
    convert: {
      tip: 'Paste config rules and convert. Review complex rules before using them.',
      swap: 'Swap input/output',
      copyOut: 'Copy result',
      phApache: 'Paste Apache .htaccess rules…',
      phNginx: 'Paste Nginx rewrite rules…'
    },
    ts: {
      tip: 'Convert Unix timestamps and datetimes (seconds or milliseconds). Edit either side to sync.',
      tsToDate: 'Timestamp → date',
      dateToTs: 'Date → timestamp',
      tsPh: 'e.g. 1704067200 or 1704067200000',
      nowSec: 'Now (sec)',
      nowMs: 'Now (ms)',
      local: 'Local time',
      utc: 'UTC',
      iso: 'ISO',
      weekday: 'Weekday',
      weekdayVal: '{d}',
      seconds: 'Seconds',
      millis: 'Milliseconds',
      pickDate: 'Pick date & time',
      datePh: 'Or paste: 2024-01-01 12:00:00',
      secTs: 'Unix seconds',
      msTs: 'Unix milliseconds',
      localShort: 'Local',
      parseTs: 'Could not parse timestamp',
      invalidDate: 'Invalid date',
      parseDate: 'Could not parse date',
      days: {
        日: 'Sunday',
        一: 'Monday',
        二: 'Tuesday',
        三: 'Wednesday',
        四: 'Thursday',
        五: 'Friday',
        六: 'Saturday'
      }
    },
    wm: {
      urlMode: 'Encode mode',
      urlAll: 'Encode all',
      phText: 'Enter text',
      phUrl: 'Enter a URL or text',
      phJson: 'Paste JSON',
      radix: 'Radix convert',
      radixFrom: 'From base',
      baseN: 'Base {n}',
      autoBase: 'Auto-detect',
      phRadix: 'e.g. 255, 0xff, 0b1010',
      htmlEsc: 'HTML escape',
      phHtml: 'Enter HTML / text',
      uuidTip: 'Generate RFC4122 UUID v4 (random).',
      genUuid: 'Generate UUID',
      genUuid5: 'Generate 5',
      phUnicode: 'Enter text or \\uXXXX',
      phHash: 'Text to hash',
      encodeFail: 'Encode failed',
      decodeFail: 'Decode failed',
      jsonErr: 'Invalid JSON: {msg}',
      convertFail: 'Convert failed',
      dec: 'Decimal',
      bin: 'Binary',
      oct: 'Octal',
      hex: 'Hex',
      b32: 'Base 32',
      b36: 'Base 36',
      metaTitle: 'Title',
      metaDesc: 'Description',
      metaKw: 'Keywords',
      metaUrl: 'URL',
      metaImg: 'Image',
      ogImg: 'OG image URL',
      copyCode: 'Copy code',
      allowAll: 'Allow all',
      disallow: 'Disallow paths',
      copyRobots: 'Copy robots.txt'
    },
    json: {
      tip: 'Format, minify, validate, browse a parse tree and search — copy path / key / value. Large JSON loads on demand without truncation.',
      validate: 'Validate',
      parse: 'Parse',
      reparse: 'Re-parse',
      sortKeys: 'Sort keys',
      escapeStr: 'Escape as string',
      unescape: 'Unescape',
      indentN: 'Indent {n}',
      phIn: 'Paste JSON…',
      done: 'Done',
      fmtOk: 'Formatted',
      minOk: 'Minified',
      sorted: 'Keys sorted',
      escaped: 'Escaped as a JSON string',
      escapeFail: 'Escape failed',
      unescaped: 'Unescaped',
      unescapeFail: 'Unescape failed',
      parseOk: 'Parsed — browse and search below (large JSON loads on demand, never truncated)',
      parseOkLarge: 'Parsed. Large document: tree nodes load in chunks as you expand. Source data is complete.',
      parseFail: 'Parse failed',
      treeTitle: 'Parsed tree',
      treeEmpty: 'Paste valid JSON and click Parse to browse as a tree',
      searchPh: 'Search keys, values, paths, or types…',
      hitCount: '{n} hits',
      expandAll: 'Expand loaded',
      collapseAll: 'Collapse all',
      expandAllHint: 'Expanded loaded nodes and fetched one chunk each ({n} items). Use Load more for the rest.',
      loadMore: 'Load more ({progress}, {n}/batch)',
      loadAllChildren: 'Load all children',
      path: 'Path',
      key: 'Key',
      value: 'Value',
      copyValue: 'Copy value',
      copyKv: 'Copy key:value',
      copyJson: 'Copy JSON',
      copyPathVal: 'Copy path + value',
      copyLine: 'Copy line',
      useAsInput: 'Use as input',
      usedAsInput: 'Node set as input',
      selectNode: 'Select a node on the left',
      sample: 'Sample',
      download: 'Download',
      downloaded: 'Downloaded data.json',
      statType: 'Type',
      statItems: 'Top items',
      statBytes: 'Bytes',
      statNodes: 'Nodes',
      statLoaded: 'Loaded',
      statEstimate: 'Est. nodes',
      statDepth: 'Depth',
      truncated: 'Too many nodes — truncated',
      searchCapped: 'Search limit reached',
      searchCappedHint: '{n} hits after scanning {scanned} nodes. Source JSON is intact; the tree shows a subset — refine the query to narrow down.',
      loadAllDone: 'All children loaded for this node'
    },
    fmt: {
      tip: 'Beautify or minify HTML / JS / CSS / XML / PHP. Also XML↔JSON and PHP obfuscation. Processed locally.',
      xmlJson: 'XML ↔ JSON',
      phpEnc: 'PHP encrypt',
      copyOut: 'Copy result',
      inputLang: 'Input · {lang}',
      phLang: 'Paste {lang} code…',
      xmlRoot: 'JSON→XML root name',
      inXmlJson: 'Input (XML or JSON)',
      phXmlJson: 'Paste XML or JSON…',
      swap: 'Swap',
      encMode: 'Method',
      encrypt: 'Encrypt / obfuscate',
      decrypt: 'Try decrypt',
      phpWarn: 'This is obfuscation, not strong encryption. It only hides source from casual reading.',
      phpSrc: 'PHP source',
      phPhp: 'Paste PHP, e.g. echo \'hello\';',
      fmtOk: 'Formatted',
      fmtFail: 'Format failed',
      minOk: 'Minified',
      minFail: 'Minify failed',
      xmlOk: 'XML → JSON done',
      jsonOk: 'JSON → XML done',
      convertFail: 'Convert failed',
      mixOk: 'Obfuscated',
      encFail: 'Encrypt failed',
      decOk: 'Decrypted',
      decFail: 'Decrypt failed'
    },
    byte: {
      tip: 'Enter a value and unit to convert across byte sizes. The decimal point stays as you typed it. Choose base 1024 (KiB/MiB) or 1000 (KB/MB).',
      ph: 'Number, e.g. 1024 or 1.5',
      base1024: 'Base 1024',
      base1000: 'Base 1000',
      unit: 'Unit',
      value: 'Value',
      action: 'Action',
      invalid: 'Enter a valid non-negative number'
    },
    ascii: {
      tip: 'Type English letters, digits, or common symbols and pick a font to make ASCII art. Use {nl} or Enter for a new line. Chinese is not supported; paste with a monospace font.',
      ph: 'e.g. wyqii cn or Hello\\nWorld (\\n = newline)',
      font: 'Font',
      layoutDefault: 'Default',
      layoutFull: 'Full',
      layoutFitted: 'Fitted',
      layoutSmush: 'Smush',
      empty: 'Type text above to preview ASCII art',
      genFail: 'Generation failed. Check the input or try another font.',
      gallery: 'All font previews',
      collapse: 'Collapse',
      use: 'Use',
      browse: 'Browse all fonts',
      switched: 'Switched to {name}',
      qClassic: 'Classic',
      qStandard: 'Standard',
      qBig: 'Big',
      qSlant: 'Slant',
      qBanner: 'Banner',
      qBlock: 'Block',
      qBubble: 'Bubble',
      qDigital: 'Digital',
      qStar: 'Star Wars'
    },
    whois: {
      tabWhois: 'Domain WHOIS',
      tabUa: 'User-Agent',
      tipWhois: 'Look up domain registration (WHOIS). Results depend on the server network and registry policy; some domains may be limited.',
      domain: 'Domain: {d}',
      server: 'WHOIS server: {s}',
      copyOut: 'Copy result',
      empty: 'No WHOIS content returned',
      fail: 'WHOIS lookup failed',
      tipUa: 'Parse the current or a custom User-Agent, with presets for common browsers, mini programs, and crawlers.',
      useLocal: 'Use this device UA',
      phUa: 'Paste User-Agent',
      parse: 'Parse',
      copyUa: 'Copy UA',
      browser: 'Browser',
      os: 'OS',
      device: 'Device',
      engine: 'Engine',
      mobile: 'Mobile',
      wechat: 'WeChat',
      bot: 'Bot',
      length: 'Length',
      presets: 'Presets',
      use: 'Use'
    },
    mac: {
      tip: 'Look up NIC vendor from MAC / OUI. About {n} common vendors locally; try online if missed.',
      ph: 'e.g. AA:BB:CC:DD:EE:FF or AABBCC',
      online: 'Online lookup',
      fail: 'Lookup failed',
      onlineFail: 'Online lookup failed',
      invalid: 'Enter at least 6 hex digits (OUI) or a full MAC',
      mac: 'Normalized MAC',
      oui: 'OUI',
      vendor: 'Vendor',
      unknown: 'Not found',
      localBit: 'Locally administered',
      multicast: 'Multicast',
      source: 'Source',
      srcLocal: 'Local',
      srcNone: 'Miss',
      srcOnline: 'Online',
      tipHit: 'Hit the local vendor list',
      tipMiss: 'Not in the local list — try the online lookup',
      tipOnline: 'Hit online',
      tipOnlineMiss: 'Not found online either'
    },
    regex: {
      tip: 'Write and test regex with presets and a metacharacter cheat sheet. Highlight matches and replace in the browser.',
      presets: 'Presets',
      phPattern: 'Regular expression',
      insert: 'Insert:',
      sample: 'Test text',
      phSample: 'Paste text to match',
      replace: 'Replace with (optional, $1 = group)',
      phReplace: 'Replacement',
      test: 'Test',
      copyRe: 'Copy regex',
      copyRepl: 'Copy replacement',
      matches: 'Matches',
      hit: '{n} hit(s)',
      none: 'No match',
      pos: 'Index',
      text: 'Match',
      groups: 'Groups',
      preview: 'Replace preview',
      tokens: 'Metacharacters',
      escapeSel: 'Escape selected / clipboard text',
      needCopy: 'Copy the text to escape first',
      escaped: 'Escaped as a literal regex',
      needPattern: 'Enter a regular expression',
      invalid: 'Invalid regex',
      replaceFail: 'Replace failed',
      runFail: 'Run failed',
      g: 'g global',
      gTip: 'Find all matches, not just the first',
      i: 'i ignore case',
      iTip: 'A and a match equally',
      m: 'm multiline',
      mTip: '^ $ match each line',
      s: 's dotall',
      sTip: '. also matches newlines',
      u: 'u Unicode',
      uTip: 'Treat as Unicode code points',
      y: 'y sticky',
      yTip: 'Match continuously from lastIndex',
      p: {
        email: { name: 'Email', desc: 'Common email format' },
        'mobile-cn': { name: 'CN mobile', desc: '11-digit mainland number' },
        url: { name: 'URL', desc: 'http/https links' },
        ipv4: { name: 'IPv4', desc: 'IPv4 address' },
        'id-card': { name: 'ID card', desc: '18-digit structure check' },
        'date-ymd': { name: 'Date YYYY-MM-DD', desc: 'Year-month-day' },
        'time-hms': { name: 'Time HH:mm:ss', desc: '24-hour clock' },
        chinese: { name: 'Chinese', desc: 'Consecutive Han characters' },
        number: { name: 'Number', desc: 'Integer or decimal' },
        'hex-color': { name: 'Hex color', desc: 'CSS color' },
        username: { name: 'Username', desc: 'Letter then 4–16 chars' },
        password: { name: 'Strong password', desc: 'Upper, lower, digit, symbol, ≥8' },
        'html-tag': { name: 'HTML tag', desc: 'Simple tag match' },
        'blank-line': { name: 'Blank line', desc: 'Empty or whitespace-only' },
        'trim-spaces': { name: 'Trim spaces', desc: 'Leading/trailing spaces' }
      }
    },
    pixel: {
      tip: 'Convert pixels ↔ cm / in / mm by DPI. You can also upload an image to read size and EXIF DPI (max 50MB).',
      ph: 'Enter a number',
      custom: 'Custom',
      unit: 'Unit',
      value: 'Value',
      action: 'Action',
      fromImage: 'Read from image',
      drop: 'Upload an image to read size / EXIF DPI',
      apply: 'Use width and convert',
      print: 'Print size ({dpi} DPI)',
      px: 'Pixels (px)',
      inch: 'Inches (in)',
      cm: 'Centimeters (cm)',
      mm: 'Millimeters (mm)',
      dpi72: '72 (screen)',
      dpi96: '96 (Windows)',
      dpi150: '150 (draft print)',
      dpi300: '300 (print)',
      readFail: 'Failed to read',
      invalid: 'Enter a valid number'
    },
    net: {
      ipTitle: 'IP geolocation',
      ipDesc: 'Look up country / region / city / ISP for an IP',
      ipPh: 'IPv4 address, e.g. 8.8.8.8',
      quick: 'Quick:',
      continent: 'Continent',
      country: 'Country / region',
      province: 'Province / state',
      city: 'City',
      isp: 'ISP',
      countryCode: 'Country code',
      latlng: 'Coordinates',
      raw: 'Raw data',
      ipEmpty: 'No geolocation data for this IP',
      needIp: 'Enter an IP address',
      domainTitle: 'Domain IP lookup',
      domainDesc: 'Resolve A/AAAA records and look up offline geolocation for each IPv4',
      domainPh: 'Domain, e.g. github.com or https://example.com',
      domainPrepend: 'Domain',
      resolve: 'Resolve',
      ipCount: '{n} IP(s)',
      engineOff: 'Offline IP database not ready — showing DNS results only',
      noGeo: 'No geolocation data',
      dnsRaw: 'Raw DNS records ({n})',
      needDomain: 'Enter a domain',
      resolveFail: 'Resolve failed',
      speedTitle: 'Speed test',
      speedDesc: 'Measure latency, download, and upload to this site. Results depend on server bandwidth and path — not your ISP plan peak.',
      downSize: 'Download size',
      upSize: 'Upload size',
      startSpeed: 'Start test',
      stop: 'Stop',
      speedResult: 'Results',
      latency: 'Latency (RTT)',
      downSpeed: 'Download',
      upSpeed: 'Upload',
      downTime: 'Download time',
      upTime: 'Upload time',
      transfer: 'Transferred',
      hintStart: 'Click start to measure latency → download → upload.',
      hintRun: 'Testing — keep this page open…',
      hintDone: 'Done. Values are measured on this site path for reference only.',
      hintStop: 'Test stopped.',
      phasePing: 'Measuring latency…',
      phaseDown: 'Download test…',
      phaseUp: 'Upload test…',
      phaseRun: 'Testing…',
      speedOk: 'Speed test finished',
      speedFail: 'Speed test failed',
      downFail: 'Download test failed',
      qAliDns: 'AliDNS',
      qBaidu: 'Baidu',
      qSite: 'This site'
    },
    netops: {
      latencyTitle: 'Host latency',
      latencyDesc: 'TCP connect latency to a public domain/IP (not ICMP ping). Probes run from this site’s server; private/loopback targets are blocked.',
      latencyPh: 'e.g. 1.1.1.1 or www.example.com',
      startTest: 'Start test',
      quick: 'Quick',
      target: 'Target',
      resolvedIp: 'Resolved IP',
      port: 'Port',
      reachable: 'Reachable',
      ok: 'OK',
      fail: 'Failed',
      avg: 'Average',
      minMax: 'Min / max',
      okCount: 'Successes',
      noteTcp: 'TCP connect time, not ICMP ping',
      needTarget: 'Enter a domain or IP',
      probeFail: 'Probe failed',
      lanTitle: 'LAN IP check',
      lanDesc: 'Compare WebRTC candidates with this site’s egress to guess LAN addresses and your public IP (browser support varies).',
      refresh: 'Refresh',
      localIp: 'Likely LAN IP',
      publicIp: 'Public IP',
      publicLoc: 'Public location',
      status: 'Status',
      lanNote: 'Some browsers or corporate networks hide host candidates. For full LAN scans, use the mini program.',
      detected: 'Detected',
      undetected: 'Not detected',
      lanEmpty: 'No address found — try another browser or the mini program',
      lanFail: 'Detection failed',
      camTitle: 'Camera check',
      camDesc: 'Strict same-Wi‑Fi probe for Hikvision/Dahua-style camera assets (counts a hit only when an image/script actually loads — timeouts are ignored).',
      cam1: 'Detects your LAN IP via WebRTC, then probes vendor image/script assets on common HTTP ports',
      cam2: 'Only real asset onload or readable vendor signatures count; timeouts and TLS failures are ignored',
      cam3: 'HTTPS pages may block http:// LAN assets (mixed content). Use the mini program for a fuller scan',
      cam4: 'Only scan networks you manage. Multiple ports on the same IP are merged into one result',
      camSubnet: 'Likely subnet',
      camRange: 'Scan range',
      camQuick: 'Quick subnet',
      camDefaults: 'Common defaults',
      camFull: 'Full /24',
      camManual: 'Manual IP',
      camManualPh: 'e.g. 192.168.1.64',
      camStart: 'Scan now',
      camScanning: 'Scanning…',
      camStop: 'Stop',
      camHintReady: 'Connect to the same Wi‑Fi as the cameras, then tap Scan now.',
      camHintNoIp: 'Could not read a LAN IP — you can still scan Common defaults or enter an IP.',
      camHintScan: '{n} probes queued — keep this tab open…',
      camFallbackDefaults: 'No LAN IP found — scanning common factory default addresses instead.',
      camStopped: 'Scan stopped.',
      camBadIp: 'Enter a valid IPv4 address',
      camNeedPrivate: 'Only private LAN addresses are allowed',
      camNeedWifi: 'No LAN IP detected — connect to Wi‑Fi first',
      camLikely: 'Likely cameras ({n})',
      camOther: 'Other open web ports ({n})',
      camEmpty: 'No reliable hits. Try Common defaults / Manual IP, or the WeChat mini program on the same Wi‑Fi.',
      camSuspect: 'Likely camera',
      camOpen: 'Open device',
      camDoneHit: 'Done: found {n} likely camera endpoint(s)',
      camDoneMiss: 'Done: no reliable fingerprint (web UI off, custom port, or browser blocked LAN assets)',
      camFail: 'Scan failed',
      camMixedWarn: 'This page is HTTPS, so the browser may block http:// LAN assets. Prefer the mini program camera check for fuller results.',
      privA: 'Class A private (10.0.0.0/8)',
      privB: 'Class B private (172.16.0.0/12)',
      privC: 'Class C private (192.168.0.0/16)',
      loopback: 'Loopback',
      other: 'Likely public or other',
      qBaidu: 'Baidu',
      qAliDns: 'AliDNS',
      qSite: 'This site'
    },
    beian: {
      eyebrow: 'Webmaster compliance · sign-in required',
      title: 'ICP filing lookup',
      desc: 'After sign-in, look up website / APP / mini program / quick app ICP filings. Members can create an open API for scripts and systems.',
      tabQuery: 'Online query',
      tabApi: 'Open API',
      member: 'Member',
      try: 'Try:',
      openOfficial: 'Open official site',
      officialTitle: 'Query network security filing on the MPS official site',
      keyword: 'Keyword:',
      copyKw: 'Copy keyword',
      total: '{n} result(s)',
      officialLink: 'Official verify',
      empty: 'No filing found',
      apiTitle: 'Open API docs',
      apiDesc: 'Members can create a personal token and call the filing API over HTTP for scripts, ops, and integrations.',
      memberOn: 'Member active',
      needMember: 'Membership required',
      apiOnlyMember: 'Open API is members-only',
      apiOnlyMemberDesc: 'Web queries need sign-in; creating/rotating API tokens requires membership.',
      goMember: 'Get membership',
      goMemberHint: 'Then you can create a token and view the full API docs here',
      token: 'API token',
      enabled: 'Enabled',
      notCreated: 'Not created',
      tokenHintOn: 'A token exists. The full secret is shown only on create/rotate — rotate again if lost.',
      tokenHintOff: 'Create a token below to start calling the API.',
      rotate: 'Rotate token',
      create: 'Create API token',
      closeApi: 'Disable API',
      authTitle: '1. Authentication',
      authBody: 'Send the token in the request header (recommended):',
      authCompat: 'Also accepted:',
      queryApiTitle: '2. Query endpoint',
      copyUrl: 'Copy URL',
      param: 'Param',
      explain: 'Description',
      fieldsTitle: '3. Response fields',
      field: 'Field',
      curlTitle: '4. cURL example',
      jsTitle: '5. JavaScript example',
      notesTitle: '6. Notes',
      footerTitle: 'Notes',
      footer1: 'Web queries require a signed-in account; the open API needs a member token.',
      footer2: 'ICP data depends on the server upstream; network-security filing defaults to the official site.',
      footer3: 'Authoritative results are on the MIIT / MPS official platforms.',
      typeWeb: 'Website',
      typeApp: 'APP',
      typeMapp: 'Mini program',
      typeKapp: 'Quick app',
      typeWangan: 'Network security',
      phWeb: 'Domain / filing no. / owner, e.g. baidu.com',
      phApp: 'APP name / owner / filing no.',
      phMapp: 'Mini program name / owner / filing no.',
      phKapp: 'Quick app name / owner / filing no.',
      phWangan: 'Enter a domain to open the MPS official query',
      phDefault: 'Enter a keyword',
      prependDomain: 'Domain',
      prependKw: 'Keyword',
      hintWangan: 'Network-security filing opens the MPS official page by default; a paid upstream returns results directly when configured.',
      hintIcp: 'Search by domain, service name, owner, or filing number.',
      statusChecking: 'Checking service…',
      statusApiMember: 'Member open API',
      statusApiNeed: 'Open API needs membership',
      statusReady: 'ICP query ready',
      statusNotReady: 'ICP upstream not ready',
      statusWait: 'Please wait',
      statusApiOk: 'You can create a token and call the API',
      statusApiHint: 'Get membership first',
      statusFail: 'Could not load service status',
      loadApiFail: 'Failed to load open API',
      confirmRotate: 'The old token will stop working immediately. Continue?',
      confirmCreate: 'Create an open API token for filing lookups?',
      confirmTitle: 'Open API',
      confirmClose: 'The token will stop working immediately. Continue?',
      closeTitle: 'Disable open API',
      closed: 'Disabled',
      record: 'Filing record',
      fDomain: 'Domain',
      fSiteName: 'Site name',
      fOwner: 'Owner',
      fOwnerType: 'Owner type',
      fBeianCode: 'Filing no.',
      fPolice: 'Filing authority',
      fBeianDate: 'Filing date',
      fSiteType: 'Site type',
      fUnit: 'Sponsoring unit',
      fService: 'Service name',
      fMainLicence: 'Main licence',
      fServiceLicence: 'Service licence',
      fPassTime: 'Approved',
      fContentType: 'Pre-approval',
      fAddress: 'Address',
      nothingCopy: 'Nothing to copy',
      needKw: 'Enter a search keyword',
      wanganMsg: 'There is no long-term free stable public API for network-security filing. Please use the MPS official site.',
      queryFail: 'Query failed'
    },
    ico: {
      drop: 'Drop or click to upload an image and convert to ICO locally',
      clear: 'Clear',
      unnamed: 'Untitled image',
      quickTitle: 'Quick presets',
      quickSub: 'Select common size sets in one click',
      sizesTitle: 'Export sizes',
      selectAll: 'Select all',
      faviconOnly: 'Favicon only',
      clearSel: 'Clear',
      custom: 'Custom',
      addSize: 'Add {n}×{n}',
      extraAdded: 'Custom sizes:',
      fitTitle: 'Fit mode',
      bgTitle: 'Background',
      transparent: 'Transparent',
      solid: 'Solid',
      bgHint: 'Best for transparent PNG favicons',
      genDownload: 'Generate & download ICO',
      packCount: 'Will pack {n} size(s)',
      preview: 'Live preview',
      tiers: '{n} size(s)',
      previewEmpty: 'Upload an image to preview icons at the selected sizes',
      needSize: 'Select at least one export size',
      tips: 'Tips',
      tip1: 'Prefer a square, transparent PNG as the source',
      tip2: 'Website favicons often use 16 / 32 / 48',
      tip3: 'Generated in the browser — nothing is uploaded',
      tip4: 'Save as favicon.ico in your site root when done',
      customTip: 'Custom size',
      genOk: 'Generated {name} ({n} sizes, ~{kb} KB)',
      convertFail: 'Conversion failed',
      fitContain: 'Fit',
      fitContainHint: 'Scale to fit and center; pad empty edges (recommended)',
      fitCover: 'Cover',
      fitCoverHint: 'Scale to fill; crop overflow from the center',
      fitStretch: 'Stretch',
      fitStretchHint: 'Force-fill the square; may distort',
      qFavicon: 'Website favicon',
      qWindows: 'Windows icon',
      qApp: 'App icon',
      qAll: 'All sizes',
      tip16: 'Browser tab / classic favicon',
      tip24: 'Some toolbar icons',
      tip32: 'Hi-DPI favicon / taskbar',
      tip48: 'Windows Explorer',
      tip64: 'Desktop shortcut',
      tip128: 'Hi-DPI icon',
      tip256: 'Vista+ large icon'
    },
    exif: {
      lead: 'Upload a photo to read and edit full EXIF: serial number, lens / flash, contrast / saturation / sharpness, light source, white balance, EXIF version, detailed GPS, and more. Device / style / light / flash / lens presets are included; you can also save custom presets. Export as JPEG (local processing).',
      drop: 'Choose or drop a photo (JPEG / PNG / WebP, ≤50MB)',
      hasExif: 'Existing EXIF found',
      noExif: 'No EXIF / not JPEG — you can add fields manually',
      stampNow: 'Set time to now',
      justShot: 'Quick “just shot”',
      saveCustom: 'Save as custom',
      clearFields: 'Clear fields',
      export: 'Export',
      exportHint: 'Write all current fields into JPEG EXIF and download. Original JPEGs keep fidelity; other formats are converted to JPEG first.',
      jpegQuality: 'JPEG quality',
      fileName: 'File name',
      exportBtn: 'Export JPEG with EXIF',
      devicePresets: 'Device presets',
      styleBlock: 'Style · light · flash · lens',
      style: 'Style',
      light: 'Light source',
      flash: 'Flash',
      lens: 'Lens',
      myPresets: 'My custom presets',
      delete: 'Delete',
      gpsBlock: 'GPS city shortcuts (accuracy / status / area)',
      clearGps: 'Clear GPS',
      searchPh: 'Search fields (e.g. serial, contrast, GPS)',
      onlyFilled: 'Filled only',
      select: 'Select',
      readFail: 'Failed to read',
      sizeFail: 'Could not read image size',
      applied: 'Applied: {label}',
      appliedDevice: 'Applied {brand} {name}',
      gpsFilled: 'Filled {name} GPS details',
      timeSet: 'Capture time set to now',
      justShotOk: 'Filled “just shot” parameters',
      saveTitle: 'Save custom preset',
      savePrompt: 'Name this field set',
      savePh: 'e.g. street night / studio portrait',
      save: 'Save',
      cancel: 'Cancel',
      saved: 'Custom preset saved',
      exported: 'Exported',
      exportFail: 'Export failed'
    },
    ocr: {
      eyebrow: 'Alibaba DocMind · file OCR',
      title: 'Smart image & document recognition',
      desc: 'General text, ID cards, invoices, vehicles/logistics, and exam papers. Supports images and PDF. With admin approval you can use the open API for business systems.',
      available: 'left',
      pickScene: 'Pick a scene',
      quota: 'Quota {n}/month',
      notReadyEm: 'Service not ready — contact an admin',
      pausedEm: 'Temporarily unavailable',
      notReady: 'Service not ready',
      notReadyBody: 'Ask an admin to configure the Alibaba OCR AccessKey in the backend.',
      tabRec: 'Online OCR',
      tabApi: 'Open API',
      authorized: 'Authorized',
      replace: 'Click or drop to replace',
      replaceClick: 'Click to replace',
      dropTitle: 'Drop an image or PDF here',
      dropHint: 'JPG / PNG / BMP / WebP / GIF / TIFF / PDF / OFD · ~10MB max',
      clear: 'Clear',
      typeLabel: 'Recognition type',
      typePh: 'Select Type',
      pageLabel: 'PDF / OFD page (optional)',
      pageTip: 'For multi-page files; leave empty to use the first page.',
      keysLabel: 'Extract fields (optional, comma-separated)',
      keysPh: 'e.g. name, address, invoice date; leave empty for auto',
      outputTable: 'Output table structure',
      result: 'Result',
      text: 'Text',
      emptyText: '(No plain text — switch to JSON)',
      resultEmpty: 'Pick a scene and upload a file to start',
      apiTitle: 'Open API docs',
      apiDesc: 'After admin approval you can create a personal token and call OCR over HTTP for apps and scripts.',
      apiOk: 'Authorized',
      needAdmin: 'Needs admin approval',
      apiNeedTitle: 'Open API needs admin approval',
      apiNeedDesc: 'Ask an admin to enable OCR API under Users → Tool config and set a monthly quota. Users cannot enable it themselves.',
      notOpened: 'Not enabled',
      notOpenedHint: 'Web OCR still works; the open API needs separate approval.',
      token: 'API token',
      enabled: 'Enabled',
      notCreated: 'Not created',
      used: 'Used {used} / {limit}',
      remaining: '{n} left',
      tokenHintOn: 'A token exists. The full secret is shown only on create/rotate — rotate again if lost.',
      tokenHintOff: 'Create a token below to start calling the API.',
      rotate: 'Rotate token',
      create: 'Create API token',
      closeToken: 'Revoke token',
      authTitle: '1. Authentication',
      authBody: 'Send the token in the request header (recommended):',
      authCompat: 'Also accepted:',
      queryTitle: '2. Recognize endpoint',
      copyUrl: 'Copy URL',
      param: 'Param',
      explain: 'Description',
      fieldsTitle: '3. Response fields',
      field: 'Field',
      scenesTitle: '4. Scene IDs (sceneId)',
      curlTitle: '5. cURL example',
      jsTitle: '6. JavaScript example',
      notesTitle: '7. Notes',
      btnNotReady: 'Service not ready',
      btnPaused: 'Unavailable',
      btnNeedFile: 'Upload a file first',
      btnRun: 'Start OCR',
      loadFail: 'Failed to load OCR status',
      tooLarge: 'File too large — keep under ~10MB',
      recOk: 'Recognized',
      unavailable: 'Temporarily unavailable',
      recFail: 'Recognition failed',
      loadApiFail: 'Failed to load open API',
      confirmRotate: 'The old token will stop working immediately. Continue?',
      confirmCreate: 'Create an OCR open API token?',
      confirmTitle: 'Open API',
      tokenCreated: 'Token created — copy and save it now',
      confirmClose: 'The token will stop working immediately. Continue?',
      closeTitle: 'Revoke open API',
      closed: 'Token revoked'
    },
    localOcr: {
      eyebrow: 'In-browser · private OCR',
      title: 'Local image text recognition',
      desc: 'PP-OCRv6 Tiny with onnxruntime-web runs detection and recognition in your browser. Images never leave your device — great for screenshots, document photos, and sensitive content.',
      badgeLocal: 'On-device',
      engineIdle: 'Engine not loaded',
      engineIdleHint: 'Models load on first use (~6MB, cached afterward)',
      engineLoading: 'Loading engine',
      engineReady: 'Engine ready',
      engineReadyHint: 'Pick an image to start',
      engineFail: 'Failed to load the engine — refresh and try again',
      dropTitle: 'Click or drop an image here',
      dropHint: 'JPG / PNG / WebP / BMP / GIF · max 20MB per image',
      pasteTip: 'Ctrl+V / ⌘+V to paste a screenshot',
      replace: 'Click or drop to replace',
      clear: 'Clear',
      showBoxes: 'Show boxes',
      autoRun: 'Recognize after select',
      result: 'Result',
      resultEmpty: 'Recognized text will appear here',
      emptyText: '(No text detected)',
      confidence: 'Confidence {n}%',
      lineCount: '{n} text blocks',
      btnLoading: 'Loading engine…',
      btnNeedFile: 'Select an image first',
      btnRunning: 'Recognizing…',
      btnRun: 'Recognize',
      needImage: 'Please choose an image file',
      tooLarge: 'Image must be under 20MB',
      noText: 'No text found — try a sharper image',
      recFail: 'Recognition failed',
      tipsTitle: 'Tips',
      tip1: 'First run downloads PP-OCRv6 Tiny detection and recognition models; they are cached in the browser.',
      tip2: 'Processing stays on-device. For complex layouts or handwriting, use the cloud “File OCR” tool.',
      tip3: 'Works best on horizontal printed text; supports Chinese, English, and mixed multilingual content.'
    },
    bgRemove: {
      eyebrow: 'In-browser · AI cutout',
      title: 'Smart background removal',
      desc: 'Remove backgrounds locally with ISNet. Checkerboard preview, solid/gradient/custom backgrounds. Models are self-hosted on this site — images never upload.',
      badgeLocal: 'On-device',
      badgeFree: 'Free: max edge {n}px',
      badgeMember: 'Member: unlimited resolution',
      limitNotice: 'Scaled from {from} to {to} (max edge {n}px) for free users. Members keep full resolution.',
      upgrade: 'Become a member',
      engineIdle: 'Engine idle',
      engineIdleHint: 'First run loads models from this site (tens of MB, then cached)',
      engineDownloading: 'Loading model assets',
      engineRunning: 'Removing background',
      engineReady: 'Engine ready',
      engineReadyHint: 'Pick another image anytime',
      dropTitle: 'Drop or click to upload',
      dropHint: 'JPG / PNG / WebP · up to 40MB',
      pasteTip: 'Paste screenshots with Ctrl+V / ⌘+V',
      replace: 'Drop or click to replace',
      clear: 'Clear',
      model: 'Model quality',
      result: 'Result',
      resultEmpty: 'Your cutout will appear here after processing',
      viewResult: 'Result',
      viewCompare: 'Compare',
      original: 'Original',
      cutout: 'Cutout',
      bgTitle: 'Background',
      download: 'Download',
      copy: 'Copy',
      copied: 'Copied to clipboard',
      copyUnsupported: 'Clipboard image copy is not supported here',
      btnNeedFile: 'Choose an image first',
      btnRunning: 'Working…',
      btnRun: 'Remove background',
      needImage: 'Please choose an image file',
      tooLarge: 'Image must be under {n}MB',
      recFail: 'Background removal failed — try another image or refresh',
      done: 'Done',
      tipsTitle: 'Notes',
      tip1: 'Models and WASM are served from /bg-removal/ on this site (no third-party CDN).',
      tip2: 'Free users are capped at 2048px on the long edge; members keep full resolution.',
      tip3: 'Use PNG for transparency; after swapping a solid/gradient/custom background you can export JPEG or WebP.',
      modelFast: 'Fast',
      modelFastHint: 'Smaller model — good for previews and simple portraits',
      modelStd: 'Standard',
      modelStdHint: 'Recommended balance of speed and edge quality',
      modelFine: 'Fine',
      modelFineHint: 'Higher quality — slower download and inference',
      gpuHint: 'Runs on CPU/WASM to match self-hosted models. Assets are cached in the browser after the first load.'
    },
    remoteDesk: {
      eyebrow: 'Official remote · BilldDesk',
      title: 'Remote Desk',
      desc: 'This page is a signed-in gateway. Actual remote sessions run on BilldDesk (desk.hsslive.cn). Screen streams and device codes never pass through our servers.',
      badgeLogin: 'Login required',
      badgeNoStore: 'No screen on our server',
      statOfficial: 'Official service',
      statOfficialHint: 'No bandwidth cost here; sessions stay under your BilldDesk account',
      openOfficial: 'Open BilldDesk',
      download: 'Download clients',
      copyUrl: 'Copy official URL',
      faq: 'Help / FAQ',
      stepsTitle: 'How to use',
      step1: 'Sign in on this site (done when you see this page).',
      step2: 'Open the official site or install Windows / macOS / Android clients.',
      step3: 'Register or sign in on BilldDesk, then connect with device code and password.',
      matrixTitle: 'Capabilities (per BilldDesk)',
      matrixHint: 'Features are provided by BilldDesk. Android-as-controller modes may still be in progress upstream.',
      soon: 'Upstream WIP',
      m1t: 'Web → PC',
      m1d: 'Control Windows / macOS from browser',
      m2t: 'Web → Android',
      m2d: 'Control Android from browser',
      m3t: 'Web → Web',
      m3d: 'View-only screen share',
      m4t: 'PC → PC',
      m4d: 'Desktop client control',
      m5t: 'PC → Android',
      m5d: 'Desktop controls Android',
      m6t: 'PC → Web',
      m6d: 'View only',
      m7t: 'Android → PC',
      m7d: 'Phone controls PC',
      m8t: 'Android → Android',
      m8d: 'Phone to phone',
      m9t: 'Android → Web',
      m9d: 'View only',
      safetyTitle: 'Safety notes',
      safety1: 'Use device codes and passwords only on BilldDesk — we never store them.',
      safety2: 'We can see who opened this tool, but not your BilldDesk devices or remote logs.',
      safety3: 'If an admin blocks you here, this gateway closes; your BilldDesk account is separate.',
      bannedTitle: 'Unavailable',
      bannedBody: 'An admin disabled remote-desk access for your account. Contact the site owner if needed.',
      disabledTitle: 'Gateway closed',
      disabledBody: 'The remote-desk gateway is temporarily disabled. Try again later.',
      loadFail: 'Failed to load status'
    },
    battery: {
      tip: 'Convert capacity, series/parallel packs, runtime, and C-rate. Includes JiaShiKai 32140 power cells, ESS prismatic cells, and consumer-cell presets (nominal values for estimates).',
      tabCap: 'Capacity',
      tabPack: 'Series / parallel',
      tabRuntime: 'Runtime',
      tabCrate: 'C-rate',
      presets: 'Cell presets',
      searchCell: 'Search model / brand / capacity, e.g. 32140, JiaShiKai, 280Ah',
      noCell: 'No matching cells. Try another keyword or category.',
      presetNote: 'Voltage, capacity, and C-rate are typical nominal values. Always confirm with the manufacturer datasheet. Selecting a cell fills voltage and capacity.',
      voltage: 'Voltage V',
      mah: 'Capacity mAh',
      orWh: 'or energy Wh',
      cellV: 'Cell voltage V',
      cellMah: 'Cell capacity mAh',
      cellWeight: 'Cell weight g (est.)',
      harnessPct: 'Harness / case weight %',
      series: 'Series S',
      parallel: 'Parallel P',
      loadMa: 'Load current mA',
      efficiency: 'Efficiency %',
      cRate: 'C-rate',
      orCurrentA: 'or current A',
      calc: 'Calculate',
      fail: 'Calculation failed',
      packNote: 'Voltage window and BMS current are rule-of-thumb estimates (BMS ≈ continuous current ×1.25). Weight includes harness/case overhead — confirm with datasheets and mechanical design.',
      errVoltage: 'Enter a valid nominal voltage (V)',
      errMahOrWh: 'Enter either mAh or Wh',
      errCell: 'Enter a valid cell voltage and capacity',
      errRuntime: 'Enter capacity and load current',
      errMah: 'Enter battery capacity (mAh)',
      errCrate: 'Enter a C-rate or discharge current',
      r: {
        voltage: 'Voltage V',
        mAh: 'Capacity mAh',
        Ah: 'Capacity Ah',
        Wh: 'Energy Wh',
        combo: 'Config',
        cells: 'Cells',
        chemName: 'Chemistry',
        packV: 'Nominal voltage V',
        packWindow: 'Voltage window',
        packChargeV: 'Charge voltage V',
        packCutoffV: 'Cutoff voltage V',
        packMah: 'Pack mAh',
        packAh: 'Pack Ah',
        packWh: 'Pack Wh',
        cellCrate: 'Ref. discharge C',
        packContA: 'Approx. continuous A',
        bmsSuggest: 'BMS suggestion',
        bmsContA: 'Suggested BMS continuous A',
        packWeightKg: 'Est. weight kg',
        packWhKg: 'Energy density Wh/kg',
        hours: 'Runtime hours',
        minutes: 'Runtime minutes',
        days: '≈ days',
        efficiency: 'Efficiency %',
        cRate: 'C-rate',
        currentA: 'Current A',
        currentMa: 'Current mA',
        ah: 'Capacity Ah'
      }
    },
    recording: {
      tabSize: 'Recording size',
      tabTime: 'Recording time',
      tabBw: 'Bandwidth',
      tipSize: 'Estimate continuous-recording disk size from codec, resolution (or custom bitrate), camera count, and days. Bitrates are industry references and vary with scene complexity.',
      tipTime: 'Given total disk capacity, estimate how long continuous recording lasts at the current quality and camera count.',
      tipBw: 'Estimate network bandwidth for recording/preview from camera count and per-stream bitrate, with ~20% headroom.',
      conditions: 'Inputs',
      byResolution: 'Resolution',
      byBitrate: 'Bitrate',
      codec: 'Codec',
      resolution: 'Resolution',
      fps: 'Frame rate',
      bitrate: 'Bitrate',
      recBitrate: 'Suggested bitrate',
      cameras: 'Cameras',
      camerasPh: 'e.g. 16',
      duration: 'Duration',
      durationPh: 'e.g. 30',
      capacity: 'Disk capacity',
      capacityPh: 'e.g. 8',
      reset: 'Reset',
      calc: 'Calculate',
      result: 'Result',
      sizeSub: 'Approx. capacity for continuous recording ({cameras} cams × {bitrate} Kbps × {days} days)',
      exact: 'Exact',
      suggestDisk: 'Suggested disk',
      sizeNote: 'Reserve ~15% headroom (formatting, indexes, bitrate spikes).',
      timeSub: 'Approx. continuous storage on {cap}',
      days: 'Days',
      hours: 'Hours',
      months: '≈ months',
      dayUnit: 'days',
      hourUnit: 'hours',
      monthUnit: 'months',
      bwSub: '{cameras} streams total (each {bitrate} Kbps)',
      totalBw: 'Total bandwidth',
      suggestBw: 'Suggested capacity',
      bwNote: 'Reserve ~20% link bandwidth; also consider switch backplane and NVR ports.',
      needBitrate: 'Enter a valid bitrate',
      fail: 'Calculation failed',
      errBw: 'Enter a valid camera count and bitrate',
      errSize: 'Enter a valid camera count, bitrate, and duration',
      errTime: 'Enter a valid camera count, bitrate, and disk capacity',
      uDay: 'Days',
      uHour: 'Hours',
      uMonth: 'Months (30d)',
      aboutDays: '~{n} GB',
      aboutTb: '~{n} TB'
    },
    networkCable: {
      tip: 'Enter bandwidth and run length for a detailed recommendation, budget / balanced / future-proof plan comparison, and a rough roadmap of how the cable holds up as broadband and LAN speeds grow.',
      conditions: 'Inputs',
      bandwidth: 'Target bandwidth',
      customBw: 'Custom',
      customBwValue: 'Custom bandwidth',
      length: 'Cable length',
      lengthPh: 'e.g. 30',
      scenario: 'Use case',
      environment: 'Installation',
      needsPoE: 'PoE powered (camera / AP)',
      preferFiber: 'Prefer fiber',
      quick: 'Quick presets',
      quickHome: 'Home 1G · 20m',
      quickCam: 'PoE cam · 80m',
      quickOffice: 'Office 10G · 40m',
      quickOutdoor: 'Building · 300m',
      reset: 'Reset',
      calc: 'Calculate',
      fail: 'Calculation failed',
      idleTitle: 'Enter conditions to calculate',
      idleDesc: 'Pick bandwidth, length, and scenario — or try a quick preset below.',
      result: 'Recommendation',
      linkSpeed: 'Link speed',
      effectiveSpeed: 'Est. throughput',
      loss: 'Overhead / margin',
      ceiling: 'Ceiling at length',
      years: 'Rough lifespan fit',
      headroom: 'Headroom vs target',
      whyTitle: 'Why this cable',
      maxEra: 'Era coverage',
      recommendDetail: 'Cable & jacket',
      cable: 'Recommended cable',
      shielding: 'Shielding',
      jacket: 'Jacket / type',
      maxChannel: 'Max segment',
      plansTitle: 'Three plan comparison',
      plansDesc: 'Budget, balanced, and future-proof options — pick by cost vs how hard it is to rewire later.',
      planCap: 'Ceiling',
      planCost: 'Cost',
      higherTitle: 'Would a higher category be better?',
      flagSpeed: 'Higher speed ceiling',
      flagYears: 'Longer upgrade runway',
      flagWorth: 'Worth the future-proof tier',
      flagOptional: 'Optional — budget OK',
      compareTitle: 'How each cable does at this length',
      compareDesc: 'Compare Cat5e–Cat8 and fiber: meets target, ceiling, cost tier, and future headroom.',
      roadmapTitle: 'Future upgrade timeline',
      roadmapDesc: 'Rough path: today → multi-gig in a few years → 10G-class later → rewire decade — how far this cable can follow.',
      reserveTitle: 'Install reserves & expansion',
      reserveDesc: 'Cable upgrades are cheap vs opening walls; conduit, dual pulls, and pull-string are the real future-proofing.',
      relayTitle: 'Relay & devices',
      needRelay: 'Intermediate device needed',
      yes: 'Yes',
      no: 'No',
      relayDevice: 'Suggested device',
      relayHops: 'Intermediate switches',
      alternatives: 'Alternatives',
      warnings: 'Warnings',
      tips: 'Installation tips',
      disclaimer: 'Based on common practice and channel standards (year estimates are approximate). Verify with certified cable, field testers, and negotiated link speed.',
      scenarioMap: {
        home: 'Home broadband / PC',
        office: 'Office LAN',
        camera: 'PoE camera',
        ap: 'Wi-Fi AP / patch panel',
        server: 'Server / datacenter',
        outdoor: 'Building / outdoor run'
      },
      envMap: {
        indoor: 'Indoor dry',
        ceiling: 'Ceiling / tray',
        outdoor: 'Outdoor (UV / weather)',
        buried: 'Direct bury / conduit',
        industrial: 'High-EMI industrial'
      }
    },
    eng: {
      disclaimer: 'For reference only — verify against applicable codes for real projects.',
      calc: 'Calculate',
      calcSize: 'Size cable',
      fail: 'Calculation failed',
      result: 'Results',
      byCurrent: 'By current',
      byPower: 'By power',
      singlePhase: 'Single-phase',
      threePhase: 'Three-phase',
      extraTag: 'Large estimate',
      dia: '≈ diameter φ{n} mm',
      ampacity: 'Ampacity ≈ {n} A',
      drop: 'Drop ≈ {n} V ({p}%)',
      limitedBy: 'Limited by {what}',
      byDrop: 'voltage drop',
      byAmpacity: 'ampacity',
      cableTitle: 'Cable sizing (copper / aluminum / gold / CCA)',
      cableTipPower: 'Enter load power and run length to recommend cross-section from ampacity and voltage drop.',
      cableTipCurrent: 'Enter load current and run length to recommend cross-section from ampacity and voltage drop.',
      mat: { cu: 'Copper', al: 'Aluminum', au: 'Gold', cca: 'CCA' },
      tip: {
        'cable-size': 'Recommend copper, aluminum, gold, or CCA size from current or power and run length.',
        'electrician-calc': 'Electrician tools: power/current, voltage drop, motors, three-phase, R/L, and more.',
        'room-calc': 'Room area, shape area, AC sizing, and paint/flooring estimates.',
        'unit-calc': 'Length, area, temperature, and percent/discount conversions.',
        'science-calc': 'Cylinders, triangles, quadrilaterals, circles, and spheres.',
        'other-tools': 'Electric, cable, and room calculators — switch from the left menu.'
      },
      m: {
        'cable-size': { title: 'Cable sizing', desc: 'Current or power → Cu/Al/Au/CCA size' },
        electric: { title: 'V / I / P', desc: 'Basic electrical conversions' },
        bill: { title: 'Energy cost', desc: 'Power × time → kWh and cost' },
        cable: { title: 'Voltage drop', desc: 'Drop from known cable size' },
        motor: { title: 'Motor I / P', desc: 'Motor current and power' },
        'delta-wye': { title: 'Delta / wye', desc: 'Three-phase connection and power' },
        resistance: { title: 'Resistance', desc: 'Ohm’s law / LED current limit' },
        inductance: { title: 'Inductance', desc: 'Reactance and series/parallel' },
        circuit: { title: 'Circuits', desc: 'Power, RC, capacitive reactance' },
        component: { title: 'Components', desc: 'Cutoff / resonance / divider' },
        cylinder: { title: 'Cylinder force', desc: 'Pneumatic force and pressure' },
        room: { title: 'Room area', desc: 'L×W, volume, multiple rooms' },
        shape: { title: 'Shape area', desc: 'Rect / triangle / circle / trapezoid' },
        'area-unit': { title: 'Area units', desc: 'm² / mu / hectare / ping' },
        ac: { title: 'AC sizing', desc: 'Match room area to AC tonnage' },
        material: { title: 'Paint & flooring', desc: 'Material from floor area' },
        length: { title: 'Length units', desc: 'mm / m / ft conversions' },
        temp: { title: 'Temperature', desc: '°C / °F / K' },
        percent: { title: 'Percent / discount', desc: 'Share, discount, savings' },
        'math-rect': { title: 'Rectangle / square', desc: 'Perimeter, area, diagonal' },
        'math-isosceles': { title: 'Isosceles triangle', desc: 'Sides, height, area, angles' },
        'math-triangle': { title: 'Triangle', desc: 'SSS / SAS / base×height' },
        'math-quad': { title: 'Quadrilateral', desc: 'Parallelogram / trapezoid / general' },
        'math-cylinder': { title: 'Cylinder', desc: 'Base, lateral area, volume' },
        'math-circle': { title: 'Circle', desc: 'Circumference and area' },
        'math-sphere': { title: 'Sphere', desc: 'Surface area and volume' },
        'math-cube': { title: 'Cube', desc: 'Surface, volume, space diagonal' },
        'math-pythagoras': { title: 'Pythagoras', desc: 'Right-triangle sides' }
      },
      r: {
        drop: 'Drop (V)',
        percent: 'Drop (%)',
        endVoltage: 'End voltage (V)',
        resistanceOne: 'Single-wire R (Ω)',
        tip: 'Note',
        current: 'Current (A)',
        inputPowerKw: 'Input power (kW)',
        apparentKva: 'Apparent (kVA)',
        formula: 'Formula',
        powerKw: 'Output power (kW)',
        horsepower: '≈ horsepower (HP)',
        connection: 'Connection',
        lineVoltage: 'Line voltage UL (V)',
        phaseVoltage: 'Phase voltage UP (V)',
        lineCurrent: 'Line current IL (A)',
        phaseCurrent: 'Phase current IP (A)',
        activeKw: 'Active power (kW)',
        reactiveKvar: 'Reactive (kvar)',
        areaMm2: 'Piston area (mm²)',
        pushForceN: 'Extend force (N)',
        pushForceKg: 'Extend force (kgf)',
        pullForceN: 'Retract force (N)',
        pullForceKg: 'Retract force (kgf)',
        pressureBar: 'Pressure (bar)',
        pressureMpa: 'Pressure (MPa)',
        xl: 'XL (Ω)',
        inductanceMh: 'L (mH)',
        totalMh: 'Equivalent L (mH)',
        resistance: 'Resistance (Ω)',
        voltage: 'Voltage (V)',
        total: 'Equivalent R (Ω)',
        powerW: 'Power (W)',
        tauSec: 'Time constant τ (s)',
        tauMs: 'Time constant τ (ms)',
        settle5Tau: '≈ 5τ (s)',
        xc: 'Xc (Ω)',
        cutoffHz: 'Cutoff (Hz)',
        resonateHz: 'Resonance (Hz)',
        vout: 'Vout (V)',
        ratio: 'Divider ratio',
        coolingW: 'Cooling (W)',
        coolingKw: 'Cooling (kW)',
        coolingBtu: 'Cooling (BTU/h)',
        suggestHp: 'Suggested HP',
        areaM2: 'Area (m²)',
        m2: 'Square meters m²',
        mu: 'Mu',
        hectare: 'Hectare',
        ping: 'Ping',
        sqft: 'Square feet',
        cm2: 'Square centimeters',
        areaPing: '≈ ping',
        areaSqft: '≈ sq ft',
        perimeterM: 'Perimeter (m)',
        volumeM3: 'Volume (m³)',
        wallAreaM2: 'Wall area (m²)',
        heightM: 'Ceiling (m)',
        roomsDetail: 'Breakdown',
        area: 'Area',
        circumference: 'Circumference',
        mm: 'mm',
        cm: 'cm',
        m: 'm',
        km: 'km',
        inch: 'inch',
        ft: 'ft',
        celsius: '°C',
        fahrenheit: '°F',
        kelvin: 'K',
        result: 'Result',
        finalPrice: 'Sale price',
        saved: 'Saved',
        offPercent: 'Discount (%)',
        netAreaM2: 'Net area (m²)',
        withWasteM2: 'With waste (m²)',
        paintLiters: 'Paint ≈ (L)',
        pieces: 'Planks ≈ (pcs)',
        pieceAreaM2: 'Piece area (m²)',
        loadCurrentA: 'Load current (A)',
        designCurrentA: 'Design current (A)',
        lengthM: 'Run length (m)',
        voltageV: 'Voltage (V)',
        phases: 'Phases',
        safetyFactor: 'Safety factor',
        recommendCu: 'Copper size',
        recommendAl: 'Aluminum size',
        recommendAu: 'Gold size',
        recommendCca: 'CCA size',
        detailCu: 'Copper note',
        detailAl: 'Aluminum note',
        detailAu: 'Gold note',
        detailCca: 'CCA note',
        kwh: 'Energy (kWh)',
        cost: 'Est. cost (CNY)',
        dailyKwh: 'Daily energy (kWh)',
        inputMode: 'Input mode',
        loadPowerW: 'Load power (W)',
        loadPowerKw: 'Load power (kW)',
        powerUnit: 'Power unit',
        side: 'Side / edge',
        length: 'Length',
        width: 'Width',
        perimeter: 'Perimeter',
        diagonal: 'Diagonal',
        equalSide: 'Equal side',
        base: 'Base',
        height: 'Height',
        apexAngleDeg: 'Apex (°)',
        baseAngleDeg: 'Base angle (°)',
        sideC: 'Side c',
        semiPerimeter: 'Semi-perimeter',
        baseArea: 'Base area',
        lateralArea: 'Lateral area',
        surfaceArea: 'Surface area',
        volume: 'Volume',
        radius: 'Radius',
        diameter: 'Diameter',
        faceArea: 'Face area',
        spaceDiagonal: 'Space diagonal',
        hypotenuse: 'Hypotenuse',
        otherLeg: 'Other leg'
      },
      convert: 'Convert',
      estimate: 'Estimate',
      f: {
        inputMode: 'Input mode',
        loadCurrentA: 'Load current (A)',
        loadPower: 'Load power',
        powerUnit: 'Power unit',
        lengthM: 'Cable length (m)',
        voltageV: 'Voltage (V)',
        phases: 'Phases',
        maxDrop: 'Max drop (%)',
        safety: 'Safety factor',
        pf: 'Power factor',
        mode: 'Mode',
        powerW: 'Power (W)',
        currentA: 'Current (A)',
        resistance: 'Resistance (Ω)',
        power: 'Power',
        hoursDay: 'Hours / day',
        days: 'Days',
        price: 'Rate (CNY/kWh)',
        length: 'Length (m)',
        width: 'Width (m)',
        heightOpt: 'Ceiling (m, optional)',
        shape: 'Shape',
        long: 'Length',
        wide: 'Width',
        high: 'Height',
        base: 'Base',
        radius: 'Radius r',
        orDia: 'Or diameter',
        top: 'Top base',
        bottom: 'Bottom base',
        value: 'Value',
        unit: 'Unit',
        type: 'Type',
        areaM2: 'Area (m²)',
        waste: 'Waste (%)',
        coats: 'Coats',
        coverage: 'Coverage (m²/L)',
        plankW: 'Plank width (m)',
        plankL: 'Plank length (m)',
        scale: 'Scale',
        part: 'Part',
        whole: 'Whole',
        percent: 'Percent %',
        original: 'Original price',
        discount: 'Discount',
        lenM: 'Length (m)',
        section: 'Cross-section (mm²)',
        resistivity: 'Resistivity',
        goal: 'Solve for',
        powerKw: 'Power (kW)',
        eta: 'Efficiency η',
        connection: 'Connection',
        ul: 'Line voltage UL (V)',
        il: 'Line current IL (A)',
        up: 'Phase voltage UP (V)',
        ip: 'Phase current IP (A)',
        bore: 'Bore (mm)',
        rod: 'Rod dia. (mm)',
        pressure: 'Pressure (bar)',
        force: 'Force (N)',
        Lmh: 'Inductance (mH)',
        freq: 'Frequency (Hz)',
        xl: 'Reactance (Ω)',
        voltV: 'Voltage V',
        ampI: 'Current I (A)',
        resR: 'Resistance R (Ω)',
        vs: 'Supply Vs (V)',
        vf: 'LED Vf (V)',
        ma: 'Current (mA)',
        ampIplain: 'Current I',
        resRplain: 'Resistance R',
        capUf: 'Capacitance C (μF)',
        freqF: 'Frequency f (Hz)',
        roomArea: 'Room area (m²)',
        heightM: 'Ceiling (m)',
        roomType: 'Room type',
        sun: 'Sun exposure',
        people: 'Occupants',
        side: 'Side',
        equalSide: 'Equal side',
        apex: 'Apex (°)',
        sideA: 'Side a',
        sideB: 'Side b',
        sideC: 'Side c',
        angleC: 'Angle C (°)',
        heightH: 'Height h',
        cubeSide: 'Edge a',
        baseNum: 'Base value',
        sideD: 'Side d',
        solve: 'Solve',
        legA: 'Leg a',
        legB: 'Leg b',
        hypC: 'Hypotenuse c',
        diagonal: 'Diagonal'
      },
      h: {
        electric: 'Current / voltage / power',
        bill: 'Energy use / electricity cost',
        room: 'Room area',
        shape: 'Shape area',
        areaUnit: 'Area unit conversion',
        ac: 'Air-conditioner sizing',
        material: 'Paint / flooring estimate',
        length: 'Length unit conversion',
        temp: 'Temperature conversion',
        percent: 'Percent / discount',
        cable: 'Cable voltage drop',
        motor: 'Motor current / power',
        dw: 'Delta / wye load power',
        cyl: 'Cylinder pressure / force',
        ind: 'Inductance calculator',
        res: 'Resistance calculator',
        cir: 'Classic circuit calculator',
        comp: 'Component calculator',
        mathRect: 'Rectangle / square',
        mathIso: 'Isosceles triangle',
        mathTri: 'Triangle',
        mathQuad: 'Quadrilateral',
        mathCyl: 'Cylinder',
        mathCircle: 'Circle',
        mathSphere: 'Sphere',
        mathCube: 'Cube',
        mathPy: 'Pythagorean theorem'
      },
      sub: {
        mathRect: 'Perimeter, area, and diagonal.',
        mathIso: 'Area and angles from equal sides, base/height, or apex angle.',
        mathTri: 'Area and perimeter from three sides, SAS, or base × height.',
        mathQuad: 'Parallelogram, trapezoid, or four sides plus a diagonal.',
        mathCyl: 'Base, lateral, surface area, and volume.',
        mathCircle: 'Circumference and area; enter radius or diameter.',
        mathSphere: 'Surface area and volume.',
        mathCube: 'Surface area, volume, and space diagonal.',
        mathPy: 'Find the hypotenuse from two legs, or a leg from hypotenuse + one leg.'
      },
      o: {
        p2i: 'Power → current',
        i2p: 'Current → power',
        ohm: 'Ohm’s law',
        oneRoom: 'One room L × W',
        multi: 'Multiple rooms',
        rect: 'Rectangle',
        triangle: 'Triangle',
        circle: 'Circle',
        trap: 'Trapezoid',
        bedroom: 'Bedroom',
        living: 'Living room',
        office: 'Office',
        kitchen: 'Kitchen',
        sunN: 'Typical',
        sunS: 'Strong / west sun',
        sunW: 'Shaded / weak',
        paint: 'Paint',
        floor: 'Flooring',
        pct: 'Find percent',
        of: 'Percent of',
        disc: 'Sale price',
        discHint: 'Enter 8.5 or 85',
        rhoCu: 'Copper 0.0175 Ω·mm²/m',
        rhoAl: 'Aluminum 0.0283 Ω·mm²/m',
        fromP: 'Current from power',
        fromI: 'Power from current',
        star: 'Star (Y)',
        delta: 'Delta (Δ)',
        p2f: 'Pressure → force',
        f2p: 'Force → pressure',
        xl: 'Find XL',
        L: 'Find L',
        comb: 'Series / parallel',
        series: 'Series',
        parallel: 'Parallel',
        ohmFill: 'Fill any two to solve the third',
        led: 'LED current limit',
        power: 'Electric power',
        rc: 'RC time constant',
        xc: 'Capacitive reactance Xc',
        rcCut: 'RC cutoff',
        lc: 'LC resonance',
        div: 'Voltage divider',
        square: 'Square',
        rectShape: 'Rectangle',
        sides: 'Equal sides + base',
        baseH: 'Base + height',
        apex: 'Equal side + apex',
        sss: 'Three sides',
        sas: 'Two sides + included angle',
        bh: 'Base × height',
        para: 'Parallelogram',
        genQuad: 'General quad',
        hyp: 'Find hypotenuse c',
        leg: 'Find a leg',
        name: 'Name',
        addRoom: 'Add room',
        del: 'Remove'
      }
    },
    life: {
      disclaimer: 'For everyday reference only — not medical or professional advice.',
      pickDate: 'Pick a date',
      start: 'Calculate',
      female: 'Female',
      male: 'Male',
      fail: 'Calculation failed',
      n: {
        'outfit-customize': 'Outfits',
        'due-date': 'Due date',
        ovulation: 'Ovulation',
        menstrual: 'Period',
        luteal: 'Luteal',
        'pregnancy-week': 'Gestational age',
        'lunar-calendar': 'Lunar calendar',
        'bmi-calc': 'BMI',
        'body-fat': 'Body fat',
        'ideal-weight': 'Ideal weight',
        'calorie-bmr': 'Metabolism',
        'water-intake': 'Water',
        'sleep-cycle': 'Sleep',
        'age-calc': 'Age'
      },
      dueTitle: 'Due date',
      pregTitle: 'Gestational age',
      dueLead: 'Estimated from last menstrual period (Naegele’s rule), adjustable by cycle length.',
      lmp: 'First day of last period',
      cycleDays: 'Cycle length (days)',
      dueDate: 'Due date',
      weekday: '{d}',
      pregWeek: 'Week {label}',
      trimester: 'Trimester',
      stage: '',
      pregnant: 'Pregnant for',
      remain: 'Days until due',
      days: 'days',
      ct: {
        ovulation: 'Ovulation window',
        menstrual: 'Menstrual cycle',
        luteal: 'Luteal phase'
      },
      cd: {
        ovulation: 'Estimate ovulation day and the fertile window from cycle length.',
        menstrual: 'Project period, ovulation, fertile days, and upcoming cycles.',
        luteal: 'Estimate the luteal window and next period from ovulation day.'
      },
      periodStart: 'First day of period',
      cycleLen: 'Cycle length',
      periodDays: 'Period length',
      ovuDay: 'Ovulation day',
      lutealLen: 'Luteal length',
      period: 'Period',
      fertile: 'Fertile',
      ovu: 'Ovulation',
      nextMenses: 'Next period',
      luteal: 'Luteal',
      futureCycles: 'Next {n} cycles',
      colPeriodStart: 'Period start',
      colOvu: 'Ovulation',
      colFertile: 'Fertile window',
      colNext: 'Next period',
      lutealRange: '{n} days · next period {date}',
      lutealShort: 'Luteal phase is on the short side; see a clinician if this persists.',
      lutealLong: 'Luteal phase is on the long side; interpret with your own history.',
      lutealOk: 'Luteal length is within a common range.',
      lunarTitle: 'Solar / lunar calendar',
      lunarLead: 'Gregorian and Chinese lunar dates, stems-and-branches, zodiac, and solar terms (1900–2100).',
      solarDate: 'Gregorian date',
      today: 'Today',
      term: 'Solar term · {t}',
      gzYear: 'Year (sexagenary)',
      animal: 'Zodiac animal',
      lunarMonth: 'Lunar month',
      lunarDay: 'Lunar day',
      yearMonth: '{y} / {m}',
      w0: 'Sun',
      w1: 'Mon',
      w2: 'Tue',
      w3: 'Wed',
      w4: 'Thu',
      w5: 'Fri',
      w6: 'Sat',
      ht: {
        'bmi-calc': 'Body mass index (BMI)',
        'body-fat': 'Body-fat estimate',
        'ideal-weight': 'Ideal weight',
        'calorie-bmr': 'BMR and calories',
        'water-intake': 'Daily water intake',
        'sleep-cycle': 'Sleep cycles',
        'age-calc': 'Age, zodiac, and star sign',
        fallback: 'Life calculators'
      },
      hd: {
        'bmi-calc': 'Weight status using Chinese adult BMI cutoffs.',
        'body-fat': 'U.S. Navy circumference method.',
        'ideal-weight': 'Modified Broca vs. BMI healthy range.',
        'calorie-bmr': 'Mifflin-St Jeor BMR / TDEE estimate.',
        'water-intake': 'Water volume from body weight and activity.',
        'sleep-cycle': 'Bedtime from 90-minute sleep cycles.',
        'age-calc': 'Exact age, Chinese zodiac, star sign, and birthday countdown.'
      },
      heightCm: 'Height (cm)',
      weightKg: 'Weight (kg)',
      gender: 'Sex',
      heightPlain: 'Height cm',
      neck: 'Neck cm',
      waist: 'Waist cm',
      hip: 'Hip cm',
      age: 'Age',
      activity: 'Activity',
      weightPlain: 'Weight kg',
      waterAct: 'Activity level',
      low: 'Low',
      normal: 'Typical',
      high: 'High',
      wakePlan: 'Wake time',
      wakePh: 'Wake-up time',
      fallAsleep: 'Minutes to fall asleep',
      birthday: 'Date of birth',
      under: 'Underweight',
      overweight: 'Overweight',
      obese: 'Obese',
      idealRange: 'Ideal range',
      bmiMid: 'BMI midpoint',
      healthRange: 'Healthy range',
      bodyFatRate: 'Body fat',
      bmr: 'BMR',
      tdee: 'TDEE',
      cut: 'Cut estimate',
      bulk: 'Bulk estimate',
      waterSuggest: 'Suggested intake',
      waterAbout: 'About {ml} ml · {cups} cups (250 ml)',
      waterTip: 'Spread intake through the day; add more in heat or exercise.',
      sleepIn: 'Suggested bedtime',
      wakeAt: 'Wake {t} · {n} cycles',
      cycleHours: '{n} cycles · {h} hours',
      exactAge: 'Exact age',
      yearsOld: '{n} years',
      monthsDays: '{m} months {d} days',
      constellation: 'Star sign',
      nextBirthday: 'Days until birthday',
      lived: 'Days lived',
      weekPlus: '{w} weeks + {d} days',
      phase: {
        period: 'Period',
        fertile: 'Fertile',
        ovulation: 'Ovu.',
        safe: 'Safer'
      },
      mile: {
        t1: 'End of first trimester',
        screen: 'Second-trimester screening window',
        t2: 'End of second trimester',
        due: 'Due date'
      },
      act: {
        sedentary: 'Sedentary',
        light: 'Light activity',
        moderate: 'Moderate exercise',
        active: 'High intensity',
        athlete: 'Athlete'
      },
      bmi: {
        under: 'Underweight',
        normal: 'Normal',
        over: 'Overweight',
        obese: 'Obese'
      },
      bmiTip: {
        under: 'Consider more nutrition and strength training.',
        normal: 'Keep a balanced diet and regular exercise.',
        over: 'Consider calorie control and more aerobic activity.',
        obese: 'Consider a professionally guided weight-loss plan.'
      },
      fat: {
        essential: 'Essential fat',
        athlete: 'Athletic',
        fit: 'Fit / lean',
        average: 'Average',
        high: 'High'
      }
    },
    fengshui: {
      disclaimer: 'For cultural and entertainment reference only — not professional feng shui or destiny advice.',
      pickDate: 'Pick a date',
      start: 'Run reading',
      fail: 'Reading failed',
      today: 'Today',
      optional: 'Optional',
      score: 'Score',
      birthDate: 'Birth date (solar)',
      birthHour: 'Birth hour',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      nameOpt: 'Name (optional)',
      namePh: 'Shown in result title',
      chartTitle: 'BaZi chart',
      dayMaster: 'Day master',
      wuxingDist: 'Five-element balance',
      animalA: 'Zodiac A',
      animalB: 'Zodiac B',
      facing: 'Facing / entrance',
      yearAnimal: 'Year animal',
      purpose: 'Purpose',
      home: 'Home',
      office: 'Office',
      shop: 'Shop',
      luckyDirs: 'Favorable directions',
      cautionDirs: 'Caution directions',
      rooms: 'Rooms',
      terrain: 'Terrain form',
      water: 'Nearby water',
      waterNone: 'No notable water',
      waterFront: 'Water in front',
      waterBack: 'Water behind',
      waterSide: 'Water on the side',
      road: 'Road form',
      roadCalm: 'Calm / smooth',
      roadCurve: 'Curving embrace',
      roadRush: 'Straight rush',
      shas: 'Observed sha',
      intensity: 'Felt intensity',
      intLow: 'Mild',
      intMid: 'Moderate',
      intHigh: 'Strong',
      pressure: 'Sha pressure',
      date: 'Date',
      yourAnimal: 'Your zodiac',
      dayPillar: 'Day pillar',
      boost: 'Strengthen',
      ease: 'Ease',
      master: 'Master reading',
      todayLeft: 'Left today',
      todayUsed: 'Used today',
      dailyLimit: 'Daily limit',
      timesUnit: '',
      unlimited: 'Unlimited',
      member: 'Member',
      freeUser: 'Free',
      needLoginTitle: 'Sign in to ask the master',
      needLoginDesc: 'Free users: 1/day. Members: 10/day. Ask anything.',
      goLogin: 'Sign in',
      askLabel: 'Your question',
      askPh: 'e.g. Is a south-facing entrance good? Career luck this year?',
      askBtn: 'Ask the master',
      askRequired: 'Please enter a question',
      askOk: 'Reading ready',
      myRecords: 'My records',
      historyTitle: 'Recent',
      masterBadge: 'Master',
      delete: 'Delete',
      deleted: 'Deleted',
      deleteConfirm: 'Delete this reading?',
      tip: 'Notice',
      sq1: 'How should I arrange a new home?',
      sq2: 'Career luck and directions this year',
      sq3: 'Are our zodiacs compatible?',
      sq4: 'Best bed placement for rest?',
      n: {
        master: 'Master',
        bazi: 'BaZi',
        hehe: 'Harmony',
        fs: 'Feng Shui',
        house: 'Layout',
        site: 'Terrain',
        posha: 'Remedies',
        dir: 'Directions',
        wx: 'Elements'
      },
      t: {
        'master-divination': 'Master Reading',
        'bazi-divination': 'BaZi Chart',
        'hehe-sanhe': 'Zodiac Harmony',
        'fengshui-divination': 'Feng Shui Reading',
        'house-layout': 'House Layout',
        'site-terrain': 'Site Terrain',
        'posha-break': 'Sha Remedies',
        'direction-luck': 'Daily Directions',
        'wuxing-tune': 'Five Elements Tune'
      },
      d: {
        'master-divination': 'Ask anything; AI master replies using the admin-selected provider. Free 1/day, members 10/day.',
        'bazi-divination': 'Build four pillars from solar birth date and hour, with five-element tips.',
        'hehe-sanhe': 'Compare two zodiacs for Liuhe, Sanhe, clash, and harm relations.',
        'fengshui-divination': 'Lucky and caution directions from facing and space purpose.',
        'house-layout': 'Room placement tips for living room, bedroom, kitchen, and more.',
        'site-terrain': 'Score homestead qi from terrain, water, and road form.',
        'posha-break': 'Identify common sha patterns and practical remedy ideas.',
        'direction-luck': 'Daily auspicious directions for travel or seating.',
        'wuxing-tune': 'Color, direction, and object tips from BaZi element balance.'
      }
    },
    lookup: {
      n: {
        'phone-location': 'Mobile region',
        'common-phones': 'Useful numbers',
        'area-zip': 'Area / ZIP',
        'idcard-area': 'ID region',
        'university-search': 'Universities',
        'country-code': 'Country codes',
        'blood-type': 'Blood type'
      },
      tip: {
        'phone-location': 'Look up Chinese mainland mobile carriers; province/city is added when the number-range API is available.',
        'common-phones': 'Emergency, government, bank, and courier numbers — search and copy.',
        'area-zip': 'Quick lookup of Chinese city area codes and postal codes.',
        'idcard-area': 'Parse the first 6 digits of a Chinese ID for region, birth date, and sex.',
        'university-search': 'Search a growing list of major universities in China.',
        'country-code': 'Country/region names, ISO codes, and international dialing codes.',
        'blood-type': 'Estimate a child’s possible ABO types from the parents.'
      },
      phMobile: '11-digit mobile number',
      number: 'Number',
      carrier: 'Carrier',
      prefix: 'Prefix',
      province: 'Province',
      city: 'City',
      phPhone: 'Search name / number / category',
      phZip: 'City / area code / ZIP',
      areaCode: 'Area code',
      zip: 'ZIP',
      phId: '15- or 18-digit ID number',
      region: 'Administrative region',
      regionCode: 'Region code',
      birthday: 'Date of birth',
      gender: 'Sex',
      ageAbout: 'Age about',
      years: '{n} years',
      phUni: 'Name / province / type',
      school: 'School',
      type: 'Type',
      level: 'Level',
      phCountry: 'Country / ISO / dialing code',
      zhName: 'Chinese',
      dial: 'Dialing code',
      father: 'Father’s type',
      mother: 'Mother’s type',
      bloodBtn: 'Possible types',
      possible: 'Possible in child',
      impossible: 'Not possible',
      none: 'None',
      fail: 'Lookup failed',
      male: 'Male',
      female: 'Female',
      bloodNote: 'ABO inheritance estimate only; Rh and subtypes are not included.'
    },
    lan: {
      badge: 'LAN P2P',
      title: 'LAN speed test',
      lead: 'Open this tool on two devices: one as {host}, one as {client}. Pair with a room code to measure latency and throughput. Signaling goes through this site; test traffic uses WebRTC between devices (best on the same Wi‑Fi).',
      host: 'Host',
      client: 'Client',
      asHost: 'Be the host',
      asHostDesc: 'Create a room, share the code, and wait for the other device to join.',
      asClient: 'Be the client',
      asClientDesc: 'Enter the room code to join, start the test, and see latency plus up/down rates.',
      leave: 'Leave session',
      roomCode: 'Room code',
      copyInvite: 'Copy invite link',
      rewait: 'Wait again',
      hostHint: 'Send the code or link to another device on the same LAN and join as Client. Keep this page open on the host.',
      phCode: 'Enter 6-character code',
      joined: 'Connected',
      join: 'Join',
      dlAmt: 'Download size',
      ulAmt: 'Upload size',
      unit: 'Speed unit',
      testing: 'Testing…',
      start: 'Start test',
      rtt: 'Latency RTT',
      jitter: 'Jitter {n}',
      dl: 'Download (peer → you)',
      ul: 'Upload (you → peer)',
      finished: 'Finished at',
      how: 'How to use',
      tip1: 'Open this page in browsers on two computers or phones, ideally on {lan}.',
      lanSame: 'the same Wi‑Fi or wired LAN',
      tip2: 'One side taps Host for a room code; the other joins as Client. Either side can start the test.',
      tip3: 'Results show the path between devices, not your ISP plan. Different subnets or firewalls may block a direct link.',
      tip4: 'In the mini program, copy the page link and open it in the system browser for full WebRTC support.',
      livePing: 'Ping',
      liveDl: 'Downloading',
      liveUl: 'Uploading',
      liveDone: 'Done',
      liveTesting: 'Testing',
      liveRate: 'Live rate',
      st: {
        idle: 'Not connected',
        enterCode: 'Enter a room code to join',
        creating: 'Creating room…',
        createFail: 'Could not create room',
        createFailShort: 'Create failed',
        connected: 'Connected — you can start the test',
        roomReadyRetry: 'Room created. Retry waiting below, or leave and create a new one.',
        rewait: 'Waiting for peer again…',
        waitFail: 'Wait failed',
        needCode: 'Enter a 6-character room code',
        joinFail: 'Join failed',
        testOk: 'Test finished',
        testFail: 'Test failed',
        codeCopied: 'Room code copied',
        linkCopied: 'Invite link copied',
        roomGone: 'Room missing or closed. Ask the host to create a new code and join again.',
        waitPeer: 'Creating room and waiting for peer…',
        published: 'Session published, waiting for the client…',
        joining: 'Joining room…',
        pinging: 'Measuring latency…',
        dl: 'Download test…',
        ul: 'Upload test…',
        done: 'Test finished',
        connFail: 'Connection failed. Make sure both devices are on the same LAN.',
        disconnected: 'Disconnected',
        dcClosed: 'Data channel closed',
        waitTimeout: 'Timed out waiting for the peer. Check the code and network.',
        answering: 'Answered, establishing a direct link…',
        clientJoined: 'Client joined, establishing a direct link…',
        sdpBad: 'Session description mismatch. Use a recent Chrome/Edge on both sides, or refresh both pages.',
        peerDl: 'Peer download test — this device is sending…',
        peerUl: 'Peer upload test — this device is receiving…',
        noWebrtc: 'This browser does not support WebRTC',
        dcNotReady: 'Data channel is not ready',
        cancelled: 'Cancelled',
        dcNotOpen: 'Data channel is not open',
        waitType: 'Timed out waiting for {type}',
        dlTimeout: 'Download test timed out',
        ulTimeout: 'Upload test timed out'
      }
    },
    xfer: {
      eyebrow: 'LAN · P2P',
      title: 'LAN transfer',
      lead: 'Open a room code or scan the QR to chat and send files in one room. Files go device-to-device (not via this site). Select a peer for private chat/files (inspired by {link}).',
      leadLink: 'internal-chat',
      createRoom: 'Create room',
      createDesc: 'Generate a room code and QR for peers on the same LAN.',
      phNick: 'Your nickname',
      createEnter: 'Create & enter',
      joinRoom: 'Join room',
      joinDesc: 'Enter the 6-digit code, or scan their QR to open this page.',
      phCode: 'Room code',
      join: 'Join',
      room: 'Room',
      copyCode: 'Copy code',
      copyLink: 'Copy link',
      altQr: 'Room QR',
      scanJoin: 'Scan to join',
      myNick: 'My nickname',
      online: 'Online {n}',
      guest: 'Guest',
      me: ' (me)',
      leave: 'Leave room',
      chatHint: 'Select a peer for {priv} (only they see it). Otherwise messages and files go to all connected peers. Files are peer-to-peer.',
      privStrong: 'private chat / files',
      sendTo: 'Send to',
      phBroadcast: 'All connected peers (broadcast)',
      modePriv: 'Private',
      modeBroadcast: 'Broadcast',
      feedEmpty: 'No messages yet. Wait until a peer shows “Ready”, then send text or files.',
      dm: 'DM',
      download: 'Download',
      sendFilePriv: 'Private file',
      sendFile: 'Send file',
      sendingN: 'Sending {i}/{total}…',
      dropTip: 'Multi-select · drag & drop · LAN P2P (not via server)',
      phDm: 'Private message (only they see)…',
      phChat: 'Message, Enter to send (Shift+Enter for newline)',
      send: 'Send',
      how: 'How to use',
      tip1: 'Files transfer only between devices, not via this site. Use a browser on the same Wi‑Fi when possible.',
      tip2: 'In a multi-peer room, select someone for private chat/files; otherwise broadcast to all connected peers.',
      tip3: 'You can multi-select or drop several files; they send in order. Mobile browsers support multi-select too.',
      tip4: 'Wait until a peer shows “Ready” before sending files. Closing the page leaves the room.',
      ready: 'Ready',
      roomBroadcast: 'Room broadcast',
      dmTitle: 'DM · {name}',
      peer: 'Peer',
      createFail: 'Create failed',
      needCode: 'Enter a 6-digit room code',
      joinFail: 'Join failed',
      connErr: 'Connection error',
      entered: 'Entered room',
      self: 'You',
      relayTextOnly: 'Relay · text only',
      connecting: 'Connecting',
      connected: 'Connected',
      canSend: 'Ready',
      left: 'Left',
      failed: 'Failed',
      disconnected: 'Disconnected',
      dcClosed: 'Channel closed',
      dcError: 'Channel error',
      waitDirect: 'Waiting for P2P',
      peerRelay: '{name} (mini program · text only)',
      peerReady: '{name} (ready)',
      peerConnecting: '{name} (connecting)',
      codeCopied: 'Room code copied',
      linkCopied: 'Invite link copied',
      copyFail: 'Copy failed',
      sendFail: 'Send failed',
      broadcastConfirmMulti: 'Send {n} files to all connected peers. For private send, pick a recipient first.',
      broadcastConfirm: 'No peer selected — files will go to all connected peers. Pick a recipient above for private send.',
      broadcastTitle: 'Broadcast files?',
      broadcastOk: 'Broadcast',
      goPick: 'Pick peer',
      file: 'File',
      fileFail: '{name}: {err}',
      sentN: 'Sent {n} files',
      sentOne: 'File sent',
      donePartial: 'Done: {ok} ok, {fail} failed',
      phSendStart: 'Starting send',
      phSendProgress: 'Sending',
      phSendDone: 'Sent',
      phSendFail: 'Send failed',
      phRecvStart: 'Starting receive',
      phRecvProgress: 'Receiving',
      phRecvDone: 'Download ready',
      st: {
        creating: 'Creating room…',
        createFail: 'Failed to create room',
        joining: 'Joining room…',
        joinedRelay: 'Joined (relay mode)',
        joinedWait: 'Joined — waiting for peers…',
        left: 'Left room',
        punching: 'Punching peer connection…',
        timeoutRetry: 'Direct timeout: network may block P2P; retrying…',
        iceRetry: 'ICE failed, retrying…',
        failRetry: 'Direct connect failed, retrying…',
        punchFailMany: 'Repeated punch failures: use the same Wi‑Fi, disable VPN/firewall, then Reconnect. Symmetric NAT may block pure P2P.',
        rePunch: 'Re-punching…',
        readyDirect: 'Peer connected — ready to send files'
      },
      err: {
        noPeerId: 'Join failed: no peerId',
        noMsg: 'Messaging not supported here',
        peerNotReady: 'Peer not ready yet — wait until status is “Ready”',
        noPeers: 'No connected peers yet — try again shortly',
        dcClosed: 'Send failed: data channel not open',
        noFile: 'No file selected',
        relayNoFile: 'Relay endpoint cannot send LAN files — open this tool in a browser',
        miniNoFile: 'Peer is on mini program and cannot receive LAN files; both sides need a browser',
        peerNotReadyFile: 'Peer not ready — wait for “Ready”, or enable temporary cross-network relay',
        noPeersRelay: 'No connected peers. Enable temporary relay for cross-network, or configure TURN',
        noRelayEnv: 'Relay file transfer not supported here',
        unnamed: 'Untitled file',
        noWebrtc: 'WebRTC not supported (needs HTTPS or localhost)',
        insecure: 'Insecure context — open over HTTPS for WebRTC',
        disconnected: 'Disconnected',
        peerNotReadyShort: 'Peer not ready',
        xferAbort: 'Transfer aborted: connection closed',
        sendNat: 'Direct send failed (possible symmetric NAT). Switch network or use the same Wi‑Fi'
      }
    },
    p2p: {
      eyebrow: 'WebRTC · browser P2P',
      title: 'P2P file transfer',
      lead: 'Both sides open this page in a browser, pair with a room code or link, then send files. {strong} — not via this site’s app servers; the server only exchanges tiny signaling.',
      leadStrong: 'File bytes stay device-to-device',
      point1: 'Prefers direct P2P; cross-region / different ISPs may fail',
      point2: 'Optional temporary cross-network relay via this site (~100MB cap)',
      point3: 'If TURN is configured, failed paths can fall back to TURN (no disk)',
      inRoom: 'Room {code}',
      notInRoom: 'Not in a room',
      createRoom: 'Create room',
      createDesc: 'Generate a 6-digit code and invite link for the other person.',
      phNick: 'Your nickname',
      createEnter: 'Create & enter',
      joinRoom: 'Join room',
      joinDesc: 'Enter their code, or scan / open the invite link to join.',
      phCode: '6-digit room code',
      joinAction: 'Join transfer',
      roomCode: 'Room code',
      copyCode: 'Copy code',
      copyLink: 'Copy link',
      altQr: 'Invite QR',
      scanJoin: 'Scan to join',
      peers: 'Peers {n}',
      waitPeer: 'Waiting for peer…',
      peer: 'Peer',
      reconnect: 'Reconnect',
      natTip: 'Cross-region / ISP punching often fails. Enable temporary relay below, or ask the admin to configure TURN.',
      relayTitle: 'Temporary cross-network relay',
      relayDesc: 'If direct fails, relay briefly via this site (~{n}MB cap; uses bandwidth)',
      myNick: 'My nickname',
      leave: 'Leave room',
      xferTitle: 'File transfer',
      xferLead: 'Select a peer, then send. Files use a WebRTC DataChannel; {strong}.',
      xferStrong: 'content does not go through this site',
      phTarget: 'Choose recipient (ready peers)',
      peerReadyOpt: '{name} · ready',
      feedEmpty: 'No transfers yet. Send when the peer shows “Ready”.',
      save: 'Save',
      how: 'Notes',
      tip1Strong: 'Prefer direct',
      tip1: ': on the same LAN / weak NAT, files stay between devices.',
      tip2Strong: 'Cross-region / ISP',
      tip2: ': pure STUN often fails. Enable temporary relay, or deploy TURN (env LAN_TRANSFER_TURN_*).',
      tip3Strong: 'TURN vs temp relay',
      tip3: ': TURN forwards bytes with no disk; temp relay briefly stores on this site (same as LAN transfer).',
      tip4: 'Use a modern HTTPS browser. For chat + multi-peer, use LAN transfer.',
      ready: 'Ready',
      shortReady: 'Ready',
      shortRelay: 'Relay OK',
      shortFail: 'Punch failed',
      shortConnecting: 'Connecting',
      shortWait: 'Waiting',
      shortIdle: 'Idle',
      sendingN: 'Sending {i}/{total}',
      sendingRelay: 'Sending via relay…',
      sendingDirect: 'Sending directly…',
      pickPeerFirst: 'Pick a peer first',
      peerNotReady: 'Peer not ready — or enable temporary relay',
      dropRelay: 'Click or drop files (via temporary relay)',
      dropSend: 'Click or drop files to send',
      hintRelay: 'Temporary site relay; removable after transfer',
      hintDirect: 'Device-to-device transfer',
      hintTurn: 'TURN configured: failed punches may use TURN',
      hintRelayPending: 'Direct failed — send will use temporary site relay',
      hintWait: 'Punching… for cross-network, enable temporary relay',
      hintMulti: 'Multi-select supported; large files chunked',
      guest: 'Guest',
      peerInitial: 'P',
      relayOnTip: 'Temporary relay on: falls back to this site when direct fails',
      punchFailTip: 'Direct failed — enable temporary relay to keep sending',
      connErr: 'Connection error',
      noRelayPeer: 'Unsupported (relay peer)',
      stReady: 'Ready',
      stConnected: 'Connected',
      stConnecting: 'Punching…',
      stDisc: 'Briefly disconnected…',
      stFailed: 'Punch failed — reconnect',
      stLeft: 'Left',
      stDcClosed: 'Channel closed',
      stDcError: 'Channel error',
      stClosed: 'Closed',
      createFail: 'Create failed',
      needCode: 'Enter a 6-digit room code',
      joinFail: 'Join failed',
      entered: 'Entered transfer room',
      codeCopied: 'Room code copied',
      linkCopied: 'Invite link copied',
      copied: 'Copied',
      copyFail: 'Copy failed',
      pickReadyPeer: 'Pick a ready peer first',
      peerNotDirect: 'Peer not fully connected yet',
      pickConnected: 'Pick a connected peer first',
      sentN: 'Sent {n} files',
      sentOne: 'File sent',
      sendFail: 'Send failed',
      phXfer: 'Transferring',
      phStart: 'Start',
      phProgress: 'Transferring',
      phSent: 'Sent',
      phRecv: 'Received',
      file: 'File',
      leftOk: 'Left room',
      rePunchOk: 'Re-punch started',
      reFail: 'Reconnect failed'
    },
    optical: {
      eyebrow: 'In-house · fountain-code light transfer',
      title: 'Optical file transfer',
      lead: 'The sender plays a live QR stream on screen; the receiver aims a camera at it to rebuild the file. {noCable}. Data does not go through this site’s servers.',
      noCable: 'No Wi‑Fi, Bluetooth, or cable needed',
      pillSha: 'SHA-256 check',
      pillLocal: 'In-browser · no redirect',
      pillBrowser: 'Browser only',
      maxHint: 'Up to {n}',
      send: 'Send',
      recv: 'Receive',
      sendTitle: 'Send a file',
      sendLead: 'Pick a file or paste text; the screen plays fountain-code QR frames. Open Receive on another device and aim at this screen.',
      pickFile: 'Choose file',
      orPaste: 'Or paste text',
      phPaste: 'Paste text to send (saved as .txt)',
      fps: 'Flash rate',
      fps8: '8 FPS (steadier)',
      fps10: '10 FPS (recommended)',
      fps12: '12 FPS',
      fps15: '15 FPS (faster)',
      ecl: 'Error correction',
      eclL: 'L · more capacity',
      eclM: 'M · balanced',
      file: 'File',
      size: 'Size',
      blocks: 'Blocks',
      eta: 'Estimate',
      etaSec: 'from about {n} s',
      start: 'Start flashing',
      stop: 'Stop',
      sendHint: 'Keep a single file under {max}; compress or split larger ones. Transfer is not encrypted — do not send secrets.',
      readyFlash: 'Ready to flash here',
      sending: 'Sending · frame {n} · keep the screen on',
      recvTitle: 'Receive a file',
      recvLead: 'Allow the camera and aim at the sender’s screen. HTTPS or localhost required. Steady light and less shake help.',
      camPreview: 'Camera preview',
      camOn: 'Start camera',
      camOff: 'Stop camera',
      reset: 'Reset progress',
      unique: 'Unique frames: {n}',
      rank: 'Decoded / total: {a} / {b}',
      fileMeta: 'File: {name} ({size})',
      scan: 'Scan: {s}',
      recvOk: 'Received',
      download: 'Download file',
      tips: 'Tips',
      tip1: 'Two devices: one flashes, one scans. You can also use two windows on one machine.',
      tip2: 'About 20–40 cm; fill the viewfinder with the QR. Lower FPS on the sender if needed.',
      tip3: 'If it stays on “waiting for header”: both sides must be on this page, and the sender must be flashing.',
      tip4: 'Camera works only on HTTPS or localhost.',
      privacy: 'Privacy',
      priv1: 'Transfer is optical — the two devices need not share a network.',
      priv2a: 'Not encrypted',
      priv2b: ': any camera aimed at the screen can read the stream. Do not send secrets.',
      priv3: 'Encode/decode stay local; files never upload to this site.',
      credit: 'Inspired by open optical fountain-code projects. This page is our own implementation and does not bundle their code.',
      textChars: 'Text · {n} chars',
      done: 'Done',
      waitMeta: 'Waiting for header…',
      collecting: 'Collecting fountain frames…',
      fileTooBig: 'File too large (max {max}). Compress or split it first.',
      textTooBig: 'Text too large (max {max})',
      prepFail: 'Prepare failed',
      qrFail: 'Could not draw QR: {m}',
      unknown: 'Unknown error',
      needHttps: 'This page is not HTTPS, so most browsers cannot use the camera. Use HTTPS or localhost.',
      noCam: 'Camera is not available here',
      aiming: 'Aim at the sender’s flashing QR…',
      camFail: 'Could not open the camera. Check permission, or try HTTPS / another device.',
      notOurFrame: 'QR seen, but not this site’s light-transfer frame (scanned {n} times)',
      dupFrame: 'Locked on · duplicate frame (unique {n})',
      gotHeader: 'Header received, collecting data…',
      waitHeader: 'Data frame cached — still waiting for header…',
      receiving: 'Receiving · unique frames {n}',
      recvDone: 'File received — you can download it',
      restoreFail: 'Could not restore. Reset and try again.',
      hashFail: 'Checksum failed. Transfer may be corrupt; reset and aim again.',
      noQr: 'No QR recognized yet',
      fallbackTitle: 'Optical file transfer',
      fallbackDesc: 'Fountain-code light transfer'
    },
    vocal: {
      badge: 'AI split',
      title: 'Vocal separator',
      lead: 'Upload audio or video to split vocals from backing. Default is vocals + accompaniment; members can use four stems (vocals / drums / bass / other). Wait after submit, then download.',
      daily: 'Today’s quota',
      unlimited: 'Unlimited',
      remain: '{a} / {b} left',
      maxLen: 'Max length',
      hardCap: ' (tier unlimited, hard cap applies)',
      uploadCap: 'Upload limit',
      outMode: 'Output',
      modeMember: '2-stem / 4-stem (members)',
      mode2: '2-stem (vocals + backing)',
      keep: 'File retention',
      days: '{n} days',
      hours: '{n} hours',
      minSec: '{m} min {s} s',
      sec: '{n} s',
      cannot: 'Cannot submit right now',
      submit: 'New job',
      twoStem: 'Vocals + backing',
      fourStem: '4-stem (members)',
      drop: 'Drop a file here, or',
      pick: 'Choose audio / video',
      formats: 'mp3 / wav / flac / m4a / mp4 / mkv and more',
      change: 'Change file',
      clear: 'Clear',
      start: 'Start split',
      job: 'Current job #{id}',
      dl: 'Download {name}',
      cancel: 'Stop conversion',
      del: 'Delete job',
      recent: 'Recent jobs',
      empty: 'No jobs yet',
      four: '4-stem',
      two: '2-stem',
      stop: 'Stop',
      remove: 'Delete',
      waitDone: 'Done. Download the result (it will be deleted after expiry).',
      waitFail: 'Failed. Try another file.',
      waitCancel: 'Job stopped',
      waitSlow: 'Splitting ({p}%). CPU split is slow; the last few percent can take minutes. Keep this page open.',
      waitRun: 'Splitting ({p}%). CPU processing may take several minutes; download here when done.',
      waitQueue: 'Queued. Keep this page open.',
      st: {
        pending: 'Pending',
        queued: 'Queued',
        processing: 'Processing',
        done: 'Done',
        failed: 'Failed',
        cancelled: 'Stopped',
        expired: 'Expired',
        deleted: 'Deleted'
      },
      loadFail: 'Load failed',
      queuedOk: 'Queued. Please wait.',
      submitFail: 'Submit failed',
      cancelAsk: 'Stop this conversion job?',
      cancelTitle: 'Stop job',
      cancelOk: 'Stopped',
      cancelFail: 'Could not stop',
      delAsk: 'Deleted files cannot be recovered. Delete this job?',
      delTitle: 'Delete job',
      delOk: 'Deleted',
      delFail: 'Could not delete',
      dlFail: 'Download failed'
    },
    md: {
      open: 'Open a Markdown file',
      lead: 'Drop a .md here or click to choose. Parsed locally — nothing is uploaded.',
      pick: 'Choose file',
      sample: 'Sample document',
      paste: 'Paste from clipboard',
      tip1: '.md / .markdown / .mdx / .txt',
      tip2: 'Max {n}MB per file',
      tip3: 'Source · preview · split',
      source: 'Source',
      preview: 'Preview',
      split: 'Split',
      openFile: 'Open file',
      copyMd: 'Copy Markdown',
      dlMd: 'Download .md',
      exportHtml: 'Export HTML',
      close: 'Close document',
      lines: '{n} lines',
      words: '{n} words',
      chars: '{n} chars',
      headings: '{n} headings',
      codes: '{n} code blocks',
      images: '{n} images',
      toc: 'Outline',
      wrap: 'Wrap lines',
      phEdit: 'Edit Markdown here…',
      gfm: 'GFM · rendered locally',
      modeSource: 'Source view',
      modeSplit: 'Split view',
      modePreview: 'Preview',
      opened: 'File opened',
      openFail: 'Could not open',
      sampleOk: 'Sample loaded',
      noClip: 'This browser cannot read the clipboard. Paste into the source pane instead.',
      clipEmpty: 'Clipboard is empty',
      pasted: 'Pasted from clipboard',
      pasteFail: 'Paste failed',
      copied: 'Markdown copied',
      copyFail: 'Copy failed. Select the source text manually.',
      downloading: 'Download started',
      exported: 'HTML exported',
      sampleDoc: '# Markdown viewer\n\nOpen a `.md` file locally and switch between **source** and **preview**. Nothing is uploaded.\n\n## Highlights\n\n- Drag or click to open Markdown\n- Source / preview / split\n- Outline jump and counts\n- Copy, download, export HTML\n'
    },
    anydoc: {
      maxFile: 'Max {n}MB per file',
      local: 'Processed locally — not uploaded',
      try: 'Quick try',
      sampleRtf: 'Sample RTF',
      sampleCsv: 'Sample CSV',
      feat1: 'Private / local',
      feat2: 'Drop to convert',
      feat3: '14 formats',
      chars: '{n} chars',
      source: 'Source',
      preview: 'Preview',
      guide: 'Formats and notes',
      guideSub: 'Format is detected from content, even if the extension is wrong',
      tip1: 'Text PDFs convert directly; scan-only / image PDFs need OCR and are not supported yet.',
      tip2: 'Embedded images show up as text notes in the Markdown.',
      tip3: 'The conversion engine loads on first use, then the browser cache is reused.',
      other: 'Other',
      titleLoad: 'Preparing conversion engine…',
      titleRun: 'Converting to Markdown…',
      titleDrop: 'Release to convert',
      titleIdle: 'Drop a document here, or click to upload',
      hintLoad: 'First load takes a moment; then conversion stays local.',
      hintRun: 'Please wait — large files take longer.',
      engLoad: 'Engine loading',
      engReady: 'Engine ready',
      engOff: 'Engine not ready',
      engFail: 'Could not load conversion engine: {m}',
      convFail: 'Conversion failed',
      copyFail: 'Copy failed. Select the text manually.'
    },
    gift: {
      "eyebrow": "Gifts · easy to look up",
      "title": "Gift book",
      "lead": "Record guest names, amounts, and notes. Multiple books, combined sharing, optional password, Excel / CSV export.",
      "quota": "Book quota",
      "quotaDefault": "Using the site default quota",
      "remain": "{n} more books available",
      "phGlobal": "Search all books: name / note",
      "searchAll": "Search all",
      "globalTip": "Find a guest across every book. Results show which book they belong to.",
      "results": "Search results",
      "resultMeta": "“{q}” · {n} entries · ¥{amt} · {books} books",
      "noMatch": "No matching records",
      "book": "Book",
      "myBooks": "My books",
      "newBook": "New book",
      "emptyBooks": "No books yet — create one above",
      "shareOne": "Share this book",
      "exportExcel": "Export Excel",
      "nEntries": "entries",
      "datePrefix": "Date {d}",
      "myShares": "My shares",
      "shareTip": "The link stays the same. You can change the password and books. Entry changes sync to visitors.",
      "newShare": "New share",
      "emptyShares": "No shares yet — create one above",
      "shareFallback": "Gift book share",
      "unbound": "No books linked",
      "web": "Web",
      "mini": "Mini program",
      "unshare": "Stop sharing",
      "emptyMain": "Select or create a book to start recording",
      "orderAscShow": "Oldest first",
      "orderDescShow": "Newest first",
      "orderTip": "Share pages use the same order",
      "orderAsc": "Oldest",
      "orderDesc": "Newest",
      "excelFilter": "Excel (current filter)",
      "csvFilter": "CSV (current filter)",
      "count": "Count",
      "countFiltered": "Filtered count",
      "total": "Total",
      "totalFiltered": "Filtered total",
      "avg": "Average",
      "max": "Highest",
      "phSearch": "Search name / note",
      "moreFilters": "More filters",
      "phExactName": "Exact name",
      "phAmtMin": "Amount ≥",
      "phAmtMax": "Amount ≤",
      "sort": "Sort",
      "sortDefault": "Book default order",
      "sortAmtDesc": "Amount high to low",
      "sortAmtAsc": "Amount low to high",
      "sortName": "Name",
      "apply": "Apply",
      "reset": "Reset",
      "emptyTable": "No records yet. Click Add to start.",
      "colName": "Name",
      "colAmt": "Amount",
      "colGiftDate": "Gift date",
      "colCreated": "Added at",
      "dlgEditBook": "Edit book",
      "dlgNewBook": "New book",
      "bookName": "Book name",
      "phBookTitle": "e.g. Wedding, baby shower",
      "eventDate": "Event date (optional)",
      "phEventDate": "e.g. wedding day",
      "entryOrder": "Entry order",
      "orderHint": "Oldest first: earliest entries on top. Newest first: latest on top. Share pages follow this.",
      "descOpt": "Notes (optional)",
      "phDesc": "For your own reference",
      "dlgEditEntry": "Edit entry",
      "dlgAddEntry": "Add entry",
      "continueHint": "Stay open after save for rapid entry",
      "onceHint": "Close after save",
      "roundCount": "{n} added this round",
      "continueMode": "Rapid entry",
      "onceMode": "Add once",
      "phGuest": "Guest name",
      "amount": "Amount",
      "amountCN": "In words: {t}",
      "giftDateOpt": "Gift date (optional)",
      "phGiftDate": "Can be left empty",
      "phRemark": "Optional, e.g. cash / envelope",
      "saveEdit": "Save changes",
      "saveClose": "Save and close",
      "saveContinue": "Save and continue",
      "dlgEditShare": "Edit share",
      "dlgCreateShare": "Create share",
      "linkStable": "The share link does not change",
      "linkStableDesc": "You can change the title, books, and password. Existing links and mini-program codes still work.",
      "shareTitle": "Share title",
      "phShareTitle": "e.g. Wedding gift book",
      "pickBooks": "Books to include",
      "selectedN": "{n} / {total} selected",
      "selectAll": "Select all",
      "shareBooksTip": "Add or remove books. Visitors are always read-only. Entry changes appear on the share page immediately.",
      "accessPwd": "Access password",
      "accessPwdOpt": "Access password (optional)",
      "pwdSet": "Password is set",
      "clearPwd": "Remove password (make public)",
      "pwdKeepHint": "Leave empty without clearing to keep the old password. Enter a new one to replace it.",
      "pwdNewHint": "Leave empty for public access. Set a password to require it.",
      "genShare": "Create share",
      "resultBadge": "Fixed link · visitors read-only · edit anytime under My shares",
      "webShare": "Web share",
      "miniShare": "Mini program",
      "h5Title": "Open in browser",
      "h5Desc": "Copy the web link. Friends can view the book on phone or desktop.",
      "copyWebLink": "Copy web link",
      "openWindow": "Open in new window",
      "copyCopy": "Copy text",
      "miniTitle": "Open in WeChat mini program",
      "miniDesc": "Scan to open the mini program, or copy a direct link for WeChat.",
      "miniAlt": "Gift book mini-program code",
      "miniLoading": "Loading mini-program code…",
      "miniLink": "Mini program link",
      "dlMiniQr": "Download code",
      "copyOpenLink": "Copy open link",
      "miniFooter": "Prefer the mini-program code. If WeChat URL Link is enabled, Open link goes straight into the mini program. The H5 page can also jump there.",
      "shareAs": "Share “{t}”",
      "pwdPhNew": "Leave empty for public access",
      "pwdPhClear": "Password will be removed",
      "pwdPhKeep": "Leave empty to keep the current password",
      "pwdPhSet": "Set an access password (optional)",
      "exportedFilter": "Exported {label} with current filters",
      "exported": "Exported {label}",
      "needKeyword": "Enter a name or note keyword",
      "searchFail": "Search failed",
      "shareSuffix": "{t} share",
      "confirmDelBook": "Delete gift book “{t}”? Its entries will no longer be visible.",
      "needBookName": "Please enter a book name",
      "orderSetAsc": "Now showing oldest first",
      "orderSetDesc": "Now showing newest first",
      "setFail": "Could not update order",
      "needGuest": "Please enter a name",
      "addedNth": "Added entry #{n}",
      "added": "Added",
      "bookHash": "Book #{id}",
      "confirmDelEntry": "Delete the entry for “{n}”?",
      "needBook": "Select at least one book",
      "pwdLen": "Password must be 4–32 characters",
      "shareUpdated": "Share updated (link unchanged)",
      "shareCreated": "Share created",
      "generating": "Generating…",
      "genFail": "Generation failed",
      "copiedLink": "Link copied",
      "copiedWeb": "Web link copied",
      "copiedShare": "Share text copied",
      "copiedMini": "Mini program link copied",
      "copiedText": "Text copied",
      "confirmUnshare": "The share link will stop working (the code stays but will not open). Continue?",
      "unshareTitle": "Stop sharing",
      "unshared": "Sharing stopped"
    },
    om: {
      "eyebrow": "Digital menu · table ordering",
      "title": "Order menu",
      "lead": "Build menus and dishes, generate table codes. Guests scan to order in-house or enter an address for delivery. Set hours so orders stop after closing.",
      "quota": "Menu quota",
      "quotaMember": "Member · default {n}",
      "quotaFree": "Free · default {n}",
      "remain": "{n} more available",
      "newMenu": "New menu",
      "pendingN": "{n} pending",
      "orderAlert": "Order alerts",
      "alertBanner": "{n} pending orders — tap to handle them",
      "unmute": "Turn sound on",
      "mute": "Mute for now",
      "empty": "No menus yet — create one first",
      "pendingBadge": "{n} pending",
      "noDesc": "No description",
      "nDishes": "{n} dishes",
      "nTables": "{n} tables",
      "nOrders": "{n} orders",
      "dlgEdit": "Edit menu",
      "dlgNew": "New menu",
      "shopName": "Shop name",
      "phShop": "e.g. Green Apple Cafe",
      "shopLogo": "Shop logo",
      "changeLogo": "Change logo",
      "uploadLogo": "Upload logo",
      "logoHint": "Square image recommended. Converted to WebP. Not shown in the mini program.",
      "intro": "About",
      "phone": "Phone",
      "address": "Address",
      "notice": "Notice",
      "phNotice": "e.g. ¥5 off over ¥50",
      "orderWays": "Ordering",
      "dineIn": "Dine-in tables",
      "takeaway": "Takeaway",
      "detail": "Menu details",
      "pendingBar": "{n} pending · auto-refreshing",
      "goHandle": "Handle now",
      "orderPage": "Ordering page",
      "shareMini": "Share / mini-program code",
      "editInfo": "Edit info",
      "openNow": "Open",
      "closeNow": "Close",
      "hours": "Hours",
      "delMenu": "Delete menu",
      "tabDishes": "Dishes",
      "addDish": "Add dish",
      "colImg": "Img",
      "colName": "Name",
      "colCat": "Category",
      "colPrice": "Price",
      "colStatus": "Status",
      "onSale": "On sale",
      "offSale": "Unavailable",
      "onShelf": "Available",
      "delShort": "Del",
      "tabTables": "Tables",
      "addTable": "Add table",
      "batchCreate": "Batch create",
      "tableCode": "Table code",
      "copyLink": "Copy link",
      "copyText": "Text",
      "miniQr": "Mini-program code",
      "orders": "Orders",
      "ordersPending": "Orders ({n} pending)",
      "ordersN": "Orders ({n})",
      "st": {
        "pending": "Pending",
        "confirmed": "Confirmed",
        "preparing": "Preparing",
        "done": "Done",
        "cancelled": "Cancelled",
        "complete": "Done",
        "cancel": "Cancel"
      },
      "menuSt": {
        "active": "Open",
        "closed": "Closed",
        "disabled": "Disabled",
        "banned": "Banned"
      },
      "typeTakeaway": "Takeaway",
      "typeDine": "Dine-in",
      "liveWatch": "Live watch",
      "noOrders": "No orders",
      "orderedAt": "Ordered {t}",
      "updatedAt": " · updated {t}",
      "tableOf": "Table: {n}",
      "remarkOf": "Note: {t}",
      "print": "Print receipt",
      "tabNotify": "Alerts / print",
      "autoPoll": "Auto poll",
      "pollHint": "Fetch new orders while this page is open",
      "pollInterval": "Interval",
      "seconds": "sec",
      "beep": "Sound",
      "previewBeep": "Preview",
      "titleFlash": "Flash title",
      "pendingOnly": "Pending only",
      "printer": "Receipt printer",
      "enablePrint": "Enable print",
      "autoPrint": "Print new orders",
      "printerType": "Printer type",
      "gCloud": "Cloud print",
      "gLan": "LAN / in-store",
      "gOther": "Other",
      "brandFeie": "Feie Cloud",
      "brandYly": "Yilianyun",
      "brandXinye": "Xprinter Cloud",
      "brandPoscom": "Poscom Cloud",
      "brandShangpeng": "Shangpeng Cloud",
      "brandDaqu": "Daqu",
      "brandHprt": "HPRT Cloud",
      "brandJolimark": "Jolimark Cloud",
      "brandGeneric": "Generic cloud (any open API)",
      "brandLan": "LAN ESC/POS (IP:9100)",
      "brandAgent": "Local print agent",
      "brandQueue": "Offline queue (agent pull)",
      "brandWebhook": "Custom webhook",
      "brandNone": "Not configured",
      "deviceName": "Device label",
      "phDevice": "e.g. bar Feie / kitchen Xprinter",
      "receiptStyle": "Receipt style",
      "styleClassic": "Classic guest",
      "styleCompact": "Compact",
      "styleKitchen": "Kitchen",
      "paperWidth": "Paper width",
      "showPrice": "Show prices",
      "footer": "Footer text",
      "phFooter": "Thanks for visiting",
      "copies": "Copies",
      "devAccount": "Developer / account",
      "savedSecret": "Saved — leave empty to keep",
      "phPlatform": "Platform account or developer ID",
      "ukey": "UKEY",
      "printerSn": "Printer SN",
      "phSn": "SN / device ID",
      "appId": "App ID",
      "appSecret": "App secret",
      "terminal": "Terminal ID",
      "terminalKey": "Terminal key",
      "merchant": "Merchant ID",
      "apiKey": "API key",
      "deviceSn": "Device ID",
      "phOrAccount": "Or fill in the account field",
      "backupUser": "Backup account",
      "phUserField": "Some brands use the user field",
      "backupKey": "Backup key",
      "apiUrl": "API URL",
      "phApiOverride": "Override the brand default open API URL",
      "appLikeTip": "Fill in from Daqu / HPRT / Jolimark docs. You can change the API URL if the vendor updates it.",
      "preset": {
        "custom": "Custom",
        "feie_compat": "Feie-compatible",
        "xinye_compat": "Xprinter-compatible",
        "poscom_compat": "Poscom-compatible",
        "shangpeng": "Shangpeng open platform",
        "daqu": "Daqu open platform",
        "hprt": "HPRT open platform",
        "jolimark": "Jolimark open platform",
        "bearer_json": "Bearer + JSON",
        "webhook_json": "JSON webhook"
      },
      "cloudPreset": "Protocol preset",
      "apiAddr": "API URL",
      "phVendorApi": "https://vendor-open-api/print",
      "authMode": "Auth",
      "signFeie": "Feie sign",
      "signXinye": "Xprinter sign",
      "signPoscom": "Poscom sign",
      "signNone": "No signature",
      "body": "Body",
      "contentFmt": "Content format",
      "fmtPlain": "Plain text",
      "fmtFeie": "Feie tags",
      "successCode": "Success code",
      "phSuccess": "Default 0",
      "userAppId": "Account / AppId",
      "phUser": "user / account",
      "appIdAlt": "AppId (alt)",
      "secret": "Secret",
      "genericTip": "Use Generic cloud when the brand is not listed: pick auth/format from the vendor docs and fill in the API.",
      "printerIp": "Printer IP",
      "port": "Port",
      "lanHint": "Default 9100 · the API server must be on the same LAN as the printer",
      "agentUrl": "Agent URL",
      "agentToken": "Agent token",
      "phCustomKey": "Custom secret",
      "agentTip": "For USB/LAN receipt printers: copy api/scripts/order-menu-local-agent.js to an in-store PC and run it.",
      "pullToken": "Pull token",
      "phQueueKey": "Secret used by the agent to poll",
      "queueTip": "Offline queue: GET /api/tools/order-menus/{id}/print-queue/pull?token=TOKEN",
      "saveSettings": "Save settings",
      "previewReceipt": "Preview receipt",
      "testPrint": "Test print",
      "cloudTip": "Cloud printers must be bound on their platform. Generic cloud can connect other brands that publish an open API.",
      "previewDlg": "Receipt preview",
      "styleShortClassic": "Classic",
      "styleShortCompact": "Compact",
      "styleShortKitchen": "Kitchen",
      "plainContent": "Plain text",
      "refreshPreview": "Refresh preview",
      "dishDlg": "Dish",
      "phCat": "Featured / mains / drinks",
      "phUnit": "ea",
      "catRecommend": "Featured",
      "unitPortion": "ea",
      "uploadImg": "Upload image",
      "batchDlg": "Batch create tables",
      "count": "Count",
      "namePrefix": "Name prefix",
      "phPrefix": "Optional; default is Table 1…",
      "hoursEnabled": "Limit hours",
      "hoursHint": "Off = order all day. On = only during open hours.",
      "start": "Opens",
      "end": "Closes",
      "openDays": "Open days",
      "dow": {
        "0": "Sun",
        "1": "Mon",
        "2": "Tue",
        "3": "Wed",
        "4": "Thu",
        "5": "Fri",
        "6": "Sat"
      },
      "shareTable": "Share table · {n}",
      "shareMenu": "Share menu · {n}",
      "qrLoading": "Loading mini-program code…",
      "orderLink": "Order link",
      "webBackup": "Web fallback",
      "copyShareText": "Copy share text",
      "shareTip": "Send guests the Order link (opens in browser/WeChat). Scan the mini-program code to enter the mini program. Mini-program path is for developers, not a URL.",
      "advPath": "Advanced: mini-program path",
      "path": "Path",
      "today": "Today {t}",
      "yesterday": "Yesterday {t}",
      "previewFail": "Preview failed",
      "newOrderTitle": "New order",
      "newOrderMsg": "{n} new order(s) — please handle them",
      "newOrderNotify": "New dine-in order",
      "newOrderBody": "{n} new order(s) waiting",
      "flashTitle": "[New ×{n}]",
      "needShop": "Please enter a shop name",
      "notifySaved": "Alert and printer settings saved",
      "testSent": "Test receipt sent",
      "testFail": "Test failed",
      "printed": "Sent to printer",
      "printFail": "Print failed",
      "closedOk": "Closed",
      "openedOk": "Open",
      "hoursSaved": "Hours saved",
      "confirmDelMenu": "This cannot be undone. Delete this menu?",
      "imgUploaded": "Image uploaded",
      "uploadFail": "Upload failed",
      "logoUploaded": "Logo uploaded (WebP)",
      "needDish": "Please enter a dish name",
      "confirmDelDish": "Delete this dish?",
      "tableName": "Table name",
      "tableDefault": "Table {n}",
      "tablesCreated": "Tables created",
      "createFail": "Create failed",
      "confirmDelTable": "Delete table “{n}”?",
      "loadOrdersFail": "Failed to load orders",
      "orderUpdated": "Order updated",
      "updateFail": "Update failed",
      "copiedOrder": "Order link copied",
      "copiedPath": "Path copied",
      "qrNameTable": "table-{n}-mini-code.png",
      "qrNameMenu": "menu-{n}-mini-code.png"
    },
    er: {
      "eyebrow": "Read · compare · share",
      "title": "Electricity logs",
      "lead": "Manage rooms and meters, record readings, and compare the main meter with the sum of sub-meters versus last month. Share with a password (remembered 30 days on this device), or enable an open API so devices/scripts can post readings.",
      "quota": "Room quota",
      "remain": "{n} more rooms available",
      "monthsFree": "Free plan: last {n} months",
      "monthsMember": "Members can see all periods",
      "myRooms": "My rooms",
      "newRoom": "New room",
      "emptyRooms": "No rooms yet",
      "shareRoom": "Share room",
      "metersMeta": "{n} meters · {pwd}",
      "defaultPrice": "Default {p} ¥/kWh",
      "noPrice": "No rate set (preview hides amounts)",
      "hideCost": " · amounts hidden on share",
      "fromYm": " · shown from {ym}",
      "exportTable": "Export table",
      "expCurrent": "Export this month",
      "expPrev": "Export this + last month",
      "expCompare": "Export vs last month",
      "expCsv": "Export this month CSV",
      "tabSummary": "Period summary",
      "emptySummary": "No readings yet — add one first",
      "vsYm": "vs {ym}",
      "expMonth": "That month",
      "expMonthPrev": "That month + previous",
      "expMonthCmp": "Compare previous",
      "mainUsage": "Main usage",
      "vsLast": "vs last month {d}",
      "subTotal": "Sub-meter sum",
      "mainMinus": "Main − subs",
      "gapHint": "Difference can estimate common-area use",
      "kindMain": "Main",
      "kindSub": "Sub",
      "readingOf": "Reading {v}",
      "usageOf": "Usage {v}",
      "tabMeters": "Meters & readings",
      "addMeter": "Add tenant meter",
      "ownPwd": "Own password",
      "ownPrice": "Custom {p} ¥/kWh",
      "inheritPrice": "Inherit {p} ¥/kWh",
      "noBill": "Not billed",
      "reading": "Reading",
      "emptyReadings": "No readings",
      "colPeriod": "Period",
      "colReading": "Reading",
      "colUsage": "Usage",
      "colCost": "Cost",
      "colAt": "Read at",
      "emptyMain": "Select a room on the left, or create one to start",
      "dlgEditRoom": "Edit room",
      "dlgNewRoom": "New room",
      "name": "Name",
      "phRoom": "e.g. Building 3",
      "address": "Address",
      "defaultTariff": "Default rate",
      "yuanKwh": "¥/kWh (0 = no billing, preview hides amounts)",
      "shareCost": "Share amounts",
      "showFee": "Show cost",
      "usageOnly": "Usage only",
      "accessPwd": "Access password",
      "phPwd": "Leave empty to keep; empty on create = public",
      "clearPwd": "Remove password",
      "dlgEditMeter": "Edit meter",
      "dlgAddMeter": "Add meter",
      "phMeter": "e.g. Apt 101 / shop",
      "tariff": "Rate",
      "inheritRoom": "Use room default",
      "customTariff": "Custom rate",
      "meterPriceTip": "Custom rate applies to this tenant only. Not billed also hides amounts in preview.",
      "followRoom": "Follow room",
      "show": "Show",
      "hide": "Hide",
      "ownPwdPh": "Leave empty to use the room password",
      "clearOwnPwd": "Remove own password",
      "dlgReading": "Reading · {n}",
      "readingValue": "Meter reading",
      "readingAt": "Read at",
      "period": "Period",
      "phPeriod": "YYYY-MM, can follow read time",
      "shareDlg": "Share",
      "shareTip": "Copy the link for tenants, or generate a mini-program code. After the password is entered, this device remembers it for 30 days.",
      "qrAlt": "Mini-program code",
      "genMini": "Generate mini-program code",
      "apiDlg": "Open API · {n}",
      "apiLeadStrong": "Members only.",
      "apiLead": "Smart meters, scripts, or third parties can post readings with a token. New readings show immediately in summaries, lists, and share previews. Auth header: X-Electric-Token (or query/body token).",
      "apiFreeTitle": "Open API is not available on the free plan",
      "apiFreeDesc": "Become a member to enable a token. Tokens stop working if membership expires.",
      "meterCode": "Meter code {c}",
      "tokenOnce": "Shown only when enabling/rotating. Store it safely; rotate if leaked.",
      "submitReading": "Submit reading",
      "queryLatest": "Latest / list",
      "tierCustomAdmin": "Admin quota",
      "tierMember": "Member quota",
      "tierCustom": "Custom quota",
      "tierFree": "Free quota",
      "loadDetailFail": "Failed to load details",
      "confirmDelRoom": "Delete room “{n}”?",
      "needMeterName": "Please enter a meter name",
      "confirmDelMeter": "Delete meter “{n}”? Readings stay in the database but will no longer be shown.",
      "needReading": "Please enter a reading",
      "readingSaved": "Reading saved",
      "confirmDelReading": "Delete this reading?",
      "expMode": {
        "current": "this month",
        "current_prev": "this + last month",
        "compare": "vs last month",
        "meter": "meter this + last month"
      },
      "exported": "Exported {m} table",
      "qrUnavailable": "Mini-program code unavailable — share the link instead",
      "loadApiFail": "Failed to load API info",
      "apiMemberOnly": "Open API is members-only. Please become a member first.",
      "rotateConfirm": "The old token will stop working immediately. Continue?",
      "enableConfirm": "A token will be able to post readings to this meter. Generate it?",
      "tokenOk": "Token generated",
      "closeApiConfirm": "Third parties will no longer be able to post. Continue?",
      "closeApiTitle": "Turn off open API",
      "closed": "Turned off"
    },
    tb: {
      "eyebrow": "Collaborate · assign · audit",
      "title": "Task board",
      "lead": "Create boards, grant members or invite links. Submit tasks with images (auto WebP), assign, and reject with a reason. Members can enable an open API for scripted submits.",
      "boards": "Boards",
      "quotaFreeMember": "Free {free} · Member {member}",
      "remain": "{n} more available",
      "perBoard": "Tasks / board",
      "quotaTaskFree": "Free {n} · members unlimited",
      "byOwner": "Based on the board owner’s membership",
      "myBoards": "My boards",
      "newBoard": "New board",
      "phBoardSearch": "Search name or description…",
      "nTasks": "{n} tasks",
      "noMatchBoard": "No matching boards",
      "emptyBoards": "No boards yet",
      "noDesc": "No description",
      "boardTasks": "Tasks on this board",
      "remainSubmit": " · {n} more can be submitted",
      "memberUnlimited": " · unlimited for members (cap {n})",
      "copyReadonly": "Copy read-only link",
      "tabTasks": "Tasks",
      "phTaskSearch": "Search title, notes, submitter, assignee…",
      "submitTask": "Submit task",
      "showing": "Showing {n}",
      "noMatchTask": "No matching tasks",
      "emptyTasks": "No tasks yet",
      "submittedBy": "From {n}",
      "executor": "Assignee {n}",
      "unassigned": "Unassigned",
      "due": " · due {d}",
      "rejectOf": "Rejected: {r}",
      "doing": "In progress",
      "complete": "Done",
      "reject": "Reject",
      "reopen": "Reopen",
      "assign": "Assign",
      "tabMembers": "Members",
      "phUsername": "Username",
      "tabInvites": "Invite links",
      "phLabel": "Label",
      "phOptPwd": "Optional password",
      "genInvite": "Create invite",
      "colUser": "User",
      "colRole": "Role",
      "colLink": "Link",
      "pwdDot": " · password",
      "disabledDot": " · revoked",
      "revoke": "Revoke",
      "tabLogs": "Log",
      "system": "System",
      "emptyLogs": "No log entries",
      "emptyMain": "Select a board on the left, or create one to start",
      "dlgEdit": "Edit board",
      "dlgNew": "New board",
      "name": "Name",
      "desc": "Description",
      "accessPwd": "Access password",
      "phReadonlyPwd": "Optional for read-only sharing",
      "clearPwd": "Remove password",
      "anon": "Anonymous submit",
      "anonOn": "Invite link can submit without login",
      "mustLogin": "Login required",
      "anonTip": "If off, visitors on the invite link must sign in before submitting tasks or uploading images.",
      "hideSubmitter": "Hide submitter",
      "hideViewer": "Hide from viewers",
      "notifyTitle": "New-task alerts",
      "notifyLead": "Add multiple emails and mini-program subscribers. All of them are notified. Takes effect after save.",
      "emailNotify": "Email alerts",
      "emailCount": "Up to 10 · {n} added",
      "addEmail": "Add email",
      "emptyEmail": "No emails yet — add one at the top right",
      "phEmail": "Email address",
      "phLabelOpt": "Label (optional)",
      "mailOff": "If server mail is not enabled, email alerts may not arrive.",
      "miniNotify": "Mini-program subscribe",
      "miniTpl": "Task ticket alert",
      "miniCount": "{title} · {n}/{total} added",
      "saveFirst": "Create and save the board first, then add mini-program recipients.",
      "noTpl": "No subscribe template. Set mini_subscribe_task_submit in api/config/wechat.php.",
      "addMyself": "Add me",
      "phSiteUser": "Site username",
      "addUser": "Add user",
      "wxUnbound": "You have not bound WeChat yet. Sign in via the mini program, or bind in your profile first.",
      "miniTip": "WeChat subscribe messages are one-shot. In the mini program, tick “always keep this choice” and restock, or renew each visit. Email is more reliable long-term.",
      "emptyMini": "No mini-program recipients",
      "wxUser": "WeChat user",
      "joinedAt": "Added {t}",
      "lastAuth": "Last grant {t} · ~{n} left",
      "notAuth": "Not subscribed in the mini program yet",
      "remove": "Remove",
      "dlgTask": "Submit task",
      "taskTitle": "Title",
      "taskBody": "Details",
      "priority": "Priority",
      "priLow": "Low",
      "priNormal": "Normal",
      "priHigh": "High",
      "assignTo": "Assign",
      "phAssignee": "Assignee nickname (optional)",
      "images": "Images",
      "imgHint": "Click to upload, or Ctrl + V to paste a screenshot · converted to WebP",
      "uploading": "Uploading…",
      "submit": "Submit",
      "dlgReject": "Reject task",
      "rCannot": "Not feasible",
      "rDelay": "Needs more time",
      "rInfo": "Not enough info",
      "rCustom": "Custom",
      "phReject": "Enter a reject reason",
      "confirmReject": "Confirm reject",
      "dlgAssign": "Assign",
      "pickMember": "Choose a member",
      "orNick": "Or enter a nickname",
      "apiDlg": "Open API · {n}",
      "apiLeadStrong": "Board owner must be a member.",
      "apiLead": "Scripts or third parties can submit/query tasks with a token. Auth header: X-Task-Token (or query/body token).",
      "apiFreeTitle": "Open API is not available on the free plan",
      "apiFreeDesc": "Become a member to enable a token. Tokens stop working if membership expires.",
      "boardCode": "Board code {c}",
      "tokenOnce": "Shown only when enabling/rotating. Store it safely; rotate if leaked.",
      "submitApi": "Submit task",
      "queryApi": "Query tasks",
      "tierCustom": "Custom quota",
      "tierMember": "Member quota",
      "tierFree": "Free quota",
      "taskTierCustom": "Custom task quota",
      "taskTierMember": "Member task quota",
      "taskTierFree": "Free task quota",
      "all": "All",
      "st": {
        "pending": "Pending",
        "doing": "In progress",
        "done": "Done",
        "rejected": "Rejected"
      },
      "role": {
        "owner": "Owner",
        "submitter": "Can submit",
        "executor": "Can execute",
        "viewer": "View only"
      },
      "shareRole": {
        "view": "View only",
        "submit": "Can submit",
        "execute": "Can execute"
      },
      "log": {
        "board_create": "Created board",
        "board_update": "Updated board",
        "board_delete": "Deleted board",
        "member_add": "Added member",
        "member_update": "Updated member",
        "member_remove": "Removed member",
        "share_create": "Created invite",
        "share_disable": "Revoked invite",
        "task_create": "Submitted task",
        "task_update": "Updated task",
        "task_status": "Changed status",
        "task_reject": "Rejected task",
        "task_delete": "Deleted task",
        "admin_status": "Admin changed status",
        "admin_update": "Admin edited",
        "admin_delete": "Admin deleted"
      },
      "maxEmail": "You can add at most 10 emails",
      "miniAdded": "Added. Open the mini program to finish subscribe authorization.",
      "addFail": "Add failed",
      "needUsername": "Please enter a site username",
      "userAdded": "User added",
      "copiedCode": "Code copied",
      "maxOa": "You can bind at most 8 Official Account users",
      "followOa": "Follow the Official Account and send this code: {c}",
      "bindFail": "Failed to create bind info",
      "oaBound": "Official Account bound. You can add more people.",
      "codeExpired": "Bind code expired. Generate a new one.",
      "qrExpired": "QR code expired. Generate a new one.",
      "confirmUnbindOne": "Remove this Official Account recipient?",
      "confirmUnbindAll": "Unbind all Official Accounts?",
      "unbindTitle": "Remove bind",
      "removed": "Removed",
      "unbindFail": "Unbind failed",
      "loadDetailFail": "Failed to load details",
      "needEmail": "Enter an email, or turn this row off",
      "badEmail": "Invalid email: {m}",
      "createdOa": "Created. To use Official Account alerts, edit again and add a bind.",
      "confirmDelBoard": "Delete “{n}”?",
      "taskFull": "This board has reached its task limit",
      "loadApiFail": "Failed to load API info",
      "apiMemberOnly": "Open API is members-only. Please become a member first.",
      "rotateConfirm": "The old token will stop working immediately. Continue?",
      "enableConfirm": "A token will be able to submit tasks. Generate it?",
      "enabledOk": "Enabled",
      "closeApiConfirm": "Third parties will no longer be able to submit. Continue?",
      "closeApiTitle": "Turn off open API",
      "closed": "Turned off",
      "maxImg": "Up to 9 images",
      "imgAdded": "Image added (WebP)",
      "uploadFail": "Upload failed",
      "needTitle": "Please enter a title",
      "submitted": "Submitted",
      "submitFail": "Submit failed",
      "fail": "Failed",
      "needReject": "Please enter a reject reason",
      "rejected": "Rejected",
      "assigned": "Assigned",
      "confirmDelTask": "Delete this task?",
      "needUser": "Please enter a username",
      "added": "Added",
      "confirmRemoveMember": "Remove member {n}?",
      "inviteOk": "Invite created",
      "confirmRevoke": "Revoke this invite link?",
      "revoked": "Revoked"
    },
    live: {
      "eyebrow": "Content changes · code stays",
      "title": "Live QR",
      "lead": "Write rich text, or describe a page/form for AI to generate. Set access dates and a password, then get a fixed QR. Mini-program codes are recommended.",
      "quota": "Create quota",
      "quotaDefault": "How many live codes you can save",
      "remain": "{n} remaining",
      "today": "Today",
      "aiQuota": "AI generations",
      "editLive": "Edit live code",
      "newLive": "New live code",
      "cancelEdit": "Cancel edit",
      "liveTitle": "Title",
      "phTitle": "Title shown after scanning",
      "contentMode": "Content mode",
      "richtext": "Rich text",
      "aiPage": "AI page",
      "body": "Body",
      "phBody": "Write content. Images are supported…",
      "kind": "Type",
      "kindMini": "Open in mini program",
      "kindMiniDesc": "Scan the mini-program code — recommended",
      "kindPage": "Web page",
      "kindPageDesc": "Full H5 — open with the web link",
      "kindForm": "Web form",
      "kindFormDesc": "Sign-up form — open with the web link",
      "kindTip": "Individual mini programs cannot embed full web pages. “Open in mini program” generates rich text you can scan. For web page/form, share the web code or link.",
      "describe": "Describe the page you want",
      "formLimit": "Visitor upload limit",
      "off": "Off",
      "formLimitHint": "Takes effect after you save. Follows the current account rules (free/member or admin override).",
      "prepImgs": "Prepare images (optional)",
      "prepImgsDesc": "Inserted after generate: top / after title / before form / bottom. Converted to WebP, up to 12.",
      "uploading": "Uploading…",
      "uploadImg": "Upload images",
      "pickedImgs": "{n}/12 selected",
      "uploadingN": " · uploading {n}",
      "failN": " · failed {n}",
      "uploadingShort": "Uploading",
      "failed": "Failed",
      "imgName": "Image",
      "phImgCaption": "Caption (optional)",
      "pos": "Position",
      "posTop": "Top of page",
      "posAfterTitle": "After title",
      "posBeforeForm": "Before form",
      "posBottom": "Bottom of page",
      "uploadFailRetry": "Upload failed. Remove and retry.",
      "uploaded": "Uploaded",
      "remove": "Remove",
      "emptyImgs": "No images yet. They appear here right after you upload.",
      "docs": "Reference documents (optional)",
      "docsDesc": "Sent to AI as context, not visitor uploads. PDF / Office / WPS / TXT. No audio or video.",
      "uploadDoc": "Upload documents",
      "docLimit": "Max {limit} per file · {n}/12 selected",
      "uploadingSize": "Uploading… {s}",
      "uploadFail": "Upload failed",
      "uploadedSize": "Uploaded · {s}",
      "emptyDocs": "No documents yet. They appear here right after you upload.",
      "todayChip": "Today {n}",
      "totalChip": "Total {n}",
      "aiWorking": "AI generating…",
      "regen": "Regenerate",
      "genPage": "Generate page",
      "fullPreview": "Full-screen preview",
      "htmlReady": "Ready — you can save the live code",
      "aiShort": "Not enough AI generations",
      "formNote": "Forms post to this site. After save, view/export under Form data. Audio/video content is not supported.",
      "visitorUpload": "Visitor uploads: {h}",
      "livePreview": "Live preview",
      "formMode": "Form",
      "pageMode": "Page",
      "htmlPreview": "HTML preview",
      "startDate": "Start date (optional)",
      "phStart": "Empty = starts immediately",
      "endDate": "End date (optional)",
      "phEnd": "Empty = no expiry",
      "accessPwd": "Access password (optional)",
      "phPwdEdit": "Leave empty to keep; enter a new one to change; Clear removes it",
      "phPwdNew": "Leave empty for public access",
      "clearPwd": "Remove password",
      "saveEdit": "Save changes",
      "genLive": "Create live code",
      "auditTip": "New or edited content needs admin approval before scanning works. The QR itself does not change.",
      "myLives": "My live codes ({n})",
      "empty": "No live codes yet — create the first one on the left",
      "accessOn": "Access on",
      "accessOff": "Off",
      "banned": "Banned",
      "noPreview": "(no text preview) tap to view",
      "views": "{n} views",
      "formsN": "{n} form rows",
      "view": "View",
      "qr": "QR",
      "formData": "Form data",
      "copyLink": "Copy link",
      "pagePreview": "Page preview",
      "formTotal": "{n} submissions",
      "expSplitXlsx": "Excel · columns",
      "expMergeXlsx": "Excel · merged",
      "expSplitCsv": "CSV · columns",
      "expMergeCsv": "CSV · merged",
      "emptySubs": "No submissions yet",
      "colAt": "Submitted",
      "colFields": "Form fields",
      "downloadFile": "Download file",
      "liveFallback": "Live code",
      "resultTip": "Prefer the mini-program code so WeChat opens the mini program. The web code is for H5 in a browser. Full web/form live codes cannot embed in an individual mini program — also send the web link.",
      "miniRecommend": "Mini-program code (recommended)",
      "webQr": "Web QR",
      "copyWeb": "Copy web link",
      "webQrAlt": "Web QR",
      "miniQrAlt": "Mini-program code",
      "loading": "Loading…",
      "scanMini": "Scan in WeChat · opens the mini program",
      "copyWebFallback": "Copy web link as fallback",
      "audit": "Review: {s}",
      "auditSt": {
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "phForm": "e.g. An event signup with name, phone, party size, and notes; clean style, teal accent, easy on phones…",
      "phPage": "e.g. A cafe menu with shop name, three drinks, hours and address; fresh cards, easy on phones…",
      "formDataOf": "Form data · {t}",
      "aiTotalUnlim": "Used {n} times in total (unlimited)",
      "aiTotal": "Total {used}/{limit} · {left} left",
      "aiHint": "Describe what you need to generate a page",
      "docMember": "Member 30MB",
      "docFree": "Free 10MB",
      "formOff": "Off",
      "formCustom": " (custom)",
      "formRule": "{size} per file · up to {n} files{custom}",
      "maxImgs": "Up to 12 images",
      "qtyLimit": "Limit reached",
      "noImgUrl": "No image URL returned",
      "imgUploaded": "Image uploaded",
      "imgUploadFail": "Image upload failed",
      "maxDocs": "Up to 12 documents",
      "noAv": "Audio and video are not allowed",
      "typeDeny": "Type not allowed",
      "docName": "Document",
      "noDocUrl": "No document URL returned",
      "docUploaded": "Document uploaded",
      "docUploadFail": "Document upload failed",
      "needPrompt": "Describe the page you want first",
      "waitUpload": "Files are still uploading. Wait before generating.",
      "dropFailed": "Some uploads failed. Remove them, then generate.",
      "miniGenOk": "Mini-program body generated. Save, then scan the mini-program code.",
      "pageBound": "Page generated (submit API bound)",
      "pageForm": "Page generated. After you save, the form can receive data. Share the web link.",
      "pageOk": "Page generated. Open full web pages with the web link or web QR.",
      "genFailDs": "Generation failed. Check the DeepSeek setup.",
      "needTitle": "Please enter a title",
      "needHtml": "Generate the HTML page first",
      "savedForm": "Saved. Visitor form data is under Form data.",
      "loadFormFail": "Failed to load form data",
      "layoutMerge": "merged",
      "layoutSplit": "columns",
      "exported": "Exported {label} ({layout})",
      "confirmDelSub": "Delete this submission?",
      "confirmClear": "Clear all submissions for this live code? This cannot be undone.",
      "warn": "Warning",
      "cleared": "Cleared",
      "clearFail": "Clear failed",
      "accessEnabled": "Access turned on",
      "accessDisabled": "Access turned off",
      "confirmDelLive": "Delete “{t}”? The QR will no longer open.",
      "delLive": "Delete live code",
      "copiedLink": "Link copied",
      "cannotOpen": "This live code cannot be opened",
      "bannedView": "This live code is banned",
      "closedAsk": "Access is off, so visitors cannot open it. Turn it on and view the real page?",
      "viewLive": "View live code",
      "openAndView": "Turn on and view",
      "opened": "Access turned on",
      "openFail": "Could not turn on",
      "miniLoading": "Loading mini-program code…",
      "miniFail": "Failed to generate mini-program code",
      "genFail": "Generation failed"
    },
    wifi: {
      "eyebrow": "Share safely · scan to join",
      "title": "WiFi link",
      "lead": "Save the SSID and password, then generate a mini-program code. Guests scan in WeChat and connect without hearing the password.",
      "quota": "Create quota",
      "quotaDefault": "Using the site default quota",
      "remain": "{n} remaining",
      "edit": "Edit WiFi",
      "add": "Add WiFi",
      "cancelEdit": "Cancel edit",
      "ssid": "Network name (SSID)",
      "phSsid": "e.g. Home-5G",
      "security": "Security",
      "securityHint": "Select all that match your router. “Open” cannot be combined with other types.",
      "nopass": "Open",
      "password": "WiFi password",
      "phPassword": "Enter WiFi password",
      "remarkOpt": "Note (optional)",
      "phRemark": "e.g. living-room router",
      "hidden": "Hidden network",
      "saveEdit": "Save changes",
      "genCode": "Create share code",
      "myList": "My WiFi ({n})",
      "empty": "No WiFi yet — add the first one on the right",
      "viewQr": "View mini-program code",
      "copyOpen": "Copy open link",
      "scanN": "Scanned {n} times",
      "miniQr": "Mini-program code",
      "copyLink": "Copy link",
      "stdQr": "Standard QR",
      "miniAlt": "WiFi mini-program code",
      "qrLoading": "Loading mini-program code…",
      "qrTip": "Scan in WeChat to open the join page, or copy the link below.",
      "openLink": "Open link",
      "dlMini": "Download mini-program code",
      "copyOpenBtn": "Copy open link",
      "copyShare": "Copy share text",
      "footerTip": "“Open link” opens the share page with the mini-program code. If WeChat URL Link is enabled, the WeChat deep link is preferred.",
      "shareOf": "Share “{ssid}”",
      "openNet": "Open network",
      "needSsid": "Please enter the WiFi name",
      "needPwd": "Enter a password, or choose Open",
      "copiedOpen": "Open link copied",
      "noOpenLink": "Could not create an open link",
      "confirmDel": "Delete “{ssid}”? The mini-program code will stop working.",
      "delTitle": "Confirm delete",
      "qrFail": "Could not create the mini-program code. Check WeChat settings.",
      "copiedOpenShare": "Open link copied — send it to friends",
      "copiedShare": "Share text copied",
      "noStdQr": "Could not create a standard QR",
      "stdQrFail": "Failed to create standard QR"
    },
    epub: {
      "badge": "DeepSeek · EPUB",
      "title": "Translate foreign EPUB to ebook",
      "leadBefore": "Upload a foreign-language novel EPUB, keep the layout, and export a readable ebook in your target language.",
      "leadAfter": "Only translate content you have the right to process.",
      "daily": "Lifetime quota",
      "lifetime": "Lifetime quota",
      "uploadMax": "Upload limit",
      "identity": "Plan",
      "member": "Member",
      "free": "Free",
      "keep": "Keep results",
      "hours": "{n} hours",
      "keepHint": "Downloads stop after this window. Files stay on the server until an admin deletes them. Matching translations are reused instantly and do not use a new slot.",
      "cannot": "Cannot submit right now",
      "blockDisabled": "EPUB translation is turned off",
      "blockBanned": "This account cannot use this tool",
      "blockEngine": "Translation engine is not ready. Try later or contact an admin.",
      "blockExhausted": "No translation slots left ({n} total)",
      "newJob": "New translation",
      "targetLang": "Target language",
      "phLang": "Choose a language",
      "drop": "Drop an EPUB here, or click to choose",
      "dropHint": ".epub only · max {n} MB · images are not modified",
      "changeFile": "Change file",
      "clear": "Clear",
      "jobN": "Job #{id}",
      "chapterProg": "Chapters {done} / {total}",
      "dlEpub": "Download EPUB",
      "abort": "Stop",
      "refreshProg": "Refresh progress",
      "myJobs": "My jobs",
      "loading": "Loading…",
      "empty": "No jobs yet — upload an EPUB to start",
      "remain": "{left} / {limit} left",
      "supportBoth": "Text and image-based novels are supported.",
      "supportText": "Text-based novels are supported.",
      "tipOcr": "Image OCR is on: text EPUBs and scanned novels (body in JPG/PNG) are supported.",
      "tipText": "Text-based novels are supported (readable text in HTML/XHTML).",
      "waitExpired": "Expired — download is closed. An admin still holds the file.",
      "waitFail": "Translation failed. Check the error and retry.",
      "waitCancel": "Job stopped",
      "waitRun": "Translating chapter by chapter. Progress refreshes automatically; long books take time.",
      "start": "Start translation",
      "hashing": "Checking file…",
      "reuseHit": "Instant upload…",
      "creating": "Submitting…",
      "uploadingPct": "Uploading {n}%",
      "processing": "Working…",
      "phaseHash": "Computing file fingerprint (for instant upload)…",
      "phaseReuse": "Same translation found — instant upload…",
      "phaseCreate": "Source already stored — creating job…",
      "phaseUpload": "Uploading in chunks {n}%",
      "phaseWait": "Working, please wait…",
      "refreshFail": "Refresh failed",
      "needEpub": "Please upload a .epub file",
      "tooLarge": "File exceeds the {n} MB limit",
      "reusedOk": "Instant upload succeeded — added to your jobs",
      "submitted": "Submitted — job list updated",
      "submitFail": "Submit failed",
      "doneOk": "Translation finished — ready to download",
      "aborted": "Stopped",
      "abortFail": "Could not stop",
      "confirmDel": "Remove this job from your list? The slot is not refunded. Files stay until an admin deletes them.",
      "dlFail": "Download failed",
      "st": {
        "pending": "Pending",
        "queued": "Queued",
        "processing": "Translating",
        "done": "Done",
        "failed": "Failed",
        "cancelled": "Stopped",
        "expired": "Expired",
        "deleted": "Deleted"
      },
      "langZhCN": "Simplified Chinese",
      "langZhTW": "Traditional Chinese"
    },
    doc: {
      "quota": "Create quota",
      "sharing": "Sharing",
      "closed": "Off",
      "views": "{n} views",
      "recent": " · last {t}",
      "more": "More",
      "viewsLog": "Access log",
      "closeShare": "Turn off sharing",
      "openShare": "Turn on sharing",
      "sealUpload": "Upload seal",
      "sealTip": "Converted to WebP and embedded. Identical files are reused by hash.",
      "sealReused": "Reused an existing seal",
      "sealOk": "Seal uploaded",
      "shareClosed": "Sharing turned off",
      "shareOpened": "Sharing turned on",
      "delConfirm": "Confirm delete",
      "viewsOk": "Views",
      "prints": "Prints",
      "exports": "Exports",
      "total": "Total",
      "emptyViews": "No access yet",
      "colTime": "Time",
      "colFrom": "Source",
      "colStatus": "Status",
      "qrLoading": "Loading mini-program code…",
      "print": "Print",
      "dlPdf": "Download / export PDF",
      "layout": "Layout",
      "classic": "Classic slip",
      "modern": "Modern",
      "cornerCode": "Corner code",
      "codeNone": "None",
      "codeH5": "Web QR only",
      "codeMini": "Mini-program only",
      "codeBoth": "Both",
      "autoNo": "Leave empty to auto-generate",
      "seal": "Seal",
      "contact": "Contact",
      "remark": "Notes",
      "operator": "Handled by",
      "title": "Document title",
      "quotaAdminYou": "Set for you by admin"
    },
    receipt: {
      "eyebrow": "Formal slip · print & share",
      "title": "Receipt",
      "lead": "Fill in payment details, upload a seal, then print or share via H5 / mini program. Member-made receipts hide the footer credit by default.",
      "remain": "{n} remaining",
      "phSearch": "Search number / payer / issuer / reason",
      "newItem": "New receipt",
      "empty": "No receipts yet — click New receipt to start",
      "dlgEdit": "Edit receipt",
      "dlgNew": "New receipt",
      "receiptNo": "Receipt No.",
      "issuer": "Payee",
      "phIssuer": "Issuer / payee",
      "payer": "Payer",
      "amount": "Amount",
      "payMethod": "Payment method",
      "issueDate": "Issue date",
      "reason": "Reason",
      "address": "Address",
      "headerNote": "Header note",
      "phHeader": "Optional subtitle",
      "footerNote": "Footer note",
      "phFooter": "e.g. Handwritten copies are invalid",
      "cornerTip": "The corner QR on print/share pages opens this receipt again",
      "shareTitle": "Share receipt",
      "shareTip": "Scan the mini-program code in WeChat. Web QR/link is for browsers only — do not mix them. Opens and prints are logged.",
      "viewsOf": "Access log · {no}",
      "defaultTitle": "Payment receipt",
      "cash": "Cash",
      "wechat": "WeChat",
      "alipay": "Alipay",
      "transfer": "Bank transfer",
      "check": "Cheque",
      "other": "Other",
      "tierMember": "Members: 1000 by default while active",
      "tierExpired": "After membership ends: back to 50",
      "tierFree": "Free users: 30 by default",
      "needParties": "Please enter payee and payer",
      "confirmDel": "Delete receipt “{no}”?",
      "loadViewsFail": "Failed to load access log",
      "popup": "Allow pop-ups and try again"
    },
    quote: {
      "eyebrow": "Business quote · print & share",
      "title": "Quotation",
      "defaultTitle": "Quotation",
      "lead": "Fill in line items and terms, then print or share via H5 / mini program. Member-made quotes hide the footer credit by default.",
      "remain": "{n} remaining",
      "phSearch": "Search number / customer / seller / title",
      "newItem": "New quote",
      "verify": "Verify number",
      "empty": "No quotes yet — click New quote to start",
      "validUntilOf": "Valid until {d}",
      "dlgEdit": "Edit quote",
      "dlgNew": "New quote",
      "quoteNo": "Quote No.",
      "seller": "Seller",
      "phSeller": "Seller / quoting party",
      "customer": "Customer",
      "quoteDate": "Quote date",
      "validUntil": "Valid until",
      "currency": "Currency",
      "cny": "CNY",
      "usd": "USD",
      "eur": "EUR",
      "hkd": "HKD",
      "discount": "Discount",
      "tax": "Tax",
      "lines": "Line items",
      "linesTip": "Name, spec, qty and unit price — totals update automatically",
      "addRow": "Add row",
      "colName": "Item",
      "colSpec": "Spec",
      "colQty": "Qty",
      "colUnit": "Unit",
      "colPrice": "Price",
      "colAmt": "Amount",
      "phName": "Item / service",
      "phSpec": "Spec / model",
      "phUnit": "Unit",
      "gCommon": "Common",
      "gMeasure": "Measure",
      "gTime": "Time / count",
      "delRow": "Remove row",
      "subtotal": "Subtotal",
      "total": "Total",
      "terms": "Terms",
      "phTerms": "Payment, delivery, etc.",
      "address": "Address",
      "cornerTip": "The corner QR on print/share pages opens this quote again",
      "shareTitle": "Share quote",
      "shareTip": "Scan the mini-program code in WeChat. Web QR/link is for browsers only — do not mix them. Opens and prints are logged.",
      "viewsOf": "Access log · {no}",
      "keepOne": "Keep at least one line",
      "needParties": "Please enter seller and customer",
      "needLine": "Add at least one line item",
      "confirmDel": "Delete quote “{no}”?"
    },
    contract: {
      "eyebrow": "E-sign · print & share",
      "title": "E-contract",
      "lead": "Fill in both parties and terms. Choose whether signatures are required. Member-made contracts hide the footer credit by default.",
      "remain": "{n} remaining",
      "phSearch": "Search number / party A / party B / title",
      "newItem": "New contract",
      "empty": "No contracts yet — click New contract to start",
      "dlgEdit": "Edit contract",
      "dlgNew": "New contract",
      "contractTitle": "Title",
      "contractNo": "Contract No.",
      "partyA": "Party A",
      "phPartyA": "Party A name",
      "partyB": "Party B",
      "phPartyB": "Party B name",
      "partyAId": "Party A ID",
      "partyBId": "Party B ID",
      "phId": "ID card / unified social credit code",
      "partyAContact": "Party A contact",
      "partyBContact": "Party B contact",
      "signDate": "Sign date",
      "signPlace": "Sign place",
      "amount": "Contract amount",
      "amountCn": "Amount in words",
      "autoCn": "Auto-generated",
      "body": "Contract body",
      "phBody": "Write the contract. Tables, headings and lists are supported…",
      "bodyTip": "Insert tables from the toolbar. Complex layouts are easier on desktop.",
      "clauses": "Extra clauses",
      "clausesTip": "Optional title + body for listed terms",
      "addClause": "Add clause",
      "emptyClauses": "No clauses yet — skip or add one",
      "phClauseTitle": "Clause title",
      "phClauseBody": "Clause body",
      "classicDoc": "Classic document",
      "cornerTip": "The corner QR on print/share pages opens this contract again",
      "shareTitle": "Share e-contract",
      "shareTip": "Scan the mini-program code in WeChat to sign. Web QR/link is for browsers only — do not mix them.",
      "viewsOf": "Access log · {no}",
      "signs": "Signs",
      "defaultTitle": "E-contract",
      "tierMember": "Members: 1000 by default while active",
      "tierExpired": "After membership ends: back to 20",
      "tierFree": "Free users: 10 by default",
      "noImg": "Use tables and text in the body; for images, try Live QR",
      "stPending": "Pending signature",
      "stPartial": "Partially signed",
      "stDone": "Completed",
      "stNoSign": "No signature",
      "colGps": "GPS",
      "openMap": "Open map",
      "copyCoords": "Copy coords",
      "coordsCopied": "Coordinates copied",
      "noGps": "No valid coordinates for this visit",
      "mapCoordTip": "Coordinates are normalized for China maps (GCJ-02 for Amap/Tencent; WGS-84 for OSM/Google). DevTools mock location is often inaccurate — test on a real device.",
      "visitLoc": "Visit location",
      "locOk": "Located",
      "locDenied": "Denied",
      "locUnavailable": "Unavailable",
      "locTimeout": "Timeout",
      "locError": "Error",
      "locUnsupported": "Unsupported",
      "signMode": "Signing",
      "locCollect": "Visitor location",
      "locCollectOn": "Collect location",
      "locCollectOff": "Do not collect",
      "locCollectOnTip": "Ask for location when the share page opens",
      "locCollectOffTip": "Skip geolocation for better privacy",
      "locGateTitle": "Location required",
      "locGateDesc": "This contract requires location access. Please allow location permission to view the content.",
      "locGateBtn": "Allow location to continue",
      "locGateRetry": "Try again",
      "locGateRetryAfterAllow": "I've allowed it — continue",
      "locGateSettings": "Open settings",
      "locGateHowTo": "How to enable location",
      "locGateHowToHide": "Hide steps",
      "locGateLocating": "Getting location…",
      "locGateHint": "Location is only used to record this visit.",
      "locGateDeniedToast": "Location was denied, so the browser won't prompt again. Follow the steps below, then tap Continue.",
      "locGateStep1": "Tap the lock / info icon in the address bar (in WeChat: ··· → Settings)",
      "locGateStep2": "Set Location to Allow",
      "locGateStep3": "Return here and tap “I've allowed it — continue”",
      "locAskTitle": "Location permission",
      "locAskDesc": "This contract records visit location. Please allow access to continue.",
      "locAskAllow": "Allow location",
      "locAskDeny": "Deny",
      "locGuideTitle": "Location permission needed",
      "locGuideDesc": "This contract collects visit location. Tap the button below to allow access.",
      "locGuideAllow": "Allow location",
      "locGuideRetry": "Try again",
      "locGuideLater": "Not now",
      "locGuideBrowser": "If no system prompt appears, open the site settings in the address bar and allow Location, then retry.",
      "locGuideDenied": "Location was denied. The browser will not show the prompt again — enable it in site settings first.",
      "locGuideLocating": "Getting location…",
      "locGuideDone": "Location saved",
      "locGuideUnsupported": "This browser cannot access location. Use Chrome / Edge / Safari over HTTPS.",
      "signRequired": "Require signatures",
      "signRequiredTip": "Parties can hand-sign after sharing; signature boxes appear at the bottom",
      "signOptional": "No signature needed",
      "signOptionalTip": "View and print only — no signature area and signing is disabled",
      "noSignNeeded": "No signature required",
      "noSignHint": "This contract is for viewing and filing only; handwritten signatures are not required.",
      "viewOnlyTip": "This contract does not require signatures. You can view or export it.",
      "needParties": "Please enter Party A and Party B",
      "needBody": "Please enter the contract body (tables allowed)",
      "confirmDel": "Delete contract “{no}”?"
    },
    card: {
      "eyebrow": "Templates · shareable",
      "title": "Business card",
      "lead": "Fill in details, pick a template, and share via H5 or mini program. Call, WeChat, maps, and image export included.",
      "quota": "Creation quota",
      "remain": "{n} left",
      "editCard": "Edit card",
      "newCard": "New card",
      "cancelEdit": "Cancel edit",
      "cardTitle": "Card title",
      "phTitle": "e.g. Alex’s card",
      "themeColor": "Theme color",
      "name": "Name",
      "required": "Required",
      "jobTitle": "Title",
      "phJob": "e.g. Product manager",
      "company": "Company / org",
      "mobile": "Mobile",
      "phone": "Phone",
      "email": "Email",
      "wechat": "WeChat ID",
      "website": "Website",
      "intro": "Bio",
      "phIntro": "One-line intro",
      "avatar": "Avatar",
      "notUploaded": "Not uploaded",
      "clear": "Clear",
      "wechatQr": "WeChat QR",
      "qrUploadHint": "Upload a photo to decode and redraw",
      "regenQr": "Generate / redraw",
      "qrFieldHint": "Upload your WeChat “My QR code” image; we decode and redraw it. If decode fails you can keep the original.",
      "address": "Address",
      "phAddress": "Address text for display",
      "mapLoc": "Map location",
      "altPicked": "Selected location",
      "pickOnMap": "Pick an office or store on the map",
      "located": "Located",
      "pickedPoint": "Selected point",
      "noLocYet": "No location yet",
      "mapUnavailable": "Unavailable",
      "mapPickHint": "Search, tap a point, then confirm",
      "needMapKey": "Ask an admin to configure Tencent or Amap key",
      "rePick": "Pick again",
      "pickMap": "Pick on map",
      "coordTip": "Visitors see a map preview and can open Amap / Tencent Maps for navigation.",
      "quickActions": "Quick actions",
      "actCall": "Call",
      "actSms": "SMS",
      "actWechat": "WeChat",
      "actMap": "Navigate",
      "actEmail": "Email",
      "actCopy": "Copy info",
      "actWebsite": "Website",
      "saveEdit": "Save changes",
      "createCard": "Create card",
      "livePreview": "Live preview",
      "myCards": "My cards ({n})",
      "empty": "No cards yet — create one on the left",
      "viewsMeta": "· {n} views · {t}",
      "pendingTip": "Public sharing unlocks after review",
      "bannedTip": "Banned by admin — cannot share",
      "shareOn": "On",
      "shareOff": "Off",
      "share": "Share",
      "edit": "Edit",
      "exportImg": "Export image",
      "delete": "Delete",
      "altMiniQr": "Mini-program code",
      "scanOpen": "Scan with WeChat to open",
      "h5Link": "H5 link",
      "copy": "Copy",
      "shareText": "Share text",
      "openH5": "Open H5",
      "exportImage": "Export image",
      "dlMiniQr": "Download mini code",
      "tierAdmin": "Custom quota set by admin",
      "tierMember": "Member quota",
      "tierExpired": "Post-membership quota",
      "tierFree": "Default free quota",
      "shareOf": "Share “{name}”",
      "shareCard": "Share card",
      "uploadOk": "Uploaded",
      "uploadFail": "Upload failed",
      "qrRedrawOk": "WeChat QR decoded and redrawn",
      "qrDecodeFailMsg": "Could not read the code (official WeChat images often include avatars). Keep the original, or crop a clearer QR area and try again.",
      "qrDecodeFailTitle": "Decode failed",
      "keepOriginal": "Keep original",
      "cancel": "Cancel",
      "keptOriginal": "Original uploaded (not redrawn)",
      "processFail": "Processing failed",
      "needWechatSource": "Upload a readable WeChat QR or enter a WeChat ID first",
      "qrGenOk": "QR generated",
      "genFail": "Generation failed",
      "noMapKey": "Map key not configured",
      "locConfirmed": "Location confirmed",
      "needName": "Please enter a name",
      "saved": "Saved",
      "created": "Card created",
      "shareOpened": "Sharing enabled",
      "shareClosed": "Sharing disabled",
      "confirmDel": "Delete “{name}”?",
      "delTitle": "Delete card",
      "deleted": "Deleted",
      "miniQrFallback": "Mini-program code unavailable — copy the H5 link for now",
      "copied": "Copied",
      "linkCopied": "Link copied",
      "textCopied": "Text copied",
      "copyFail": "Copy failed",
      "noPhone": "No phone number",
      "noMobile": "No mobile number",
      "noEmail": "No email",
      "noWebsite": "No website",
      "wechatCopied": "WeChat ID copied",
      "scanWechat": "Scan to add on WeChat",
      "noWechat": "No WeChat ID",
      "wechatLine": "WeChat {id}",
      "infoCopied": "Card info copied",
      "noAddress": "No address set",
      "destination": "Destination",
      "exportBrand": "Qing Ping Guo · Business card",
      "exportOk": "Image exported"
    },
    comment: {
      "eyebrow": "Teachers · AI comments",
      "title": "Student comments",
      "lead": "Import a class, tag each student, and generate final / midterm / term comments. Spreadsheet import and parent share links included.",
      "desc": "Import students by class, tag them, generate AI comments, and share with parents.",
      "classQuota": "Class quota",
      "remainClasses": "{n} classes left",
      "perClass": "/ class",
      "studentCap": "Students per class",
      "aiBanner": "Zhipu API is not configured yet. You can still create classes, import students, and write comments manually.",
      "aiBannerShort": "Zhipu API is not ready — auto-generate is unavailable.",
      "newClass": "New class",
      "newClassTip": "Fill in class info, then import students",
      "className": "Class name",
      "phClassName": "e.g. Grade 3 Class 2",
      "school": "School",
      "phSchool": "Full school name",
      "grade": "Grade",
      "phGrade": "e.g. Grade 3",
      "location": "Classroom",
      "phLocation": "e.g. Building A, 3F east",
      "phLocationShort": "e.g. 3F east",
      "semester": "Semester",
      "phSemester": "e.g. 2025–2026 Semester 1",
      "commentDate": "Comment date",
      "phCommentDate": "Default for the class; change later if needed",
      "phCommentDateClass": "Class default; override per student",
      "commentType": "Comment type",
      "brandCredit": "Site credit",
      "hideBrand": "Hide credit on share page",
      "brandHint": "Free users show site credit on share pages; member-created classes do not.",
      "createClass": "Create class",
      "myClasses": "My classes",
      "emptyClasses": "No classes yet — create one above",
      "noPlace": "School / grade not set",
      "people": "{n} students",
      "commented": "{n} with comments",
      "enter": "Open",
      "delete": "Delete",
      "backList": "Back to classes",
      "previewPrompt": "Preview prompt",
      "exportExcel": "Export Excel",
      "batchGen": "Batch generate",
      "classSettings": "Class settings",
      "saveSettings": "Save settings",
      "extraReq": "Extra instructions",
      "phExtra": "Optional: more colloquial tone, encourage reading, etc.",
      "customTags": "Class custom tags",
      "phNewTag": "New tag",
      "add": "Add",
      "importStudents": "Import / add students",
      "importCap": "Up to {limit} per class · {n} now",
      "excelImport": "Spreadsheet import",
      "excelTip": "Download the template — one student per row. xlsx / csv.",
      "dlTemplate": "Download template",
      "uploadSheet": "Upload sheet",
      "phPasteNames": "Or paste names: one per line. Commas/semicolons OK; leading numbers are stripped.",
      "importNames": "Import names",
      "phOneName": "One name",
      "studentList": "Students",
      "phSearchName": "Search name",
      "genPending": "Generate pending ({n})",
      "overwriteAll": "Overwrite all",
      "batchProgress": "Done {done} / {total}",
      "batchFailed": " · {n} failed",
      "emptyStudents": "No students yet",
      "colName": "Name",
      "colGender": "Gender",
      "genderEmpty": "Unset",
      "genderMale": "Male",
      "genderFemale": "Female",
      "colTags": "Tags",
      "clickAdd": "Click to add",
      "colRemark": "Notes",
      "phRemark": "Classroom notes",
      "colDate": "Date",
      "phClassDate": "Class date",
      "colComment": "Comment",
      "notGenerated": "Not generated",
      "chars": "{n} chars",
      "colShare": "Share",
      "preview": "Preview",
      "copyLink": "Copy link",
      "colAction": "Actions",
      "rewrite": "Rewrite",
      "generate": "Generate",
      "prompt": "Prompt",
      "dlgTags": "Personality tags",
      "dlgTagsTip": "Multi-select, up to 20. Comments follow these tags and will not invent grades or events.",
      "dlgSelected": "Selected {n} / 20",
      "classCustom": "Class custom",
      "cancel": "Cancel",
      "saveTags": "Save tags",
      "dlgPrompt": "AI prompt preview",
      "typeFinal": "Final",
      "typeMid": "Midterm",
      "typeTerm": "Term",
      "typeDaily": "Daily",
      "quotaAdmin": "Custom quota set by admin",
      "quotaMember": "Member tier",
      "quotaFree": "Free tier · site default",
      "studentAdmin": "Per-class limit set by admin",
      "studentMember": "Members can import more students",
      "studentFree": "Free-tier per-class limit",
      "memberOk": "Membership active",
      "memberUpsell": "Upgrade to raise class and student limits",
      "needClassName": "Please enter a class name",
      "classCreated": "Class created",
      "createFail": "Create failed",
      "openFail": "Open failed",
      "saved": "Saved",
      "tagExists": "Tag already exists",
      "tagLimit": "Up to {n} custom tags",
      "addFail": "Add failed",
      "imported": "Imported {n}",
      "skipped": ", skipped {n} (limit reached)",
      "importFail": "Import failed",
      "tplDownloaded": "Template downloaded — one student per row",
      "tplFail": "Template download failed",
      "readFail": "Failed to read file",
      "noNamesInSheet": "No names found in the sheet",
      "sheetFail": "Sheet import failed",
      "added": "Added",
      "tagsSaved": "Tags saved",
      "overwriteConfirm": "“{name}” already has a comment. Overwrite?",
      "overwriteTitle": "Overwrite comment",
      "generated": "Generated",
      "genFail": "Generation failed",
      "noStudents": "No students",
      "noPending": "No students without comments",
      "batchOverwriteConfirm": "Overwrite comments for {n} students?",
      "batchOverwriteTitle": "Batch overwrite",
      "batchDone": "Batch finished: {n}",
      "batchFailPart": ", {n} failed",
      "batchFail": "Batch generate failed",
      "needStudents": "Add students first",
      "previewFail": "Preview failed",
      "exported": "Excel exported",
      "exportFail": "Export failed",
      "noShare": "No share link yet",
      "enableShareFirst": "Enable sharing for this student first",
      "shareCopied": "Share link copied",
      "copied": "Copied",
      "delStudentConfirm": "Delete student “{name}” and their comment?",
      "delTitle": "Delete",
      "deleted": "Deleted",
      "delClassConfirm": "Delete class “{name}” and all student comments? This cannot be undone.",
      "delClassTitle": "Delete class"
    },
  },
  about: {
    browseArticles: 'Browse articles',
    contactMe: 'Contact',
    role: 'Frontend developer · technical writer',
    bio1: 'A frontend developer focused on web engineering and UX. This blog is where I share notes, ideas, software picks, and project experience.',
    bio2: 'I aim to explain complex topics clearly and share useful tools so every visit is worthwhile.',
    online: 'Creating online',
    focusEyebrow: 'FOCUS',
    focusTitle: 'What I work on',
    focusSub: 'Write to capture experience; share to connect with more developers',
    focusWrite: 'Technical writing',
    focusWriteDesc: 'Frontend practice, engineering, and performance — explained clearly.',
    focusTools: 'Tool recommendations',
    focusToolsDesc: 'Curated apps and utilities that speed up daily work and learning.',
    focusTutorial: 'Hands-on tutorials',
    focusTutorialDesc: 'Project-based guides from beginner to advanced.',
    contentEyebrow: 'CONTENT',
    contentTitle: 'What you will find',
    contentSub: 'Four pillars covering beginner to advanced learning paths',
    techDesc: 'Frontend, performance, and engineering practice',
    softwareDesc: 'Utilities, office, and developer productivity apps',
    tutorialDesc: 'Structured learning from basics to advanced',
    resourceDesc: 'Learning materials, open source, and books',
    statArticles: 'Articles',
    statTech: 'Tech',
    statSoftware: 'Software',
    statTutorialResource: 'Tutorials & resources',
    techGroupFront: 'Frameworks',
    techGroupLang: 'Languages & styles',
    techGroupEng: 'Engineering',
    techGroupOther: 'Other',
    tagEng: 'Engineering',
    tagUx: 'UX',
    articleCount: '{n} articles',
    stackTitle: 'Stack',
    stackSub: 'Tools and frameworks used in daily work and writing',
    ctaTitle: 'Let’s talk',
    ctaDesc: 'Email is welcome for technical questions, collaboration, or content ideas. Thanks for supporting the site.',
    sponsorSupport: 'Support the site'
  },
  sponsor: {
    badge: 'Membership',
    title: 'Support {name} and unlock more content',
    desc: 'Your support helps keep tutorials, software picks, and tech articles coming. Choose how to start or renew.',
    memberUntil: 'Membership active until',
    renewNote: 'Renewals extend from the current expiry date',
    plansRenew: 'Renewal plans',
    plansBuy: 'Membership plans',
    plansDirectTip: 'Pick a plan and pay — membership activates automatically after payment',
    plansExternalTip: 'Buy on the card platform, then return here to redeem a CDK',
    plansIntroTip: 'Plan overview — activate with a redeem code after purchase',
    originalPrice: 'Was ¥{price}',
    unitPrice: 'About {unit}',
    renew: 'Renew',
    sponsorNow: 'Sponsor now',
    payNow: 'Pay with Alipay',
    payRenew: 'Renew with Alipay',
    alipayTitle: 'Secure Alipay checkout',
    alipayTip: 'Membership activates automatically after payment. Check orders in your profile.',
    payDialogTitle: 'Alipay payment',
    payCreating: 'Creating payment order…',
    payWaiting: 'Complete payment in the Alipay window. This page will confirm automatically.',
    payPolling: 'Waiting for payment — please keep this page open',
    scanAlipay: 'Scan with Alipay to pay',
    openAlipayPage: 'Open Alipay checkout',
    reopenPay: 'Reopen Alipay',
    retryPay: 'Try again',
    payNoForm: 'Failed to build the payment form. Please retry or contact the admin.',
    paySuccess: 'Payment successful — membership activated',
    paySuccessUntil: 'Payment successful — active until {date}',
    payFailed: 'Payment was not completed or was cancelled',
    payTimeout: 'Timed out waiting. If you already paid, refresh or check orders in your profile.',
    payNotReady: 'Alipay is not configured yet. Please try later or contact the admin.',
    payDone: 'Done',
    close: 'Close',
    confirmPay: 'Pay with Alipay',
    goBuy: 'Buy now',
    onlineBuy: 'Buy membership online',
    empty: 'Membership purchase is not available yet. Please contact the admin.',
    faqTitle: 'FAQ',
    faq1q: 'What do I get as a member?',
    faq1a: 'Read all “members only” articles and sections site-wide, and view sponsorship orders in your profile.',
    faq2q: 'How is renewal calculated?',
    faq2a: 'If your membership is still active, the new plan extends from the current expiry. If it has expired, it starts from the activation date.',
    faq3q: 'How do I use a CDK code?',
    faq3a: 'Buy a plan on the card shop, sign in here, enter the code above, and redeem to activate the matching duration.',
    faq4q: 'How do I activate after purchase?',
    faq4a: 'After buying on the card shop, return here and enter the CDK code to activate membership.',
    faqPayQ: 'Is Alipay safe? How does activation work?',
    faqPayA: 'You pay on Alipay’s official checkout. After success, membership is activated or renewed within a few seconds.',
    cdkReturnHint: 'After purchase, return here and enter the code to activate',
    confirmRenew: 'renew',
    confirmSponsor: 'sponsor',
    confirmTitle: '{action} membership',
    confirmMsg: 'Confirm {action} “{name}”? (¥{price}, {duration})',
    confirmOk: 'Confirm {action}',
    cancel: 'Cancel'
  },
  profile: {
    member: 'Member',
    normalUser: 'Regular user',
    joinedAt: 'Joined {date}',
    memberUntil: 'Member until {date}',
    changeAvatar: 'Change avatar',
    admin: 'Admin',
    renew: 'Renew',
    openSponsor: 'Become a member',
    history: 'History',
    orders: 'Orders',
    unlocked: 'Unlocked',
    sideLabel: 'Account',
    navAria: 'Profile navigation',
    tabInfo: 'Profile',
    tabInfoShort: 'Profile',
    tabSecurity: 'Security',
    tabSecurityShort: 'Security',
    tabHistory: 'History',
    tabHistoryShort: 'History',
    tabPoints: 'Points',
    tabPointsShort: 'Points',
    tabMember: 'Membership',
    tabMemberShort: 'Member',
    tabOrders: 'Orders',
    tabOrdersShort: 'Orders',
    guestTitle: 'Sign in to manage your account',
    guestDesc: 'Sync history, check-ins, membership, and orders',
    loginNow: 'Sign in'
  },
  copyright: {
    backHome: 'Back to home',
    title: 'Copyright notice',
    desc: 'Welcome to “{name}”. Please read the terms below. By using this site you agree to this notice.',
    updated: 'Last updated: Mar 10, 2026',
    effective: 'Effective: Jan 1, 2026',
    toc: 'Contents',
    contactPrefix: 'Questions about this notice? Email',
    contactSuffix: 'and we will reply within a reasonable time.',
    enNotice: 'The English version is for reference only. If it conflicts with the Chinese text, the Chinese version prevails.'
  },
  redirect: {
    back: 'Go back',
    leaving: 'You are leaving this site',
    invalid: 'Invalid link',
    leavingDesc: 'You are about to open a third-party site. Please confirm the destination first.',
    invalidDesc: 'This link could not be parsed. Check that the address is correct.',
    targetSite: 'Destination',
    copy: 'Copy',
    copied: 'Copied',
    linkName: 'Link title',
    fromArticle: 'From article',
    safety: 'Safety tips',
    tip1: 'Third-party content, privacy, and security are the responsibility of that site.',
    tip2: 'Do not enter passwords or payment details on unfamiliar pages.',
    tip3: 'If a page looks suspicious, close it and return here.',
    cancel: 'Cancel',
    confirm: 'Continue',
    countdown: 'After you confirm, the link opens in a new tab; this page stays open',
    invalidReason: 'Possible causes: bad URL format, unsupported protocol, or missing redirect parameter.',
    backHome: 'Back to home',
    footerTip: '{name} shows this warning before external links to help keep browsing safer'
  },
  common: {
    langSwitched: 'Language updated',
    tip: 'Notice',
    backTop: 'Back to top',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    reply: 'Reply'
  },
  comments: {
    title: 'Comments',
    approvalTip: 'Comments are reviewed before public display. Your pending ones are marked “Pending”.',
    placeholder: 'Share your thoughts — images and links are supported…',
    submit: 'Post comment',
    loading: 'Loading comments…',
    empty: 'No comments yet — be the first',
    pending: 'Pending',
    hidden: 'Hidden',
    replyTo: 'Reply',
    editPh: 'Edit comment…',
    replyPh: 'Reply to @{name}…',
    submitReply: 'Post reply',
    loadFailed: 'Failed to load comments',
    pickImage: 'Please choose an image',
    imageInserted: 'Image inserted',
    uploadFailed: 'Image upload failed',
    needContent: 'Please enter a comment',
    needReply: 'Please enter a reply',
    posted: 'Comment posted',
    postFailed: 'Failed to post',
    replied: 'Reply posted',
    replyFailed: 'Failed to reply',
    emptyContent: 'Comment cannot be empty',
    updated: 'Comment updated',
    updateFailed: 'Update failed',
    deleteConfirm: 'Delete this comment?',
    deleted: 'Comment deleted',
    deleteFailed: 'Delete failed'
  },
  auth: {
    login: 'Sign in',
    logout: 'Sign out',
    loggedOut: 'Signed out',
    register: 'Sign up',
    createAccount: 'Create account',
    welcomeBack: 'Welcome back',
    joinUs: 'Join us',
    forgotTitle: 'Reset password',
    welcomeDesc: 'Sign in to continue reading',
    registerDesc: 'Create an account to unlock more',
    qrDesc: 'Scan with WeChat for a quick, secure sign-in',
    qrPending: 'Scan the code with WeChat to confirm on the mini program',
    qrPendingMobile: 'On the same phone, open the mini program and enter the code below',
    qrShortLabel: 'Web login code',
    qrShortTip: 'Open the mini program → Me → Web login, then enter this code',
    openMiniLogin: 'Open mini program to confirm',
    openMiniTip: 'Jump to WeChat mini program to confirm. If it fails, use the code instead',
    openMiniFail: 'Could not open the mini program. Please use the code',
    samePhoneTip: 'Cannot scan this screen? Open the mini program → Me → Web login, and enter the 6-digit code',
    forgotDesc1: 'Verify your registered email to reset the password',
    forgotDesc2: 'Set a new password, then sign in again',
    featCollect: 'Save articles you like',
    featHistory: 'Sync reading history',
    featPersonal: 'A more personal reading experience',
    featEmail: 'Email verification keeps the account safer',
    featCode: 'Codes expire in 10 minutes',
    featReset: 'Sign in right after a reset',
    passwordLogin: 'Password',
    qrLogin: 'Mini-program QR',
    account: 'Account',
    accountPh: 'Username or email',
    password: 'Password',
    passwordPh: 'Enter password',
    forgot: 'Forgot password?',
    noAccount: 'No account yet?',
    registerNow: 'Create one',
    hasAccount: 'Already have an account?',
    loginNow: 'Sign in',
    backLogin: 'Back to sign in',
    username: 'Username',
    usernamePh: 'More than 5 characters',
    email: 'Email',
    emailCode: 'Email code',
    codePh: '6-digit code',
    getCode: 'Get code',
    resendIn: 'Resend in {n}s',
    resend: 'Resend',
    passwordRule: 'More than 8 characters',
    confirmPassword: 'Confirm password',
    confirmPh: 'Enter password again',
    forgotHint1: 'Enter your registered email to get a code',
    forgotHint2: 'Set a new password',
    registeredEmail: 'Registered email',
    registeredEmailPh: 'The email you used to register',
    sendCode: 'Send code',
    code: 'Code',
    newPassword: 'New password',
    newPasswordPh: 'At least 6 characters',
    qrAlt: 'Scan to sign in',
    qrLoading: 'Loading QR…',
    qrExpired: 'Expired — tap to refresh',
    qrRefresh: 'Refresh QR',
    qrExpiredHint: 'QR expired. Please refresh',
    qrCancelled: 'Cancelled. Refresh to try again',
    qrError: 'QR failed to load',
    qrIdle: 'Choose mini-program QR sign-in',
    rememberPassword: 'Remembered it?',
    resetPassword: 'Reset password',
    confirmNewPassword: 'Confirm new password',
    confirmNewPh: 'Enter the new password again'
  },
  user: {
    menu: 'Account menu',
    member: 'Member',
    normal: 'Regular user',
    expireUntil: 'Active until {date}',
    openHint: 'Become a member to unlock more content',
    checkin: 'Check in',
    checkinDaily: 'Daily check-in',
    checkedIn: 'Done',
    checkedInToday: 'Checked in today',
    checkinReward: 'Earn +{n} {name}',
    profile: 'Profile',
    myPoints: 'Points',
    history: 'History',
    recent: 'Recently viewed',
    viewAll: 'See all',
    noHistory: 'No reading history yet',
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago',
    streak: '{n}-day streak'
  }
}
